/*! pako 2.1.0 https://github.com/nodeca/pako @license (MIT AND Zlib) */ // (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
/* eslint-disable space-unary-ops */ /* Public constants ==========================================================*/ /* ===========================================================================*/ //const Z_FILTERED          = 1;
//const Z_HUFFMAN_ONLY      = 2;
//const Z_RLE               = 3;
const $b8ea597934691048$var$Z_FIXED$1 = 4;
//const Z_DEFAULT_STRATEGY  = 0;
/* Possible values of the data_type field (though see inflate()) */ const $b8ea597934691048$var$Z_BINARY = 0;
const $b8ea597934691048$var$Z_TEXT = 1;
//const Z_ASCII             = 1; // = Z_TEXT
const $b8ea597934691048$var$Z_UNKNOWN$1 = 2;
/*============================================================================*/ function $b8ea597934691048$var$zero$1(buf) {
    let len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
// From zutil.h
const $b8ea597934691048$var$STORED_BLOCK = 0;
const $b8ea597934691048$var$STATIC_TREES = 1;
const $b8ea597934691048$var$DYN_TREES = 2;
/* The three kinds of block type */ const $b8ea597934691048$var$MIN_MATCH$1 = 3;
const $b8ea597934691048$var$MAX_MATCH$1 = 258;
/* The minimum and maximum match lengths */ // From deflate.h
/* ===========================================================================
 * Internal compression state.
 */ const $b8ea597934691048$var$LENGTH_CODES$1 = 29;
/* number of length codes, not counting the special END_BLOCK code */ const $b8ea597934691048$var$LITERALS$1 = 256;
/* number of literal bytes 0..255 */ const $b8ea597934691048$var$L_CODES$1 = $b8ea597934691048$var$LITERALS$1 + 1 + $b8ea597934691048$var$LENGTH_CODES$1;
/* number of Literal or Length codes, including the END_BLOCK code */ const $b8ea597934691048$var$D_CODES$1 = 30;
/* number of distance codes */ const $b8ea597934691048$var$BL_CODES$1 = 19;
/* number of codes used to transfer the bit lengths */ const $b8ea597934691048$var$HEAP_SIZE$1 = 2 * $b8ea597934691048$var$L_CODES$1 + 1;
/* maximum heap size */ const $b8ea597934691048$var$MAX_BITS$1 = 15;
/* All codes must not exceed MAX_BITS bits */ const $b8ea597934691048$var$Buf_size = 16;
/* size of bit buffer in bi_buf */ /* ===========================================================================
 * Constants
 */ const $b8ea597934691048$var$MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */ const $b8ea597934691048$var$END_BLOCK = 256;
/* end of block literal code */ const $b8ea597934691048$var$REP_3_6 = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */ const $b8ea597934691048$var$REPZ_3_10 = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */ const $b8ea597934691048$var$REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */ /* eslint-disable comma-spacing,array-bracket-spacing */ const $b8ea597934691048$var$extra_lbits = /* extra bits for each length code */ new Uint8Array([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0
]);
const $b8ea597934691048$var$extra_dbits = /* extra bits for each distance code */ new Uint8Array([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13
]);
const $b8ea597934691048$var$extra_blbits = /* extra bits for each bit length code */ new Uint8Array([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    7
]);
const $b8ea597934691048$var$bl_order = new Uint8Array([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
/* eslint-enable comma-spacing,array-bracket-spacing */ /* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */ /* ===========================================================================
 * Local data. These are initialized only once.
 */ // We pre-fill arrays with 0 to avoid uninitialized gaps
const $b8ea597934691048$var$DIST_CODE_LEN = 512; /* see definition of array dist_code below */ 
// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
const $b8ea597934691048$var$static_ltree = new Array(($b8ea597934691048$var$L_CODES$1 + 2) * 2);
$b8ea597934691048$var$zero$1($b8ea597934691048$var$static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */ const $b8ea597934691048$var$static_dtree = new Array($b8ea597934691048$var$D_CODES$1 * 2);
$b8ea597934691048$var$zero$1($b8ea597934691048$var$static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */ const $b8ea597934691048$var$_dist_code = new Array($b8ea597934691048$var$DIST_CODE_LEN);
$b8ea597934691048$var$zero$1($b8ea597934691048$var$_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */ const $b8ea597934691048$var$_length_code = new Array($b8ea597934691048$var$MAX_MATCH$1 - $b8ea597934691048$var$MIN_MATCH$1 + 1);
$b8ea597934691048$var$zero$1($b8ea597934691048$var$_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */ const $b8ea597934691048$var$base_length = new Array($b8ea597934691048$var$LENGTH_CODES$1);
$b8ea597934691048$var$zero$1($b8ea597934691048$var$base_length);
/* First normalized length for each code (0 = MIN_MATCH) */ const $b8ea597934691048$var$base_dist = new Array($b8ea597934691048$var$D_CODES$1);
$b8ea597934691048$var$zero$1($b8ea597934691048$var$base_dist);
/* First normalized distance for each code (0 = distance of 1) */ function $b8ea597934691048$var$StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
    this.static_tree = static_tree; /* static tree or NULL */ 
    this.extra_bits = extra_bits; /* extra bits for each code or NULL */ 
    this.extra_base = extra_base; /* base index for extra_bits */ 
    this.elems = elems; /* max number of elements in the tree */ 
    this.max_length = max_length; /* max bit length for the codes */ 
    // show if `static_tree` has data or dummy - needed for monomorphic objects
    this.has_stree = static_tree && static_tree.length;
}
let $b8ea597934691048$var$static_l_desc;
let $b8ea597934691048$var$static_d_desc;
let $b8ea597934691048$var$static_bl_desc;
function $b8ea597934691048$var$TreeDesc(dyn_tree, stat_desc) {
    this.dyn_tree = dyn_tree; /* the dynamic tree */ 
    this.max_code = 0; /* largest code with non zero frequency */ 
    this.stat_desc = stat_desc; /* the corresponding static tree */ 
}
const $b8ea597934691048$var$d_code = (dist)=>{
    return dist < 256 ? $b8ea597934691048$var$_dist_code[dist] : $b8ea597934691048$var$_dist_code[256 + (dist >>> 7)];
};
/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */ const $b8ea597934691048$var$put_short = (s, w)=>{
    //    put_byte(s, (uch)((w) & 0xff));
    //    put_byte(s, (uch)((ush)(w) >> 8));
    s.pending_buf[s.pending++] = w & 0xff;
    s.pending_buf[s.pending++] = w >>> 8 & 0xff;
};
/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */ const $b8ea597934691048$var$send_bits = (s, value, length)=>{
    if (s.bi_valid > $b8ea597934691048$var$Buf_size - length) {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        $b8ea597934691048$var$put_short(s, s.bi_buf);
        s.bi_buf = value >> $b8ea597934691048$var$Buf_size - s.bi_valid;
        s.bi_valid += length - $b8ea597934691048$var$Buf_size;
    } else {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        s.bi_valid += length;
    }
};
const $b8ea597934691048$var$send_code = (s, c, tree)=>{
    $b8ea597934691048$var$send_bits(s, tree[c * 2], tree[c * 2 + 1]);
};
/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */ const $b8ea597934691048$var$bi_reverse = (code, len)=>{
    let res = 0;
    do {
        res |= code & 1;
        code >>>= 1;
        res <<= 1;
    }while (--len > 0);
    return res >>> 1;
};
/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */ const $b8ea597934691048$var$bi_flush = (s)=>{
    if (s.bi_valid === 16) {
        $b8ea597934691048$var$put_short(s, s.bi_buf);
        s.bi_buf = 0;
        s.bi_valid = 0;
    } else if (s.bi_valid >= 8) {
        s.pending_buf[s.pending++] = s.bi_buf & 0xff;
        s.bi_buf >>= 8;
        s.bi_valid -= 8;
    }
};
/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */ const $b8ea597934691048$var$gen_bitlen = (s, desc)=>{
    //    deflate_state *s;
    //    tree_desc *desc;    /* the tree descriptor */
    const tree = desc.dyn_tree;
    const max_code = desc.max_code;
    const stree = desc.stat_desc.static_tree;
    const has_stree = desc.stat_desc.has_stree;
    const extra = desc.stat_desc.extra_bits;
    const base = desc.stat_desc.extra_base;
    const max_length = desc.stat_desc.max_length;
    let h; /* heap index */ 
    let n, m; /* iterate over the tree elements */ 
    let bits; /* bit length */ 
    let xbits; /* extra bits */ 
    let f; /* frequency */ 
    let overflow = 0; /* number of elements with bit length too large */ 
    for(bits = 0; bits <= $b8ea597934691048$var$MAX_BITS$1; bits++)s.bl_count[bits] = 0;
    /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */ tree[s.heap[s.heap_max] * 2 + 1] = 0; /* root of the heap */ 
    for(h = s.heap_max + 1; h < $b8ea597934691048$var$HEAP_SIZE$1; h++){
        n = s.heap[h];
        bits = tree[tree[n * 2 + 1] * 2 + 1] + 1;
        if (bits > max_length) {
            bits = max_length;
            overflow++;
        }
        tree[n * 2 + 1] = bits;
        /* We overwrite tree[n].Dad which is no longer needed */ if (n > max_code) continue;
         /* not a leaf node */ 
        s.bl_count[bits]++;
        xbits = 0;
        if (n >= base) xbits = extra[n - base];
        f = tree[n * 2] /*.Freq*/ ;
        s.opt_len += f * (bits + xbits);
        if (has_stree) s.static_len += f * (stree[n * 2 + 1] + xbits);
    }
    if (overflow === 0) return;
    // Tracev((stderr,"\nbit length overflow\n"));
    /* This happens for example on obj2 and pic of the Calgary corpus */ /* Find the first bit length which could increase: */ do {
        bits = max_length - 1;
        while(s.bl_count[bits] === 0)bits--;
        s.bl_count[bits]--; /* move one leaf down the tree */ 
        s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */ 
        s.bl_count[max_length]--;
        /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */ overflow -= 2;
    }while (overflow > 0);
    /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */ for(bits = max_length; bits !== 0; bits--){
        n = s.bl_count[bits];
        while(n !== 0){
            m = s.heap[--h];
            if (m > max_code) continue;
            if (tree[m * 2 + 1] !== bits) {
                // Tracev((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
                s.opt_len += (bits - tree[m * 2 + 1]) * tree[m * 2] /*.Freq*/ ;
                tree[m * 2 + 1] = bits;
            }
            n--;
        }
    }
};
/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */ const $b8ea597934691048$var$gen_codes = (tree, max_code, bl_count)=>{
    //    ct_data *tree;             /* the tree to decorate */
    //    int max_code;              /* largest code with non zero frequency */
    //    ushf *bl_count;            /* number of codes at each bit length */
    const next_code = new Array($b8ea597934691048$var$MAX_BITS$1 + 1); /* next code value for each bit length */ 
    let code = 0; /* running code value */ 
    let bits; /* bit index */ 
    let n; /* code index */ 
    /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */ for(bits = 1; bits <= $b8ea597934691048$var$MAX_BITS$1; bits++){
        code = code + bl_count[bits - 1] << 1;
        next_code[bits] = code;
    }
    /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */ //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
    //        "inconsistent bit counts");
    //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
    for(n = 0; n <= max_code; n++){
        let len = tree[n * 2 + 1] /*.Len*/ ;
        if (len === 0) continue;
        /* Now reverse the bits */ tree[n * 2] = $b8ea597934691048$var$bi_reverse(next_code[len]++, len);
    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
    }
};
/* ===========================================================================
 * Initialize the various 'constant' tables.
 */ const $b8ea597934691048$var$tr_static_init = ()=>{
    let n; /* iterates over tree elements */ 
    let bits; /* bit counter */ 
    let length; /* length value */ 
    let code; /* code value */ 
    let dist; /* distance index */ 
    const bl_count = new Array($b8ea597934691048$var$MAX_BITS$1 + 1);
    /* number of codes at each bit length for an optimal tree */ // do check in _tr_init()
    //if (static_init_done) return;
    /* For some embedded targets, global variables are not initialized: */ /*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/ /* Initialize the mapping length (0..255) -> length code (0..28) */ length = 0;
    for(code = 0; code < $b8ea597934691048$var$LENGTH_CODES$1 - 1; code++){
        $b8ea597934691048$var$base_length[code] = length;
        for(n = 0; n < 1 << $b8ea597934691048$var$extra_lbits[code]; n++)$b8ea597934691048$var$_length_code[length++] = code;
    }
    //Assert (length == 256, "tr_static_init: length != 256");
    /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */ $b8ea597934691048$var$_length_code[length - 1] = code;
    /* Initialize the mapping dist (0..32K) -> dist code (0..29) */ dist = 0;
    for(code = 0; code < 16; code++){
        $b8ea597934691048$var$base_dist[code] = dist;
        for(n = 0; n < 1 << $b8ea597934691048$var$extra_dbits[code]; n++)$b8ea597934691048$var$_dist_code[dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: dist != 256");
    dist >>= 7; /* from now on, all distances are divided by 128 */ 
    for(; code < $b8ea597934691048$var$D_CODES$1; code++){
        $b8ea597934691048$var$base_dist[code] = dist << 7;
        for(n = 0; n < 1 << $b8ea597934691048$var$extra_dbits[code] - 7; n++)$b8ea597934691048$var$_dist_code[256 + dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: 256+dist != 512");
    /* Construct the codes of the static literal tree */ for(bits = 0; bits <= $b8ea597934691048$var$MAX_BITS$1; bits++)bl_count[bits] = 0;
    n = 0;
    while(n <= 143){
        $b8ea597934691048$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    while(n <= 255){
        $b8ea597934691048$var$static_ltree[n * 2 + 1] = 9;
        n++;
        bl_count[9]++;
    }
    while(n <= 279){
        $b8ea597934691048$var$static_ltree[n * 2 + 1] = 7;
        n++;
        bl_count[7]++;
    }
    while(n <= 287){
        $b8ea597934691048$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */ $b8ea597934691048$var$gen_codes($b8ea597934691048$var$static_ltree, $b8ea597934691048$var$L_CODES$1 + 1, bl_count);
    /* The static distance tree is trivial: */ for(n = 0; n < $b8ea597934691048$var$D_CODES$1; n++){
        $b8ea597934691048$var$static_dtree[n * 2 + 1] = 5;
        $b8ea597934691048$var$static_dtree[n * 2] = $b8ea597934691048$var$bi_reverse(n, 5);
    }
    // Now data ready and we can init static trees
    $b8ea597934691048$var$static_l_desc = new $b8ea597934691048$var$StaticTreeDesc($b8ea597934691048$var$static_ltree, $b8ea597934691048$var$extra_lbits, $b8ea597934691048$var$LITERALS$1 + 1, $b8ea597934691048$var$L_CODES$1, $b8ea597934691048$var$MAX_BITS$1);
    $b8ea597934691048$var$static_d_desc = new $b8ea597934691048$var$StaticTreeDesc($b8ea597934691048$var$static_dtree, $b8ea597934691048$var$extra_dbits, 0, $b8ea597934691048$var$D_CODES$1, $b8ea597934691048$var$MAX_BITS$1);
    $b8ea597934691048$var$static_bl_desc = new $b8ea597934691048$var$StaticTreeDesc(new Array(0), $b8ea597934691048$var$extra_blbits, 0, $b8ea597934691048$var$BL_CODES$1, $b8ea597934691048$var$MAX_BL_BITS);
//static_init_done = true;
};
/* ===========================================================================
 * Initialize a new block.
 */ const $b8ea597934691048$var$init_block = (s)=>{
    let n; /* iterates over tree elements */ 
    /* Initialize the trees. */ for(n = 0; n < $b8ea597934691048$var$L_CODES$1; n++)s.dyn_ltree[n * 2] = 0;
    for(n = 0; n < $b8ea597934691048$var$D_CODES$1; n++)s.dyn_dtree[n * 2] = 0;
    for(n = 0; n < $b8ea597934691048$var$BL_CODES$1; n++)s.bl_tree[n * 2] = 0;
    s.dyn_ltree[$b8ea597934691048$var$END_BLOCK * 2] = 1;
    s.opt_len = s.static_len = 0;
    s.sym_next = s.matches = 0;
};
/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */ const $b8ea597934691048$var$bi_windup = (s)=>{
    if (s.bi_valid > 8) $b8ea597934691048$var$put_short(s, s.bi_buf);
    else if (s.bi_valid > 0) //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
    s.bi_buf = 0;
    s.bi_valid = 0;
};
/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */ const $b8ea597934691048$var$smaller = (tree, n, m, depth)=>{
    const _n2 = n * 2;
    const _m2 = m * 2;
    return tree[_n2] < tree[_m2] || tree[_n2] === tree[_m2] && depth[n] <= depth[m];
};
/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */ const $b8ea597934691048$var$pqdownheap = (s, tree, k)=>{
    //    deflate_state *s;
    //    ct_data *tree;  /* the tree to restore */
    //    int k;               /* node to move down */
    const v = s.heap[k];
    let j = k << 1; /* left son of k */ 
    while(j <= s.heap_len){
        /* Set j to the smallest of the two sons: */ if (j < s.heap_len && $b8ea597934691048$var$smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) j++;
        /* Exit if v is smaller than both sons */ if ($b8ea597934691048$var$smaller(tree, v, s.heap[j], s.depth)) break;
        /* Exchange v with the smallest son */ s.heap[k] = s.heap[j];
        k = j;
        /* And continue down the tree, setting j to the left son of k */ j <<= 1;
    }
    s.heap[k] = v;
};
// inlined manually
// const SMALLEST = 1;
/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */ const $b8ea597934691048$var$compress_block = (s, ltree, dtree)=>{
    //    deflate_state *s;
    //    const ct_data *ltree; /* literal tree */
    //    const ct_data *dtree; /* distance tree */
    let dist; /* distance of matched string */ 
    let lc; /* match length or unmatched char (if dist == 0) */ 
    let sx = 0; /* running index in sym_buf */ 
    let code; /* the code to send */ 
    let extra; /* number of extra bits to send */ 
    if (s.sym_next !== 0) do {
        dist = s.pending_buf[s.sym_buf + sx++] & 0xff;
        dist += (s.pending_buf[s.sym_buf + sx++] & 0xff) << 8;
        lc = s.pending_buf[s.sym_buf + sx++];
        if (dist === 0) $b8ea597934691048$var$send_code(s, lc, ltree); /* send a literal byte */ 
        else {
            /* Here, lc is the match length - MIN_MATCH */ code = $b8ea597934691048$var$_length_code[lc];
            $b8ea597934691048$var$send_code(s, code + $b8ea597934691048$var$LITERALS$1 + 1, ltree); /* send the length code */ 
            extra = $b8ea597934691048$var$extra_lbits[code];
            if (extra !== 0) {
                lc -= $b8ea597934691048$var$base_length[code];
                $b8ea597934691048$var$send_bits(s, lc, extra); /* send the extra length bits */ 
            }
            dist--; /* dist is now the match distance - 1 */ 
            code = $b8ea597934691048$var$d_code(dist);
            //Assert (code < D_CODES, "bad d_code");
            $b8ea597934691048$var$send_code(s, code, dtree); /* send the distance code */ 
            extra = $b8ea597934691048$var$extra_dbits[code];
            if (extra !== 0) {
                dist -= $b8ea597934691048$var$base_dist[code];
                $b8ea597934691048$var$send_bits(s, dist, extra); /* send the extra distance bits */ 
            }
        } /* literal or match pair ? */ 
    /* Check that the overlay between pending_buf and sym_buf is ok: */ //Assert(s->pending < s->lit_bufsize + sx, "pendingBuf overflow");
    }while (sx < s.sym_next);
    $b8ea597934691048$var$send_code(s, $b8ea597934691048$var$END_BLOCK, ltree);
};
/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */ const $b8ea597934691048$var$build_tree = (s, desc)=>{
    //    deflate_state *s;
    //    tree_desc *desc; /* the tree descriptor */
    const tree = desc.dyn_tree;
    const stree = desc.stat_desc.static_tree;
    const has_stree = desc.stat_desc.has_stree;
    const elems = desc.stat_desc.elems;
    let n, m; /* iterate over heap elements */ 
    let max_code = -1; /* largest code with non zero frequency */ 
    let node; /* new node being created */ 
    /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */ s.heap_len = 0;
    s.heap_max = $b8ea597934691048$var$HEAP_SIZE$1;
    for(n = 0; n < elems; n++)if (tree[n * 2] !== 0) {
        s.heap[++s.heap_len] = max_code = n;
        s.depth[n] = 0;
    } else tree[n * 2 + 1] = 0;
    /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */ while(s.heap_len < 2){
        node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
        tree[node * 2] = 1;
        s.depth[node] = 0;
        s.opt_len--;
        if (has_stree) s.static_len -= stree[node * 2 + 1] /*.Len*/ ;
    /* node is 0 or 1 so it does not have extra bits */ }
    desc.max_code = max_code;
    /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */ for(n = s.heap_len >> 1 /*int /2*/ ; n >= 1; n--)$b8ea597934691048$var$pqdownheap(s, tree, n);
    /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */ node = elems; /* next internal node of the tree */ 
    do {
        //pqremove(s, tree, n);  /* n = node of least frequency */
        /*** pqremove ***/ n = s.heap[1 /*SMALLEST*/ ];
        s.heap[1 /*SMALLEST*/ ] = s.heap[s.heap_len--];
        $b8ea597934691048$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
        /***/ m = s.heap[1 /*SMALLEST*/ ]; /* m = node of next least frequency */ 
        s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */ 
        s.heap[--s.heap_max] = m;
        /* Create a new node father of n and m */ tree[node * 2] = tree[n * 2] + tree[m * 2] /*.Freq*/ ;
        s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
        tree[n * 2 + 1] = tree[m * 2 + 1] = node;
        /* and insert the new node in the heap */ s.heap[1 /*SMALLEST*/ ] = node++;
        $b8ea597934691048$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
    }while (s.heap_len >= 2);
    s.heap[--s.heap_max] = s.heap[1 /*SMALLEST*/ ];
    /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */ $b8ea597934691048$var$gen_bitlen(s, desc);
    /* The field len is now set, we can generate the bit codes */ $b8ea597934691048$var$gen_codes(tree, max_code, s.bl_count);
};
/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */ const $b8ea597934691048$var$scan_tree = (s, tree, max_code)=>{
    //    deflate_state *s;
    //    ct_data *tree;   /* the tree to be scanned */
    //    int max_code;    /* and its largest code of non zero frequency */
    let n; /* iterates over all tree elements */ 
    let prevlen = -1; /* last emitted length */ 
    let curlen; /* length of current code */ 
    let nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    let count = 0; /* repeat count of the current code */ 
    let max_count = 7; /* max repeat count */ 
    let min_count = 4; /* min repeat count */ 
    if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    tree[(max_code + 1) * 2 + 1] = 0xffff; /* guard */ 
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) s.bl_tree[curlen * 2] += count;
        else if (curlen !== 0) {
            if (curlen !== prevlen) s.bl_tree[curlen * 2]++;
            s.bl_tree[$b8ea597934691048$var$REP_3_6 * 2]++;
        } else if (count <= 10) s.bl_tree[$b8ea597934691048$var$REPZ_3_10 * 2]++;
        else s.bl_tree[$b8ea597934691048$var$REPZ_11_138 * 2]++;
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
};
/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */ const $b8ea597934691048$var$send_tree = (s, tree, max_code)=>{
    //    deflate_state *s;
    //    ct_data *tree; /* the tree to be scanned */
    //    int max_code;       /* and its largest code of non zero frequency */
    let n; /* iterates over all tree elements */ 
    let prevlen = -1; /* last emitted length */ 
    let curlen; /* length of current code */ 
    let nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    let count = 0; /* repeat count of the current code */ 
    let max_count = 7; /* max repeat count */ 
    let min_count = 4; /* min repeat count */ 
    /* tree[max_code+1].Len = -1; */ /* guard already set */ if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) do $b8ea597934691048$var$send_code(s, curlen, s.bl_tree);
        while (--count !== 0);
        else if (curlen !== 0) {
            if (curlen !== prevlen) {
                $b8ea597934691048$var$send_code(s, curlen, s.bl_tree);
                count--;
            }
            //Assert(count >= 3 && count <= 6, " 3_6?");
            $b8ea597934691048$var$send_code(s, $b8ea597934691048$var$REP_3_6, s.bl_tree);
            $b8ea597934691048$var$send_bits(s, count - 3, 2);
        } else if (count <= 10) {
            $b8ea597934691048$var$send_code(s, $b8ea597934691048$var$REPZ_3_10, s.bl_tree);
            $b8ea597934691048$var$send_bits(s, count - 3, 3);
        } else {
            $b8ea597934691048$var$send_code(s, $b8ea597934691048$var$REPZ_11_138, s.bl_tree);
            $b8ea597934691048$var$send_bits(s, count - 11, 7);
        }
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
};
/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */ const $b8ea597934691048$var$build_bl_tree = (s)=>{
    let max_blindex; /* index of last bit length code of non zero freq */ 
    /* Determine the bit length frequencies for literal and distance trees */ $b8ea597934691048$var$scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
    $b8ea597934691048$var$scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
    /* Build the bit length tree: */ $b8ea597934691048$var$build_tree(s, s.bl_desc);
    /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */ /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */ for(max_blindex = $b8ea597934691048$var$BL_CODES$1 - 1; max_blindex >= 3; max_blindex--){
        if (s.bl_tree[$b8ea597934691048$var$bl_order[max_blindex] * 2 + 1] !== 0) break;
    }
    /* Update opt_len to include the bit length tree and counts */ s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
    //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
    //        s->opt_len, s->static_len));
    return max_blindex;
};
/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */ const $b8ea597934691048$var$send_all_trees = (s, lcodes, dcodes, blcodes)=>{
    //    deflate_state *s;
    //    int lcodes, dcodes, blcodes; /* number of codes for each tree */
    let rank; /* index in bl_order */ 
    //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
    //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
    //        "too many codes");
    //Tracev((stderr, "\nbl counts: "));
    $b8ea597934691048$var$send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */ 
    $b8ea597934691048$var$send_bits(s, dcodes - 1, 5);
    $b8ea597934691048$var$send_bits(s, blcodes - 4, 4); /* not -3 as stated in appnote.txt */ 
    for(rank = 0; rank < blcodes; rank++)//Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    $b8ea597934691048$var$send_bits(s, s.bl_tree[$b8ea597934691048$var$bl_order[rank] * 2 + 1], 3);
    //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
    $b8ea597934691048$var$send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */ 
    //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
    $b8ea597934691048$var$send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */ 
//Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
};
/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "block list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "allow list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */ const $b8ea597934691048$var$detect_data_type = (s)=>{
    /* block_mask is the bit mask of block-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */ let block_mask = 0xf3ffc07f;
    let n;
    /* Check for non-textual ("block-listed") bytes. */ for(n = 0; n <= 31; n++, block_mask >>>= 1){
        if (block_mask & 1 && s.dyn_ltree[n * 2] !== 0) return $b8ea597934691048$var$Z_BINARY;
    }
    /* Check for textual ("allow-listed") bytes. */ if (s.dyn_ltree[18] !== 0 || s.dyn_ltree[20] !== 0 || s.dyn_ltree[26] !== 0) return $b8ea597934691048$var$Z_TEXT;
    for(n = 32; n < $b8ea597934691048$var$LITERALS$1; n++){
        if (s.dyn_ltree[n * 2] !== 0) return $b8ea597934691048$var$Z_TEXT;
    }
    /* There are no "block-listed" or "allow-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */ return $b8ea597934691048$var$Z_BINARY;
};
let $b8ea597934691048$var$static_init_done = false;
/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */ const $b8ea597934691048$var$_tr_init$1 = (s)=>{
    if (!$b8ea597934691048$var$static_init_done) {
        $b8ea597934691048$var$tr_static_init();
        $b8ea597934691048$var$static_init_done = true;
    }
    s.l_desc = new $b8ea597934691048$var$TreeDesc(s.dyn_ltree, $b8ea597934691048$var$static_l_desc);
    s.d_desc = new $b8ea597934691048$var$TreeDesc(s.dyn_dtree, $b8ea597934691048$var$static_d_desc);
    s.bl_desc = new $b8ea597934691048$var$TreeDesc(s.bl_tree, $b8ea597934691048$var$static_bl_desc);
    s.bi_buf = 0;
    s.bi_valid = 0;
    /* Initialize the first block of the first file: */ $b8ea597934691048$var$init_block(s);
};
/* ===========================================================================
 * Send a stored block
 */ const $b8ea597934691048$var$_tr_stored_block$1 = (s, buf, stored_len, last)=>{
    //DeflateState *s;
    //charf *buf;       /* input block */
    //ulg stored_len;   /* length of input block */
    //int last;         /* one if this is the last block for a file */
    $b8ea597934691048$var$send_bits(s, ($b8ea597934691048$var$STORED_BLOCK << 1) + (last ? 1 : 0), 3); /* send block type */ 
    $b8ea597934691048$var$bi_windup(s); /* align on byte boundary */ 
    $b8ea597934691048$var$put_short(s, stored_len);
    $b8ea597934691048$var$put_short(s, ~stored_len);
    if (stored_len) s.pending_buf.set(s.window.subarray(buf, buf + stored_len), s.pending);
    s.pending += stored_len;
};
/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */ const $b8ea597934691048$var$_tr_align$1 = (s)=>{
    $b8ea597934691048$var$send_bits(s, $b8ea597934691048$var$STATIC_TREES << 1, 3);
    $b8ea597934691048$var$send_code(s, $b8ea597934691048$var$END_BLOCK, $b8ea597934691048$var$static_ltree);
    $b8ea597934691048$var$bi_flush(s);
};
/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and write out the encoded block.
 */ const $b8ea597934691048$var$_tr_flush_block$1 = (s, buf, stored_len, last)=>{
    //DeflateState *s;
    //charf *buf;       /* input block, or NULL if too old */
    //ulg stored_len;   /* length of input block */
    //int last;         /* one if this is the last block for a file */
    let opt_lenb, static_lenb; /* opt_len and static_len in bytes */ 
    let max_blindex = 0; /* index of last bit length code of non zero freq */ 
    /* Build the Huffman trees unless a stored block is forced */ if (s.level > 0) {
        /* Check if the file is binary or text */ if (s.strm.data_type === $b8ea597934691048$var$Z_UNKNOWN$1) s.strm.data_type = $b8ea597934691048$var$detect_data_type(s);
        /* Construct the literal and distance trees */ $b8ea597934691048$var$build_tree(s, s.l_desc);
        // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        $b8ea597934691048$var$build_tree(s, s.d_desc);
        // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */ /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */ max_blindex = $b8ea597934691048$var$build_bl_tree(s);
        /* Determine the best encoding. Compute the block lengths in bytes. */ opt_lenb = s.opt_len + 3 + 7 >>> 3;
        static_lenb = s.static_len + 3 + 7 >>> 3;
        // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
        //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
        //        s->sym_next / 3));
        if (static_lenb <= opt_lenb) opt_lenb = static_lenb;
    } else // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */ 
    if (stored_len + 4 <= opt_lenb && buf !== -1) /* 4: two words for the lengths */ /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */ $b8ea597934691048$var$_tr_stored_block$1(s, buf, stored_len, last);
    else if (s.strategy === $b8ea597934691048$var$Z_FIXED$1 || static_lenb === opt_lenb) {
        $b8ea597934691048$var$send_bits(s, ($b8ea597934691048$var$STATIC_TREES << 1) + (last ? 1 : 0), 3);
        $b8ea597934691048$var$compress_block(s, $b8ea597934691048$var$static_ltree, $b8ea597934691048$var$static_dtree);
    } else {
        $b8ea597934691048$var$send_bits(s, ($b8ea597934691048$var$DYN_TREES << 1) + (last ? 1 : 0), 3);
        $b8ea597934691048$var$send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
        $b8ea597934691048$var$compress_block(s, s.dyn_ltree, s.dyn_dtree);
    }
    // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
    /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */ $b8ea597934691048$var$init_block(s);
    if (last) $b8ea597934691048$var$bi_windup(s);
// Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
//       s->compressed_len-7*last));
};
/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */ const $b8ea597934691048$var$_tr_tally$1 = (s, dist, lc)=>{
    //    deflate_state *s;
    //    unsigned dist;  /* distance of matched string */
    //    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
    s.pending_buf[s.sym_buf + s.sym_next++] = dist;
    s.pending_buf[s.sym_buf + s.sym_next++] = dist >> 8;
    s.pending_buf[s.sym_buf + s.sym_next++] = lc;
    if (dist === 0) /* lc is the unmatched char */ s.dyn_ltree[lc * 2]++;
    else {
        s.matches++;
        /* Here, lc is the match length - MIN_MATCH */ dist--; /* dist = match distance - 1 */ 
        //Assert((ush)dist < (ush)MAX_DIST(s) &&
        //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
        //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
        s.dyn_ltree[($b8ea597934691048$var$_length_code[lc] + $b8ea597934691048$var$LITERALS$1 + 1) * 2]++;
        s.dyn_dtree[$b8ea597934691048$var$d_code(dist) * 2]++;
    }
    return s.sym_next === s.sym_end;
};
var $b8ea597934691048$var$_tr_init_1 = $b8ea597934691048$var$_tr_init$1;
var $b8ea597934691048$var$_tr_stored_block_1 = $b8ea597934691048$var$_tr_stored_block$1;
var $b8ea597934691048$var$_tr_flush_block_1 = $b8ea597934691048$var$_tr_flush_block$1;
var $b8ea597934691048$var$_tr_tally_1 = $b8ea597934691048$var$_tr_tally$1;
var $b8ea597934691048$var$_tr_align_1 = $b8ea597934691048$var$_tr_align$1;
var $b8ea597934691048$var$trees = {
    _tr_init: $b8ea597934691048$var$_tr_init_1,
    _tr_stored_block: $b8ea597934691048$var$_tr_stored_block_1,
    _tr_flush_block: $b8ea597934691048$var$_tr_flush_block_1,
    _tr_tally: $b8ea597934691048$var$_tr_tally_1,
    _tr_align: $b8ea597934691048$var$_tr_align_1
};
// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It isn't worth it to make additional optimizations as in original.
// Small size is preferable.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
const $b8ea597934691048$var$adler32 = (adler, buf, len, pos)=>{
    let s1 = adler & 0xffff | 0, s2 = adler >>> 16 & 0xffff | 0, n = 0;
    while(len !== 0){
        // Set limit ~ twice less than 5552, to keep
        // s2 in 31-bits, because we force signed ints.
        // in other case %= will fail.
        n = len > 2000 ? 2000 : len;
        len -= n;
        do {
            s1 = s1 + buf[pos++] | 0;
            s2 = s2 + s1 | 0;
        }while (--n);
        s1 %= 65521;
        s2 %= 65521;
    }
    return s1 | s2 << 16 | 0;
};
var $b8ea597934691048$var$adler32_1 = $b8ea597934691048$var$adler32;
// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// Use ordinary array, since untyped makes no boost here
const $b8ea597934691048$var$makeTable = ()=>{
    let c, table = [];
    for(var n = 0; n < 256; n++){
        c = n;
        for(var k = 0; k < 8; k++)c = c & 1 ? 0xEDB88320 ^ c >>> 1 : c >>> 1;
        table[n] = c;
    }
    return table;
};
// Create table on load. Just 255 signed longs. Not a problem.
const $b8ea597934691048$var$crcTable = new Uint32Array($b8ea597934691048$var$makeTable());
const $b8ea597934691048$var$crc32 = (crc, buf, len, pos)=>{
    const t = $b8ea597934691048$var$crcTable;
    const end = pos + len;
    crc ^= -1;
    for(let i = pos; i < end; i++)crc = crc >>> 8 ^ t[(crc ^ buf[i]) & 0xFF];
    return crc ^ -1; // >>> 0;
};
var $b8ea597934691048$var$crc32_1 = $b8ea597934691048$var$crc32;
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var $b8ea597934691048$var$messages = {
    2: 'need dictionary',
    /* Z_NEED_DICT       2  */ 1: 'stream end',
    /* Z_STREAM_END      1  */ 0: '',
    /* Z_OK              0  */ '-1': 'file error',
    /* Z_ERRNO         (-1) */ '-2': 'stream error',
    /* Z_STREAM_ERROR  (-2) */ '-3': 'data error',
    /* Z_DATA_ERROR    (-3) */ '-4': 'insufficient memory',
    /* Z_MEM_ERROR     (-4) */ '-5': 'buffer error',
    /* Z_BUF_ERROR     (-5) */ '-6': 'incompatible version' /* Z_VERSION_ERROR (-6) */ 
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var $b8ea597934691048$var$constants$2 = {
    /* Allowed flush values; see deflate() and inflate() below for details */ Z_NO_FLUSH: 0,
    Z_PARTIAL_FLUSH: 1,
    Z_SYNC_FLUSH: 2,
    Z_FULL_FLUSH: 3,
    Z_FINISH: 4,
    Z_BLOCK: 5,
    Z_TREES: 6,
    /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */ Z_OK: 0,
    Z_STREAM_END: 1,
    Z_NEED_DICT: 2,
    Z_ERRNO: -1,
    Z_STREAM_ERROR: -2,
    Z_DATA_ERROR: -3,
    Z_MEM_ERROR: -4,
    Z_BUF_ERROR: -5,
    //Z_VERSION_ERROR: -6,
    /* compression levels */ Z_NO_COMPRESSION: 0,
    Z_BEST_SPEED: 1,
    Z_BEST_COMPRESSION: 9,
    Z_DEFAULT_COMPRESSION: -1,
    Z_FILTERED: 1,
    Z_HUFFMAN_ONLY: 2,
    Z_RLE: 3,
    Z_FIXED: 4,
    Z_DEFAULT_STRATEGY: 0,
    /* Possible values of the data_type field (though see inflate()) */ Z_BINARY: 0,
    Z_TEXT: 1,
    //Z_ASCII:                1, // = Z_TEXT (deprecated)
    Z_UNKNOWN: 2,
    /* The deflate compression method */ Z_DEFLATED: 8
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
const { _tr_init: $b8ea597934691048$var$_tr_init, _tr_stored_block: $b8ea597934691048$var$_tr_stored_block, _tr_flush_block: $b8ea597934691048$var$_tr_flush_block, _tr_tally: $b8ea597934691048$var$_tr_tally, _tr_align: $b8ea597934691048$var$_tr_align } = $b8ea597934691048$var$trees;
/* Public constants ==========================================================*/ /* ===========================================================================*/ const { Z_NO_FLUSH: $b8ea597934691048$var$Z_NO_FLUSH$2, Z_PARTIAL_FLUSH: $b8ea597934691048$var$Z_PARTIAL_FLUSH, Z_FULL_FLUSH: $b8ea597934691048$var$Z_FULL_FLUSH$1, Z_FINISH: $b8ea597934691048$var$Z_FINISH$3, Z_BLOCK: $b8ea597934691048$var$Z_BLOCK$1, Z_OK: $b8ea597934691048$var$Z_OK$3, Z_STREAM_END: $b8ea597934691048$var$Z_STREAM_END$3, Z_STREAM_ERROR: $b8ea597934691048$var$Z_STREAM_ERROR$2, Z_DATA_ERROR: $b8ea597934691048$var$Z_DATA_ERROR$2, Z_BUF_ERROR: $b8ea597934691048$var$Z_BUF_ERROR$1, Z_DEFAULT_COMPRESSION: $b8ea597934691048$var$Z_DEFAULT_COMPRESSION$1, Z_FILTERED: $b8ea597934691048$var$Z_FILTERED, Z_HUFFMAN_ONLY: $b8ea597934691048$var$Z_HUFFMAN_ONLY, Z_RLE: $b8ea597934691048$var$Z_RLE, Z_FIXED: $b8ea597934691048$var$Z_FIXED, Z_DEFAULT_STRATEGY: $b8ea597934691048$var$Z_DEFAULT_STRATEGY$1, Z_UNKNOWN: $b8ea597934691048$var$Z_UNKNOWN, Z_DEFLATED: $b8ea597934691048$var$Z_DEFLATED$2 } = $b8ea597934691048$var$constants$2;
/*============================================================================*/ const $b8ea597934691048$var$MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */ const $b8ea597934691048$var$MAX_WBITS$1 = 15;
/* 32K LZ77 window */ const $b8ea597934691048$var$DEF_MEM_LEVEL = 8;
const $b8ea597934691048$var$LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ const $b8ea597934691048$var$LITERALS = 256;
/* number of literal bytes 0..255 */ const $b8ea597934691048$var$L_CODES = $b8ea597934691048$var$LITERALS + 1 + $b8ea597934691048$var$LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ const $b8ea597934691048$var$D_CODES = 30;
/* number of distance codes */ const $b8ea597934691048$var$BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ const $b8ea597934691048$var$HEAP_SIZE = 2 * $b8ea597934691048$var$L_CODES + 1;
/* maximum heap size */ const $b8ea597934691048$var$MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ const $b8ea597934691048$var$MIN_MATCH = 3;
const $b8ea597934691048$var$MAX_MATCH = 258;
const $b8ea597934691048$var$MIN_LOOKAHEAD = $b8ea597934691048$var$MAX_MATCH + $b8ea597934691048$var$MIN_MATCH + 1;
const $b8ea597934691048$var$PRESET_DICT = 0x20;
const $b8ea597934691048$var$INIT_STATE = 42; /* zlib header -> BUSY_STATE */ 
//#ifdef GZIP
const $b8ea597934691048$var$GZIP_STATE = 57; /* gzip header -> BUSY_STATE | EXTRA_STATE */ 
//#endif
const $b8ea597934691048$var$EXTRA_STATE = 69; /* gzip extra block -> NAME_STATE */ 
const $b8ea597934691048$var$NAME_STATE = 73; /* gzip file name -> COMMENT_STATE */ 
const $b8ea597934691048$var$COMMENT_STATE = 91; /* gzip comment -> HCRC_STATE */ 
const $b8ea597934691048$var$HCRC_STATE = 103; /* gzip header CRC -> BUSY_STATE */ 
const $b8ea597934691048$var$BUSY_STATE = 113; /* deflate -> FINISH_STATE */ 
const $b8ea597934691048$var$FINISH_STATE = 666; /* stream complete */ 
const $b8ea597934691048$var$BS_NEED_MORE = 1; /* block not completed, need more input or more output */ 
const $b8ea597934691048$var$BS_BLOCK_DONE = 2; /* block flush performed */ 
const $b8ea597934691048$var$BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */ 
const $b8ea597934691048$var$BS_FINISH_DONE = 4; /* finish done, accept no more input or output */ 
const $b8ea597934691048$var$OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
const $b8ea597934691048$var$err = (strm, errorCode)=>{
    strm.msg = $b8ea597934691048$var$messages[errorCode];
    return errorCode;
};
const $b8ea597934691048$var$rank = (f)=>{
    return f * 2 - (f > 4 ? 9 : 0);
};
const $b8ea597934691048$var$zero = (buf)=>{
    let len = buf.length;
    while(--len >= 0)buf[len] = 0;
};
/* ===========================================================================
 * Slide the hash table when sliding the window down (could be avoided with 32
 * bit values at the expense of memory usage). We slide even when level == 0 to
 * keep the hash table consistent if we switch back to level > 0 later.
 */ const $b8ea597934691048$var$slide_hash = (s)=>{
    let n, m;
    let p;
    let wsize = s.w_size;
    n = s.hash_size;
    p = n;
    do {
        m = s.head[--p];
        s.head[p] = m >= wsize ? m - wsize : 0;
    }while (--n);
    n = wsize;
    //#ifndef FASTEST
    p = n;
    do {
        m = s.prev[--p];
        s.prev[p] = m >= wsize ? m - wsize : 0;
    /* If n is not on any hash chain, prev[n] is garbage but
     * its value will never be used.
     */ }while (--n);
//#endif
};
/* eslint-disable new-cap */ let $b8ea597934691048$var$HASH_ZLIB = (s, prev, data)=>(prev << s.hash_shift ^ data) & s.hash_mask;
// This hash causes less collisions, https://github.com/nodeca/pako/issues/135
// But breaks binary compatibility
//let HASH_FAST = (s, prev, data) => ((prev << 8) + (prev >> 8) + (data << 4)) & s.hash_mask;
let $b8ea597934691048$var$HASH = $b8ea597934691048$var$HASH_ZLIB;
/* =========================================================================
 * Flush as much pending output as possible. All deflate() output, except for
 * some deflate_stored() output, goes through this function so some
 * applications may wish to modify it to avoid allocating a large
 * strm->next_out buffer and copying into it. (See also read_buf()).
 */ const $b8ea597934691048$var$flush_pending = (strm)=>{
    const s = strm.state;
    //_tr_flush_bits(s);
    let len = s.pending;
    if (len > strm.avail_out) len = strm.avail_out;
    if (len === 0) return;
    strm.output.set(s.pending_buf.subarray(s.pending_out, s.pending_out + len), strm.next_out);
    strm.next_out += len;
    s.pending_out += len;
    strm.total_out += len;
    strm.avail_out -= len;
    s.pending -= len;
    if (s.pending === 0) s.pending_out = 0;
};
const $b8ea597934691048$var$flush_block_only = (s, last)=>{
    $b8ea597934691048$var$_tr_flush_block(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);
    s.block_start = s.strstart;
    $b8ea597934691048$var$flush_pending(s.strm);
};
const $b8ea597934691048$var$put_byte = (s, b)=>{
    s.pending_buf[s.pending++] = b;
};
/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */ const $b8ea597934691048$var$putShortMSB = (s, b)=>{
    //  put_byte(s, (Byte)(b >> 8));
    //  put_byte(s, (Byte)(b & 0xff));
    s.pending_buf[s.pending++] = b >>> 8 & 0xff;
    s.pending_buf[s.pending++] = b & 0xff;
};
/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */ const $b8ea597934691048$var$read_buf = (strm, buf, start, size)=>{
    let len = strm.avail_in;
    if (len > size) len = size;
    if (len === 0) return 0;
    strm.avail_in -= len;
    // zmemcpy(buf, strm->next_in, len);
    buf.set(strm.input.subarray(strm.next_in, strm.next_in + len), start);
    if (strm.state.wrap === 1) strm.adler = $b8ea597934691048$var$adler32_1(strm.adler, buf, len, start);
    else if (strm.state.wrap === 2) strm.adler = $b8ea597934691048$var$crc32_1(strm.adler, buf, len, start);
    strm.next_in += len;
    strm.total_in += len;
    return len;
};
/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */ const $b8ea597934691048$var$longest_match = (s, cur_match)=>{
    let chain_length = s.max_chain_length; /* max hash chain length */ 
    let scan = s.strstart; /* current string */ 
    let match; /* matched string */ 
    let len; /* length of current match */ 
    let best_len = s.prev_length; /* best match length so far */ 
    let nice_match = s.nice_match; /* stop if match long enough */ 
    const limit = s.strstart > s.w_size - $b8ea597934691048$var$MIN_LOOKAHEAD ? s.strstart - (s.w_size - $b8ea597934691048$var$MIN_LOOKAHEAD) : 0 /*NIL*/ ;
    const _win = s.window; // shortcut
    const wmask = s.w_mask;
    const prev = s.prev;
    /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */ const strend = s.strstart + $b8ea597934691048$var$MAX_MATCH;
    let scan_end1 = _win[scan + best_len - 1];
    let scan_end = _win[scan + best_len];
    /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */ // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
    /* Do not waste too much time if we already have a good match: */ if (s.prev_length >= s.good_match) chain_length >>= 2;
    /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */ if (nice_match > s.lookahead) nice_match = s.lookahead;
    // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
    do {
        // Assert(cur_match < s->strstart, "no future");
        match = cur_match;
        /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */ if (_win[match + best_len] !== scan_end || _win[match + best_len - 1] !== scan_end1 || _win[match] !== _win[scan] || _win[++match] !== _win[scan + 1]) continue;
        /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */ scan += 2;
        match++;
        // Assert(*scan == *match, "match[2]?");
        /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */ do ;
        while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && scan < strend);
        // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
        len = $b8ea597934691048$var$MAX_MATCH - (strend - scan);
        scan = strend - $b8ea597934691048$var$MAX_MATCH;
        if (len > best_len) {
            s.match_start = cur_match;
            best_len = len;
            if (len >= nice_match) break;
            scan_end1 = _win[scan + best_len - 1];
            scan_end = _win[scan + best_len];
        }
    }while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
    if (best_len <= s.lookahead) return best_len;
    return s.lookahead;
};
/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */ const $b8ea597934691048$var$fill_window = (s)=>{
    const _w_size = s.w_size;
    let n, more, str;
    //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
    do {
        more = s.window_size - s.lookahead - s.strstart;
        // JS ints have 32 bit, block below not needed
        /* Deal with !@#$% 64K limit: */ //if (sizeof(int) <= 2) {
        //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
        //        more = wsize;
        //
        //  } else if (more == (unsigned)(-1)) {
        //        /* Very unlikely, but possible on 16 bit machine if
        //         * strstart == 0 && lookahead == 1 (input done a byte at time)
        //         */
        //        more--;
        //    }
        //}
        /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */ if (s.strstart >= _w_size + (_w_size - $b8ea597934691048$var$MIN_LOOKAHEAD)) {
            s.window.set(s.window.subarray(_w_size, _w_size + _w_size - more), 0);
            s.match_start -= _w_size;
            s.strstart -= _w_size;
            /* we now have strstart >= MAX_DIST */ s.block_start -= _w_size;
            if (s.insert > s.strstart) s.insert = s.strstart;
            $b8ea597934691048$var$slide_hash(s);
            more += _w_size;
        }
        if (s.strm.avail_in === 0) break;
        /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */ //Assert(more >= 2, "more < 2");
        n = $b8ea597934691048$var$read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
        s.lookahead += n;
        /* Initialize the hash value now that we have some input: */ if (s.lookahead + s.insert >= $b8ea597934691048$var$MIN_MATCH) {
            str = s.strstart - s.insert;
            s.ins_h = s.window[str];
            /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */ s.ins_h = $b8ea597934691048$var$HASH(s, s.ins_h, s.window[str + 1]);
            //#if MIN_MATCH != 3
            //        Call update_hash() MIN_MATCH-3 more times
            //#endif
            while(s.insert){
                /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = $b8ea597934691048$var$HASH(s, s.ins_h, s.window[str + $b8ea597934691048$var$MIN_MATCH - 1]);
                s.prev[str & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = str;
                str++;
                s.insert--;
                if (s.lookahead + s.insert < $b8ea597934691048$var$MIN_MATCH) break;
            }
        }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */ }while (s.lookahead < $b8ea597934691048$var$MIN_LOOKAHEAD && s.strm.avail_in !== 0);
/* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */ //  if (s.high_water < s.window_size) {
//    const curr = s.strstart + s.lookahead;
//    let init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
};
/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 *
 * In case deflateParams() is used to later switch to a non-zero compression
 * level, s->matches (otherwise unused when storing) keeps track of the number
 * of hash table slides to perform. If s->matches is 1, then one hash table
 * slide will be done when switching. If s->matches is 2, the maximum value
 * allowed here, then the hash table will be cleared, since two or more slides
 * is the same as a clear.
 *
 * deflate_stored() is written to minimize the number of times an input byte is
 * copied. It is most efficient with large input and output buffers, which
 * maximizes the opportunites to have a single copy from next_in to next_out.
 */ const $b8ea597934691048$var$deflate_stored = (s, flush)=>{
    /* Smallest worthy block size when not flushing or finishing. By default
   * this is 32K. This can be as small as 507 bytes for memLevel == 1. For
   * large input and output buffers, the stored block size will be larger.
   */ let min_block = s.pending_buf_size - 5 > s.w_size ? s.w_size : s.pending_buf_size - 5;
    /* Copy as many min_block or larger stored blocks directly to next_out as
   * possible. If flushing, copy the remaining available input to next_out as
   * stored blocks, if there is enough space.
   */ let len, left, have, last = 0;
    let used = s.strm.avail_in;
    do {
        /* Set len to the maximum size block that we can copy directly with the
     * available input data and output space. Set left to how much of that
     * would be copied from what's left in the window.
     */ len = 65535 /* MAX_STORED */ ; /* maximum deflate stored block length */ 
        have = s.bi_valid + 42 >> 3; /* number of header bytes */ 
        if (s.strm.avail_out < have) break;
        /* maximum stored block length that will fit in avail_out: */ have = s.strm.avail_out - have;
        left = s.strstart - s.block_start; /* bytes left in window */ 
        if (len > left + s.strm.avail_in) len = left + s.strm.avail_in; /* limit len to the input */ 
        if (len > have) len = have; /* limit len to the output */ 
        /* If the stored block would be less than min_block in length, or if
     * unable to copy all of the available input when flushing, then try
     * copying to the window and the pending buffer instead. Also don't
     * write an empty block when flushing -- deflate() does that.
     */ if (len < min_block && (len === 0 && flush !== $b8ea597934691048$var$Z_FINISH$3 || flush === $b8ea597934691048$var$Z_NO_FLUSH$2 || len !== left + s.strm.avail_in)) break;
        /* Make a dummy stored block in pending to get the header bytes,
     * including any pending bits. This also updates the debugging counts.
     */ last = flush === $b8ea597934691048$var$Z_FINISH$3 && len === left + s.strm.avail_in ? 1 : 0;
        $b8ea597934691048$var$_tr_stored_block(s, 0, 0, last);
        /* Replace the lengths in the dummy stored block with len. */ s.pending_buf[s.pending - 4] = len;
        s.pending_buf[s.pending - 3] = len >> 8;
        s.pending_buf[s.pending - 2] = ~len;
        s.pending_buf[s.pending - 1] = ~len >> 8;
        /* Write the stored block header bytes. */ $b8ea597934691048$var$flush_pending(s.strm);
        //#ifdef ZLIB_DEBUG
        //    /* Update debugging counts for the data about to be copied. */
        //    s->compressed_len += len << 3;
        //    s->bits_sent += len << 3;
        //#endif
        /* Copy uncompressed bytes from the window to next_out. */ if (left) {
            if (left > len) left = len;
            //zmemcpy(s->strm->next_out, s->window + s->block_start, left);
            s.strm.output.set(s.window.subarray(s.block_start, s.block_start + left), s.strm.next_out);
            s.strm.next_out += left;
            s.strm.avail_out -= left;
            s.strm.total_out += left;
            s.block_start += left;
            len -= left;
        }
        /* Copy uncompressed bytes directly from next_in to next_out, updating
     * the check value.
     */ if (len) {
            $b8ea597934691048$var$read_buf(s.strm, s.strm.output, s.strm.next_out, len);
            s.strm.next_out += len;
            s.strm.avail_out -= len;
            s.strm.total_out += len;
        }
    }while (last === 0);
    /* Update the sliding window with the last s->w_size bytes of the copied
   * data, or append all of the copied data to the existing window if less
   * than s->w_size bytes were copied. Also update the number of bytes to
   * insert in the hash tables, in the event that deflateParams() switches to
   * a non-zero compression level.
   */ used -= s.strm.avail_in; /* number of input bytes directly copied */ 
    if (used) {
        /* If any input was used, then no unused input remains in the window,
     * therefore s->block_start == s->strstart.
     */ if (used >= s.w_size) {
            s.matches = 2; /* clear hash */ 
            //zmemcpy(s->window, s->strm->next_in - s->w_size, s->w_size);
            s.window.set(s.strm.input.subarray(s.strm.next_in - s.w_size, s.strm.next_in), 0);
            s.strstart = s.w_size;
            s.insert = s.strstart;
        } else {
            if (s.window_size - s.strstart <= used) {
                /* Slide the window down. */ s.strstart -= s.w_size;
                //zmemcpy(s->window, s->window + s->w_size, s->strstart);
                s.window.set(s.window.subarray(s.w_size, s.w_size + s.strstart), 0);
                if (s.matches < 2) s.matches++; /* add a pending slide_hash() */ 
                if (s.insert > s.strstart) s.insert = s.strstart;
            }
            //zmemcpy(s->window + s->strstart, s->strm->next_in - used, used);
            s.window.set(s.strm.input.subarray(s.strm.next_in - used, s.strm.next_in), s.strstart);
            s.strstart += used;
            s.insert += used > s.w_size - s.insert ? s.w_size - s.insert : used;
        }
        s.block_start = s.strstart;
    }
    if (s.high_water < s.strstart) s.high_water = s.strstart;
    /* If the last block was written to next_out, then done. */ if (last) return $b8ea597934691048$var$BS_FINISH_DONE;
    /* If flushing and all input has been consumed, then done. */ if (flush !== $b8ea597934691048$var$Z_NO_FLUSH$2 && flush !== $b8ea597934691048$var$Z_FINISH$3 && s.strm.avail_in === 0 && s.strstart === s.block_start) return $b8ea597934691048$var$BS_BLOCK_DONE;
    /* Fill the window with any remaining input. */ have = s.window_size - s.strstart;
    if (s.strm.avail_in > have && s.block_start >= s.w_size) {
        /* Slide the window down. */ s.block_start -= s.w_size;
        s.strstart -= s.w_size;
        //zmemcpy(s->window, s->window + s->w_size, s->strstart);
        s.window.set(s.window.subarray(s.w_size, s.w_size + s.strstart), 0);
        if (s.matches < 2) s.matches++; /* add a pending slide_hash() */ 
        have += s.w_size; /* more space now */ 
        if (s.insert > s.strstart) s.insert = s.strstart;
    }
    if (have > s.strm.avail_in) have = s.strm.avail_in;
    if (have) {
        $b8ea597934691048$var$read_buf(s.strm, s.window, s.strstart, have);
        s.strstart += have;
        s.insert += have > s.w_size - s.insert ? s.w_size - s.insert : have;
    }
    if (s.high_water < s.strstart) s.high_water = s.strstart;
    /* There was not enough avail_out to write a complete worthy or flushed
   * stored block to next_out. Write a stored block to pending instead, if we
   * have enough input for a worthy block, or if flushing and there is enough
   * room for the remaining input as a stored block in the pending buffer.
   */ have = s.bi_valid + 42 >> 3; /* number of header bytes */ 
    /* maximum stored block length that will fit in pending: */ have = s.pending_buf_size - have > 65535 /* MAX_STORED */  ? 65535 /* MAX_STORED */  : s.pending_buf_size - have;
    min_block = have > s.w_size ? s.w_size : have;
    left = s.strstart - s.block_start;
    if (left >= min_block || (left || flush === $b8ea597934691048$var$Z_FINISH$3) && flush !== $b8ea597934691048$var$Z_NO_FLUSH$2 && s.strm.avail_in === 0 && left <= have) {
        len = left > have ? have : left;
        last = flush === $b8ea597934691048$var$Z_FINISH$3 && s.strm.avail_in === 0 && len === left ? 1 : 0;
        $b8ea597934691048$var$_tr_stored_block(s, s.block_start, len, last);
        s.block_start += len;
        $b8ea597934691048$var$flush_pending(s.strm);
    }
    /* We've done all we can with the available input and output. */ return last ? $b8ea597934691048$var$BS_FINISH_STARTED : $b8ea597934691048$var$BS_NEED_MORE;
};
/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */ const $b8ea597934691048$var$deflate_fast = (s, flush)=>{
    let hash_head; /* head of the hash chain */ 
    let bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $b8ea597934691048$var$MIN_LOOKAHEAD) {
            $b8ea597934691048$var$fill_window(s);
            if (s.lookahead < $b8ea597934691048$var$MIN_LOOKAHEAD && flush === $b8ea597934691048$var$Z_NO_FLUSH$2) return $b8ea597934691048$var$BS_NEED_MORE;
            if (s.lookahead === 0) break; /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $b8ea597934691048$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = $b8ea597934691048$var$HASH(s, s.ins_h, s.window[s.strstart + $b8ea597934691048$var$MIN_MATCH - 1]);
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */ if (hash_head !== 0 /*NIL*/  && s.strstart - hash_head <= s.w_size - $b8ea597934691048$var$MIN_LOOKAHEAD) /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $b8ea597934691048$var$longest_match(s, hash_head);
        if (s.match_length >= $b8ea597934691048$var$MIN_MATCH) {
            // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
            /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/ bflush = $b8ea597934691048$var$_tr_tally(s, s.strstart - s.match_start, s.match_length - $b8ea597934691048$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */ if (s.match_length <= s.max_lazy_match /*max_insert_length*/  && s.lookahead >= $b8ea597934691048$var$MIN_MATCH) {
                s.match_length--; /* string at strstart already in table */ 
                do {
                    s.strstart++;
                    /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = $b8ea597934691048$var$HASH(s, s.ins_h, s.window[s.strstart + $b8ea597934691048$var$MIN_MATCH - 1]);
                    hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = s.strstart;
                /***/ /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */ }while (--s.match_length !== 0);
                s.strstart++;
            } else {
                s.strstart += s.match_length;
                s.match_length = 0;
                s.ins_h = s.window[s.strstart];
                /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */ s.ins_h = $b8ea597934691048$var$HASH(s, s.ins_h, s.window[s.strstart + 1]);
            //#if MIN_MATCH != 3
            //                Call UPDATE_HASH() MIN_MATCH-3 more times
            //#endif
            /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */ }
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s.window[s.strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $b8ea597934691048$var$_tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $b8ea597934691048$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $b8ea597934691048$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = s.strstart < $b8ea597934691048$var$MIN_MATCH - 1 ? s.strstart : $b8ea597934691048$var$MIN_MATCH - 1;
    if (flush === $b8ea597934691048$var$Z_FINISH$3) {
        /*** FLUSH_BLOCK(s, 1); ***/ $b8ea597934691048$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $b8ea597934691048$var$BS_FINISH_STARTED;
        /***/ return $b8ea597934691048$var$BS_FINISH_DONE;
    }
    if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/ $b8ea597934691048$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $b8ea597934691048$var$BS_NEED_MORE;
    /***/ }
    return $b8ea597934691048$var$BS_BLOCK_DONE;
};
/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */ const $b8ea597934691048$var$deflate_slow = (s, flush)=>{
    let hash_head; /* head of hash chain */ 
    let bflush; /* set if current block must be flushed */ 
    let max_insert;
    /* Process the input block. */ for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $b8ea597934691048$var$MIN_LOOKAHEAD) {
            $b8ea597934691048$var$fill_window(s);
            if (s.lookahead < $b8ea597934691048$var$MIN_LOOKAHEAD && flush === $b8ea597934691048$var$Z_NO_FLUSH$2) return $b8ea597934691048$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $b8ea597934691048$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = $b8ea597934691048$var$HASH(s, s.ins_h, s.window[s.strstart + $b8ea597934691048$var$MIN_MATCH - 1]);
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     */ s.prev_length = s.match_length;
        s.prev_match = s.match_start;
        s.match_length = $b8ea597934691048$var$MIN_MATCH - 1;
        if (hash_head !== 0 /*NIL*/  && s.prev_length < s.max_lazy_match && s.strstart - hash_head <= s.w_size - $b8ea597934691048$var$MIN_LOOKAHEAD) {
            /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $b8ea597934691048$var$longest_match(s, hash_head);
            /* longest_match() sets match_start */ if (s.match_length <= 5 && (s.strategy === $b8ea597934691048$var$Z_FILTERED || s.match_length === $b8ea597934691048$var$MIN_MATCH && s.strstart - s.match_start > 4096 /*TOO_FAR*/ )) /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */ s.match_length = $b8ea597934691048$var$MIN_MATCH - 1;
        }
        /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */ if (s.prev_length >= $b8ea597934691048$var$MIN_MATCH && s.match_length <= s.prev_length) {
            max_insert = s.strstart + s.lookahead - $b8ea597934691048$var$MIN_MATCH;
            /* Do not insert strings in hash table beyond this. */ //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
            /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/ bflush = $b8ea597934691048$var$_tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - $b8ea597934691048$var$MIN_MATCH);
            /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */ s.lookahead -= s.prev_length - 1;
            s.prev_length -= 2;
            do if (++s.strstart <= max_insert) {
                /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = $b8ea597934691048$var$HASH(s, s.ins_h, s.window[s.strstart + $b8ea597934691048$var$MIN_MATCH - 1]);
                hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = s.strstart;
            /***/ }
            while (--s.prev_length !== 0);
            s.match_available = 0;
            s.match_length = $b8ea597934691048$var$MIN_MATCH - 1;
            s.strstart++;
            if (bflush) {
                /*** FLUSH_BLOCK(s, 0); ***/ $b8ea597934691048$var$flush_block_only(s, false);
                if (s.strm.avail_out === 0) return $b8ea597934691048$var$BS_NEED_MORE;
            /***/ }
        } else if (s.match_available) {
            /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */ //Tracevv((stderr,"%c", s->window[s->strstart-1]));
            /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $b8ea597934691048$var$_tr_tally(s, 0, s.window[s.strstart - 1]);
            if (bflush) /*** FLUSH_BLOCK_ONLY(s, 0) ***/ $b8ea597934691048$var$flush_block_only(s, false);
            s.strstart++;
            s.lookahead--;
            if (s.strm.avail_out === 0) return $b8ea597934691048$var$BS_NEED_MORE;
        } else {
            /* There is no previous match to compare with, wait for
       * the next step to decide.
       */ s.match_available = 1;
            s.strstart++;
            s.lookahead--;
        }
    }
    //Assert (flush != Z_NO_FLUSH, "no flush?");
    if (s.match_available) {
        //Tracevv((stderr,"%c", s->window[s->strstart-1]));
        /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $b8ea597934691048$var$_tr_tally(s, 0, s.window[s.strstart - 1]);
        s.match_available = 0;
    }
    s.insert = s.strstart < $b8ea597934691048$var$MIN_MATCH - 1 ? s.strstart : $b8ea597934691048$var$MIN_MATCH - 1;
    if (flush === $b8ea597934691048$var$Z_FINISH$3) {
        /*** FLUSH_BLOCK(s, 1); ***/ $b8ea597934691048$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $b8ea597934691048$var$BS_FINISH_STARTED;
        /***/ return $b8ea597934691048$var$BS_FINISH_DONE;
    }
    if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/ $b8ea597934691048$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $b8ea597934691048$var$BS_NEED_MORE;
    /***/ }
    return $b8ea597934691048$var$BS_BLOCK_DONE;
};
/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */ const $b8ea597934691048$var$deflate_rle = (s, flush)=>{
    let bflush; /* set if current block must be flushed */ 
    let prev; /* byte at distance one to match */ 
    let scan, strend; /* scan goes up to strend for length of run */ 
    const _win = s.window;
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */ if (s.lookahead <= $b8ea597934691048$var$MAX_MATCH) {
            $b8ea597934691048$var$fill_window(s);
            if (s.lookahead <= $b8ea597934691048$var$MAX_MATCH && flush === $b8ea597934691048$var$Z_NO_FLUSH$2) return $b8ea597934691048$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* See how many times the previous byte repeats */ s.match_length = 0;
        if (s.lookahead >= $b8ea597934691048$var$MIN_MATCH && s.strstart > 0) {
            scan = s.strstart - 1;
            prev = _win[scan];
            if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
                strend = s.strstart + $b8ea597934691048$var$MAX_MATCH;
                do ;
                while (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && scan < strend);
                s.match_length = $b8ea597934691048$var$MAX_MATCH - (strend - scan);
                if (s.match_length > s.lookahead) s.match_length = s.lookahead;
            }
        //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
        }
        /* Emit match if have run of MIN_MATCH or longer, else emit literal */ if (s.match_length >= $b8ea597934691048$var$MIN_MATCH) {
            //check_match(s, s.strstart, s.strstart - 1, s.match_length);
            /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/ bflush = $b8ea597934691048$var$_tr_tally(s, 1, s.match_length - $b8ea597934691048$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            s.strstart += s.match_length;
            s.match_length = 0;
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s->window[s->strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $b8ea597934691048$var$_tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $b8ea597934691048$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $b8ea597934691048$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $b8ea597934691048$var$Z_FINISH$3) {
        /*** FLUSH_BLOCK(s, 1); ***/ $b8ea597934691048$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $b8ea597934691048$var$BS_FINISH_STARTED;
        /***/ return $b8ea597934691048$var$BS_FINISH_DONE;
    }
    if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/ $b8ea597934691048$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $b8ea597934691048$var$BS_NEED_MORE;
    /***/ }
    return $b8ea597934691048$var$BS_BLOCK_DONE;
};
/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */ const $b8ea597934691048$var$deflate_huff = (s, flush)=>{
    let bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we have a literal to write. */ if (s.lookahead === 0) {
            $b8ea597934691048$var$fill_window(s);
            if (s.lookahead === 0) {
                if (flush === $b8ea597934691048$var$Z_NO_FLUSH$2) return $b8ea597934691048$var$BS_NEED_MORE;
                break; /* flush the current block */ 
            }
        }
        /* Output a literal byte */ s.match_length = 0;
        //Tracevv((stderr,"%c", s->window[s->strstart]));
        /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $b8ea597934691048$var$_tr_tally(s, 0, s.window[s.strstart]);
        s.lookahead--;
        s.strstart++;
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $b8ea597934691048$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $b8ea597934691048$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $b8ea597934691048$var$Z_FINISH$3) {
        /*** FLUSH_BLOCK(s, 1); ***/ $b8ea597934691048$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $b8ea597934691048$var$BS_FINISH_STARTED;
        /***/ return $b8ea597934691048$var$BS_FINISH_DONE;
    }
    if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/ $b8ea597934691048$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $b8ea597934691048$var$BS_NEED_MORE;
    /***/ }
    return $b8ea597934691048$var$BS_BLOCK_DONE;
};
/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */ function $b8ea597934691048$var$Config(good_length, max_lazy, nice_length, max_chain, func) {
    this.good_length = good_length;
    this.max_lazy = max_lazy;
    this.nice_length = nice_length;
    this.max_chain = max_chain;
    this.func = func;
}
const $b8ea597934691048$var$configuration_table = [
    /*      good lazy nice chain */ new $b8ea597934691048$var$Config(0, 0, 0, 0, $b8ea597934691048$var$deflate_stored),
    /* 0 store only */ new $b8ea597934691048$var$Config(4, 4, 8, 4, $b8ea597934691048$var$deflate_fast),
    /* 1 max speed, no lazy matches */ new $b8ea597934691048$var$Config(4, 5, 16, 8, $b8ea597934691048$var$deflate_fast),
    /* 2 */ new $b8ea597934691048$var$Config(4, 6, 32, 32, $b8ea597934691048$var$deflate_fast),
    /* 3 */ new $b8ea597934691048$var$Config(4, 4, 16, 16, $b8ea597934691048$var$deflate_slow),
    /* 4 lazy matches */ new $b8ea597934691048$var$Config(8, 16, 32, 32, $b8ea597934691048$var$deflate_slow),
    /* 5 */ new $b8ea597934691048$var$Config(8, 16, 128, 128, $b8ea597934691048$var$deflate_slow),
    /* 6 */ new $b8ea597934691048$var$Config(8, 32, 128, 256, $b8ea597934691048$var$deflate_slow),
    /* 7 */ new $b8ea597934691048$var$Config(32, 128, 258, 1024, $b8ea597934691048$var$deflate_slow),
    /* 8 */ new $b8ea597934691048$var$Config(32, 258, 258, 4096, $b8ea597934691048$var$deflate_slow)
];
/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */ const $b8ea597934691048$var$lm_init = (s)=>{
    s.window_size = 2 * s.w_size;
    /*** CLEAR_HASH(s); ***/ $b8ea597934691048$var$zero(s.head); // Fill with NIL (= 0);
    /* Set the default configuration parameters:
   */ s.max_lazy_match = $b8ea597934691048$var$configuration_table[s.level].max_lazy;
    s.good_match = $b8ea597934691048$var$configuration_table[s.level].good_length;
    s.nice_match = $b8ea597934691048$var$configuration_table[s.level].nice_length;
    s.max_chain_length = $b8ea597934691048$var$configuration_table[s.level].max_chain;
    s.strstart = 0;
    s.block_start = 0;
    s.lookahead = 0;
    s.insert = 0;
    s.match_length = s.prev_length = $b8ea597934691048$var$MIN_MATCH - 1;
    s.match_available = 0;
    s.ins_h = 0;
};
function $b8ea597934691048$var$DeflateState() {
    this.strm = null; /* pointer back to this zlib stream */ 
    this.status = 0; /* as the name implies */ 
    this.pending_buf = null; /* output still pending */ 
    this.pending_buf_size = 0; /* size of pending_buf */ 
    this.pending_out = 0; /* next pending byte to output to the stream */ 
    this.pending = 0; /* nb of bytes in the pending buffer */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.gzhead = null; /* gzip header information to write */ 
    this.gzindex = 0; /* where in extra, name, or comment */ 
    this.method = $b8ea597934691048$var$Z_DEFLATED$2; /* can only be DEFLATED */ 
    this.last_flush = -1; /* value of flush param for previous deflate call */ 
    this.w_size = 0; /* LZ77 window size (32K by default) */ 
    this.w_bits = 0; /* log2(w_size)  (8..16) */ 
    this.w_mask = 0; /* w_size - 1 */ 
    this.window = null;
    /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */ this.window_size = 0;
    /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */ this.prev = null;
    /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */ this.head = null; /* Heads of the hash chains or NIL. */ 
    this.ins_h = 0; /* hash index of string to be inserted */ 
    this.hash_size = 0; /* number of elements in hash table */ 
    this.hash_bits = 0; /* log2(hash_size) */ 
    this.hash_mask = 0; /* hash_size-1 */ 
    this.hash_shift = 0;
    /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */ this.block_start = 0;
    /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */ this.match_length = 0; /* length of best match */ 
    this.prev_match = 0; /* previous match */ 
    this.match_available = 0; /* set if previous match exists */ 
    this.strstart = 0; /* start of string to insert */ 
    this.match_start = 0; /* start of matching string */ 
    this.lookahead = 0; /* number of valid bytes ahead in window */ 
    this.prev_length = 0;
    /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */ this.max_chain_length = 0;
    /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */ this.max_lazy_match = 0;
    /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */ // That's alias to max_lazy_match, don't use directly
    //this.max_insert_length = 0;
    /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */ this.level = 0; /* compression level (1..9) */ 
    this.strategy = 0; /* favor or force Huffman coding*/ 
    this.good_match = 0;
    /* Use a faster search when the previous match is longer than this */ this.nice_match = 0; /* Stop searching when current match exceeds this */ 
    /* used by trees.c: */ /* Didn't use ct_data typedef below to suppress compiler warning */ // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
    // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
    // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
    // Use flat array of DOUBLE size, with interleaved fata,
    // because JS does not support effective
    this.dyn_ltree = new Uint16Array($b8ea597934691048$var$HEAP_SIZE * 2);
    this.dyn_dtree = new Uint16Array((2 * $b8ea597934691048$var$D_CODES + 1) * 2);
    this.bl_tree = new Uint16Array((2 * $b8ea597934691048$var$BL_CODES + 1) * 2);
    $b8ea597934691048$var$zero(this.dyn_ltree);
    $b8ea597934691048$var$zero(this.dyn_dtree);
    $b8ea597934691048$var$zero(this.bl_tree);
    this.l_desc = null; /* desc. for literal tree */ 
    this.d_desc = null; /* desc. for distance tree */ 
    this.bl_desc = null; /* desc. for bit length tree */ 
    //ush bl_count[MAX_BITS+1];
    this.bl_count = new Uint16Array($b8ea597934691048$var$MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
    this.heap = new Uint16Array(2 * $b8ea597934691048$var$L_CODES + 1); /* heap used to build the Huffman trees */ 
    $b8ea597934691048$var$zero(this.heap);
    this.heap_len = 0; /* number of elements in the heap */ 
    this.heap_max = 0; /* element of largest frequency */ 
    /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */ this.depth = new Uint16Array(2 * $b8ea597934691048$var$L_CODES + 1); //uch depth[2*L_CODES+1];
    $b8ea597934691048$var$zero(this.depth);
    /* Depth of each subtree used as tie breaker for trees of equal frequency
   */ this.sym_buf = 0; /* buffer for distances and literals/lengths */ 
    this.lit_bufsize = 0;
    /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */ this.sym_next = 0; /* running index in sym_buf */ 
    this.sym_end = 0; /* symbol table full when sym_next reaches this */ 
    this.opt_len = 0; /* bit length of current block with optimal trees */ 
    this.static_len = 0; /* bit length of current block with static trees */ 
    this.matches = 0; /* number of string matches in current block */ 
    this.insert = 0; /* bytes at end of window left to insert */ 
    this.bi_buf = 0;
    /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */ this.bi_valid = 0;
/* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */ // Used for window memory init. We safely ignore it for JS. That makes
// sense only for pointers and memory check tools.
//this.high_water = 0;
/* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */ }
/* =========================================================================
 * Check for a valid deflate stream state. Return 0 if ok, 1 if not.
 */ const $b8ea597934691048$var$deflateStateCheck = (strm)=>{
    if (!strm) return 1;
    const s = strm.state;
    if (!s || s.strm !== strm || s.status !== $b8ea597934691048$var$INIT_STATE && //#ifdef GZIP
    s.status !== $b8ea597934691048$var$GZIP_STATE && //#endif
    s.status !== $b8ea597934691048$var$EXTRA_STATE && s.status !== $b8ea597934691048$var$NAME_STATE && s.status !== $b8ea597934691048$var$COMMENT_STATE && s.status !== $b8ea597934691048$var$HCRC_STATE && s.status !== $b8ea597934691048$var$BUSY_STATE && s.status !== $b8ea597934691048$var$FINISH_STATE) return 1;
    return 0;
};
const $b8ea597934691048$var$deflateResetKeep = (strm)=>{
    if ($b8ea597934691048$var$deflateStateCheck(strm)) return $b8ea597934691048$var$err(strm, $b8ea597934691048$var$Z_STREAM_ERROR$2);
    strm.total_in = strm.total_out = 0;
    strm.data_type = $b8ea597934691048$var$Z_UNKNOWN;
    const s = strm.state;
    s.pending = 0;
    s.pending_out = 0;
    if (s.wrap < 0) s.wrap = -s.wrap;
    s.status = //#ifdef GZIP
    s.wrap === 2 ? $b8ea597934691048$var$GZIP_STATE : //#endif
    s.wrap ? $b8ea597934691048$var$INIT_STATE : $b8ea597934691048$var$BUSY_STATE;
    strm.adler = s.wrap === 2 ? 0 // crc32(0, Z_NULL, 0)
     : 1; // adler32(0, Z_NULL, 0)
    s.last_flush = -2;
    $b8ea597934691048$var$_tr_init(s);
    return $b8ea597934691048$var$Z_OK$3;
};
const $b8ea597934691048$var$deflateReset = (strm)=>{
    const ret = $b8ea597934691048$var$deflateResetKeep(strm);
    if (ret === $b8ea597934691048$var$Z_OK$3) $b8ea597934691048$var$lm_init(strm.state);
    return ret;
};
const $b8ea597934691048$var$deflateSetHeader = (strm, head)=>{
    if ($b8ea597934691048$var$deflateStateCheck(strm) || strm.state.wrap !== 2) return $b8ea597934691048$var$Z_STREAM_ERROR$2;
    strm.state.gzhead = head;
    return $b8ea597934691048$var$Z_OK$3;
};
const $b8ea597934691048$var$deflateInit2 = (strm, level, method, windowBits, memLevel, strategy)=>{
    if (!strm) return $b8ea597934691048$var$Z_STREAM_ERROR$2;
    let wrap = 1;
    if (level === $b8ea597934691048$var$Z_DEFAULT_COMPRESSION$1) level = 6;
    if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else if (windowBits > 15) {
        wrap = 2; /* write gzip wrapper instead */ 
        windowBits -= 16;
    }
    if (memLevel < 1 || memLevel > $b8ea597934691048$var$MAX_MEM_LEVEL || method !== $b8ea597934691048$var$Z_DEFLATED$2 || windowBits < 8 || windowBits > 15 || level < 0 || level > 9 || strategy < 0 || strategy > $b8ea597934691048$var$Z_FIXED || windowBits === 8 && wrap !== 1) return $b8ea597934691048$var$err(strm, $b8ea597934691048$var$Z_STREAM_ERROR$2);
    if (windowBits === 8) windowBits = 9;
    /* until 256-byte window bug fixed */ const s = new $b8ea597934691048$var$DeflateState();
    strm.state = s;
    s.strm = strm;
    s.status = $b8ea597934691048$var$INIT_STATE; /* to pass state test in deflateReset() */ 
    s.wrap = wrap;
    s.gzhead = null;
    s.w_bits = windowBits;
    s.w_size = 1 << s.w_bits;
    s.w_mask = s.w_size - 1;
    s.hash_bits = memLevel + 7;
    s.hash_size = 1 << s.hash_bits;
    s.hash_mask = s.hash_size - 1;
    s.hash_shift = ~~((s.hash_bits + $b8ea597934691048$var$MIN_MATCH - 1) / $b8ea597934691048$var$MIN_MATCH);
    s.window = new Uint8Array(s.w_size * 2);
    s.head = new Uint16Array(s.hash_size);
    s.prev = new Uint16Array(s.w_size);
    // Don't need mem init magic for JS.
    //s.high_water = 0;  /* nothing written to s->window yet */
    s.lit_bufsize = 1 << memLevel + 6; /* 16K elements by default */ 
    /* We overlay pending_buf and sym_buf. This works since the average size
   * for length/distance pairs over any compressed block is assured to be 31
   * bits or less.
   *
   * Analysis: The longest fixed codes are a length code of 8 bits plus 5
   * extra bits, for lengths 131 to 257. The longest fixed distance codes are
   * 5 bits plus 13 extra bits, for distances 16385 to 32768. The longest
   * possible fixed-codes length/distance pair is then 31 bits total.
   *
   * sym_buf starts one-fourth of the way into pending_buf. So there are
   * three bytes in sym_buf for every four bytes in pending_buf. Each symbol
   * in sym_buf is three bytes -- two for the distance and one for the
   * literal/length. As each symbol is consumed, the pointer to the next
   * sym_buf value to read moves forward three bytes. From that symbol, up to
   * 31 bits are written to pending_buf. The closest the written pending_buf
   * bits gets to the next sym_buf symbol to read is just before the last
   * code is written. At that time, 31*(n-2) bits have been written, just
   * after 24*(n-2) bits have been consumed from sym_buf. sym_buf starts at
   * 8*n bits into pending_buf. (Note that the symbol buffer fills when n-1
   * symbols are written.) The closest the writing gets to what is unread is
   * then n+14 bits. Here n is lit_bufsize, which is 16384 by default, and
   * can range from 128 to 32768.
   *
   * Therefore, at a minimum, there are 142 bits of space between what is
   * written and what is read in the overlain buffers, so the symbols cannot
   * be overwritten by the compressed data. That space is actually 139 bits,
   * due to the three-bit fixed-code block header.
   *
   * That covers the case where either Z_FIXED is specified, forcing fixed
   * codes, or when the use of fixed codes is chosen, because that choice
   * results in a smaller compressed block than dynamic codes. That latter
   * condition then assures that the above analysis also covers all dynamic
   * blocks. A dynamic-code block will only be chosen to be emitted if it has
   * fewer bits than a fixed-code block would for the same set of symbols.
   * Therefore its average symbol length is assured to be less than 31. So
   * the compressed data for a dynamic block also cannot overwrite the
   * symbols from which it is being constructed.
   */ s.pending_buf_size = s.lit_bufsize * 4;
    s.pending_buf = new Uint8Array(s.pending_buf_size);
    // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
    //s->sym_buf = s->pending_buf + s->lit_bufsize;
    s.sym_buf = s.lit_bufsize;
    //s->sym_end = (s->lit_bufsize - 1) * 3;
    s.sym_end = (s.lit_bufsize - 1) * 3;
    /* We avoid equality with lit_bufsize*3 because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */ s.level = level;
    s.strategy = strategy;
    s.method = method;
    return $b8ea597934691048$var$deflateReset(strm);
};
const $b8ea597934691048$var$deflateInit = (strm, level)=>{
    return $b8ea597934691048$var$deflateInit2(strm, level, $b8ea597934691048$var$Z_DEFLATED$2, $b8ea597934691048$var$MAX_WBITS$1, $b8ea597934691048$var$DEF_MEM_LEVEL, $b8ea597934691048$var$Z_DEFAULT_STRATEGY$1);
};
/* ========================================================================= */ const $b8ea597934691048$var$deflate$2 = (strm, flush)=>{
    if ($b8ea597934691048$var$deflateStateCheck(strm) || flush > $b8ea597934691048$var$Z_BLOCK$1 || flush < 0) return strm ? $b8ea597934691048$var$err(strm, $b8ea597934691048$var$Z_STREAM_ERROR$2) : $b8ea597934691048$var$Z_STREAM_ERROR$2;
    const s = strm.state;
    if (!strm.output || strm.avail_in !== 0 && !strm.input || s.status === $b8ea597934691048$var$FINISH_STATE && flush !== $b8ea597934691048$var$Z_FINISH$3) return $b8ea597934691048$var$err(strm, strm.avail_out === 0 ? $b8ea597934691048$var$Z_BUF_ERROR$1 : $b8ea597934691048$var$Z_STREAM_ERROR$2);
    const old_flush = s.last_flush;
    s.last_flush = flush;
    /* Flush as much pending output as possible */ if (s.pending !== 0) {
        $b8ea597934691048$var$flush_pending(strm);
        if (strm.avail_out === 0) {
            /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */ s.last_flush = -1;
            return $b8ea597934691048$var$Z_OK$3;
        }
    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */ } else if (strm.avail_in === 0 && $b8ea597934691048$var$rank(flush) <= $b8ea597934691048$var$rank(old_flush) && flush !== $b8ea597934691048$var$Z_FINISH$3) return $b8ea597934691048$var$err(strm, $b8ea597934691048$var$Z_BUF_ERROR$1);
    /* User must not provide more input after the first FINISH: */ if (s.status === $b8ea597934691048$var$FINISH_STATE && strm.avail_in !== 0) return $b8ea597934691048$var$err(strm, $b8ea597934691048$var$Z_BUF_ERROR$1);
    /* Write the header */ if (s.status === $b8ea597934691048$var$INIT_STATE && s.wrap === 0) s.status = $b8ea597934691048$var$BUSY_STATE;
    if (s.status === $b8ea597934691048$var$INIT_STATE) {
        /* zlib header */ let header = $b8ea597934691048$var$Z_DEFLATED$2 + (s.w_bits - 8 << 4) << 8;
        let level_flags = -1;
        if (s.strategy >= $b8ea597934691048$var$Z_HUFFMAN_ONLY || s.level < 2) level_flags = 0;
        else if (s.level < 6) level_flags = 1;
        else if (s.level === 6) level_flags = 2;
        else level_flags = 3;
        header |= level_flags << 6;
        if (s.strstart !== 0) header |= $b8ea597934691048$var$PRESET_DICT;
        header += 31 - header % 31;
        $b8ea597934691048$var$putShortMSB(s, header);
        /* Save the adler32 of the preset dictionary: */ if (s.strstart !== 0) {
            $b8ea597934691048$var$putShortMSB(s, strm.adler >>> 16);
            $b8ea597934691048$var$putShortMSB(s, strm.adler & 0xffff);
        }
        strm.adler = 1; // adler32(0L, Z_NULL, 0);
        s.status = $b8ea597934691048$var$BUSY_STATE;
        /* Compression must start with an empty pending buffer */ $b8ea597934691048$var$flush_pending(strm);
        if (s.pending !== 0) {
            s.last_flush = -1;
            return $b8ea597934691048$var$Z_OK$3;
        }
    }
    //#ifdef GZIP
    if (s.status === $b8ea597934691048$var$GZIP_STATE) {
        /* gzip header */ strm.adler = 0; //crc32(0L, Z_NULL, 0);
        $b8ea597934691048$var$put_byte(s, 31);
        $b8ea597934691048$var$put_byte(s, 139);
        $b8ea597934691048$var$put_byte(s, 8);
        if (!s.gzhead) {
            $b8ea597934691048$var$put_byte(s, 0);
            $b8ea597934691048$var$put_byte(s, 0);
            $b8ea597934691048$var$put_byte(s, 0);
            $b8ea597934691048$var$put_byte(s, 0);
            $b8ea597934691048$var$put_byte(s, 0);
            $b8ea597934691048$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $b8ea597934691048$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
            $b8ea597934691048$var$put_byte(s, $b8ea597934691048$var$OS_CODE);
            s.status = $b8ea597934691048$var$BUSY_STATE;
            /* Compression must start with an empty pending buffer */ $b8ea597934691048$var$flush_pending(strm);
            if (s.pending !== 0) {
                s.last_flush = -1;
                return $b8ea597934691048$var$Z_OK$3;
            }
        } else {
            $b8ea597934691048$var$put_byte(s, (s.gzhead.text ? 1 : 0) + (s.gzhead.hcrc ? 2 : 0) + (!s.gzhead.extra ? 0 : 4) + (!s.gzhead.name ? 0 : 8) + (!s.gzhead.comment ? 0 : 16));
            $b8ea597934691048$var$put_byte(s, s.gzhead.time & 0xff);
            $b8ea597934691048$var$put_byte(s, s.gzhead.time >> 8 & 0xff);
            $b8ea597934691048$var$put_byte(s, s.gzhead.time >> 16 & 0xff);
            $b8ea597934691048$var$put_byte(s, s.gzhead.time >> 24 & 0xff);
            $b8ea597934691048$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $b8ea597934691048$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
            $b8ea597934691048$var$put_byte(s, s.gzhead.os & 0xff);
            if (s.gzhead.extra && s.gzhead.extra.length) {
                $b8ea597934691048$var$put_byte(s, s.gzhead.extra.length & 0xff);
                $b8ea597934691048$var$put_byte(s, s.gzhead.extra.length >> 8 & 0xff);
            }
            if (s.gzhead.hcrc) strm.adler = $b8ea597934691048$var$crc32_1(strm.adler, s.pending_buf, s.pending, 0);
            s.gzindex = 0;
            s.status = $b8ea597934691048$var$EXTRA_STATE;
        }
    }
    if (s.status === $b8ea597934691048$var$EXTRA_STATE) {
        if (s.gzhead.extra /* != Z_NULL*/ ) {
            let beg = s.pending; /* start of bytes to update crc */ 
            let left = (s.gzhead.extra.length & 0xffff) - s.gzindex;
            while(s.pending + left > s.pending_buf_size){
                let copy = s.pending_buf_size - s.pending;
                // zmemcpy(s.pending_buf + s.pending,
                //    s.gzhead.extra + s.gzindex, copy);
                s.pending_buf.set(s.gzhead.extra.subarray(s.gzindex, s.gzindex + copy), s.pending);
                s.pending = s.pending_buf_size;
                //--- HCRC_UPDATE(beg) ---//
                if (s.gzhead.hcrc && s.pending > beg) strm.adler = $b8ea597934691048$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                //---//
                s.gzindex += copy;
                $b8ea597934691048$var$flush_pending(strm);
                if (s.pending !== 0) {
                    s.last_flush = -1;
                    return $b8ea597934691048$var$Z_OK$3;
                }
                beg = 0;
                left -= copy;
            }
            // JS specific: s.gzhead.extra may be TypedArray or Array for backward compatibility
            //              TypedArray.slice and TypedArray.from don't exist in IE10-IE11
            let gzhead_extra = new Uint8Array(s.gzhead.extra);
            // zmemcpy(s->pending_buf + s->pending,
            //     s->gzhead->extra + s->gzindex, left);
            s.pending_buf.set(gzhead_extra.subarray(s.gzindex, s.gzindex + left), s.pending);
            s.pending += left;
            //--- HCRC_UPDATE(beg) ---//
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $b8ea597934691048$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
            //---//
            s.gzindex = 0;
        }
        s.status = $b8ea597934691048$var$NAME_STATE;
    }
    if (s.status === $b8ea597934691048$var$NAME_STATE) {
        if (s.gzhead.name /* != Z_NULL*/ ) {
            let beg = s.pending; /* start of bytes to update crc */ 
            let val;
            do {
                if (s.pending === s.pending_buf_size) {
                    //--- HCRC_UPDATE(beg) ---//
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $b8ea597934691048$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                    //---//
                    $b8ea597934691048$var$flush_pending(strm);
                    if (s.pending !== 0) {
                        s.last_flush = -1;
                        return $b8ea597934691048$var$Z_OK$3;
                    }
                    beg = 0;
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.name.length) val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $b8ea597934691048$var$put_byte(s, val);
            }while (val !== 0);
            //--- HCRC_UPDATE(beg) ---//
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $b8ea597934691048$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
            //---//
            s.gzindex = 0;
        }
        s.status = $b8ea597934691048$var$COMMENT_STATE;
    }
    if (s.status === $b8ea597934691048$var$COMMENT_STATE) {
        if (s.gzhead.comment /* != Z_NULL*/ ) {
            let beg = s.pending; /* start of bytes to update crc */ 
            let val;
            do {
                if (s.pending === s.pending_buf_size) {
                    //--- HCRC_UPDATE(beg) ---//
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $b8ea597934691048$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                    //---//
                    $b8ea597934691048$var$flush_pending(strm);
                    if (s.pending !== 0) {
                        s.last_flush = -1;
                        return $b8ea597934691048$var$Z_OK$3;
                    }
                    beg = 0;
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.comment.length) val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $b8ea597934691048$var$put_byte(s, val);
            }while (val !== 0);
            //--- HCRC_UPDATE(beg) ---//
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $b8ea597934691048$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
        //---//
        }
        s.status = $b8ea597934691048$var$HCRC_STATE;
    }
    if (s.status === $b8ea597934691048$var$HCRC_STATE) {
        if (s.gzhead.hcrc) {
            if (s.pending + 2 > s.pending_buf_size) {
                $b8ea597934691048$var$flush_pending(strm);
                if (s.pending !== 0) {
                    s.last_flush = -1;
                    return $b8ea597934691048$var$Z_OK$3;
                }
            }
            $b8ea597934691048$var$put_byte(s, strm.adler & 0xff);
            $b8ea597934691048$var$put_byte(s, strm.adler >> 8 & 0xff);
            strm.adler = 0; //crc32(0L, Z_NULL, 0);
        }
        s.status = $b8ea597934691048$var$BUSY_STATE;
        /* Compression must start with an empty pending buffer */ $b8ea597934691048$var$flush_pending(strm);
        if (s.pending !== 0) {
            s.last_flush = -1;
            return $b8ea597934691048$var$Z_OK$3;
        }
    }
    //#endif
    /* Start a new block or continue the current one.
   */ if (strm.avail_in !== 0 || s.lookahead !== 0 || flush !== $b8ea597934691048$var$Z_NO_FLUSH$2 && s.status !== $b8ea597934691048$var$FINISH_STATE) {
        let bstate = s.level === 0 ? $b8ea597934691048$var$deflate_stored(s, flush) : s.strategy === $b8ea597934691048$var$Z_HUFFMAN_ONLY ? $b8ea597934691048$var$deflate_huff(s, flush) : s.strategy === $b8ea597934691048$var$Z_RLE ? $b8ea597934691048$var$deflate_rle(s, flush) : $b8ea597934691048$var$configuration_table[s.level].func(s, flush);
        if (bstate === $b8ea597934691048$var$BS_FINISH_STARTED || bstate === $b8ea597934691048$var$BS_FINISH_DONE) s.status = $b8ea597934691048$var$FINISH_STATE;
        if (bstate === $b8ea597934691048$var$BS_NEED_MORE || bstate === $b8ea597934691048$var$BS_FINISH_STARTED) {
            if (strm.avail_out === 0) s.last_flush = -1;
            return $b8ea597934691048$var$Z_OK$3;
        /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */ }
        if (bstate === $b8ea597934691048$var$BS_BLOCK_DONE) {
            if (flush === $b8ea597934691048$var$Z_PARTIAL_FLUSH) $b8ea597934691048$var$_tr_align(s);
            else if (flush !== $b8ea597934691048$var$Z_BLOCK$1) {
                $b8ea597934691048$var$_tr_stored_block(s, 0, 0, false);
                /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */ if (flush === $b8ea597934691048$var$Z_FULL_FLUSH$1) {
                    /*** CLEAR_HASH(s); ***/ /* forget history */ $b8ea597934691048$var$zero(s.head); // Fill with NIL (= 0);
                    if (s.lookahead === 0) {
                        s.strstart = 0;
                        s.block_start = 0;
                        s.insert = 0;
                    }
                }
            }
            $b8ea597934691048$var$flush_pending(strm);
            if (strm.avail_out === 0) {
                s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */ 
                return $b8ea597934691048$var$Z_OK$3;
            }
        }
    }
    if (flush !== $b8ea597934691048$var$Z_FINISH$3) return $b8ea597934691048$var$Z_OK$3;
    if (s.wrap <= 0) return $b8ea597934691048$var$Z_STREAM_END$3;
    /* Write the trailer */ if (s.wrap === 2) {
        $b8ea597934691048$var$put_byte(s, strm.adler & 0xff);
        $b8ea597934691048$var$put_byte(s, strm.adler >> 8 & 0xff);
        $b8ea597934691048$var$put_byte(s, strm.adler >> 16 & 0xff);
        $b8ea597934691048$var$put_byte(s, strm.adler >> 24 & 0xff);
        $b8ea597934691048$var$put_byte(s, strm.total_in & 0xff);
        $b8ea597934691048$var$put_byte(s, strm.total_in >> 8 & 0xff);
        $b8ea597934691048$var$put_byte(s, strm.total_in >> 16 & 0xff);
        $b8ea597934691048$var$put_byte(s, strm.total_in >> 24 & 0xff);
    } else {
        $b8ea597934691048$var$putShortMSB(s, strm.adler >>> 16);
        $b8ea597934691048$var$putShortMSB(s, strm.adler & 0xffff);
    }
    $b8ea597934691048$var$flush_pending(strm);
    /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */ if (s.wrap > 0) s.wrap = -s.wrap;
    /* write the trailer only once! */ return s.pending !== 0 ? $b8ea597934691048$var$Z_OK$3 : $b8ea597934691048$var$Z_STREAM_END$3;
};
const $b8ea597934691048$var$deflateEnd = (strm)=>{
    if ($b8ea597934691048$var$deflateStateCheck(strm)) return $b8ea597934691048$var$Z_STREAM_ERROR$2;
    const status = strm.state.status;
    strm.state = null;
    return status === $b8ea597934691048$var$BUSY_STATE ? $b8ea597934691048$var$err(strm, $b8ea597934691048$var$Z_DATA_ERROR$2) : $b8ea597934691048$var$Z_OK$3;
};
/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */ const $b8ea597934691048$var$deflateSetDictionary = (strm, dictionary)=>{
    let dictLength = dictionary.length;
    if ($b8ea597934691048$var$deflateStateCheck(strm)) return $b8ea597934691048$var$Z_STREAM_ERROR$2;
    const s = strm.state;
    const wrap = s.wrap;
    if (wrap === 2 || wrap === 1 && s.status !== $b8ea597934691048$var$INIT_STATE || s.lookahead) return $b8ea597934691048$var$Z_STREAM_ERROR$2;
    /* when using zlib wrappers, compute Adler-32 for provided dictionary */ if (wrap === 1) /* adler32(strm->adler, dictionary, dictLength); */ strm.adler = $b8ea597934691048$var$adler32_1(strm.adler, dictionary, dictLength, 0);
    s.wrap = 0; /* avoid computing Adler-32 in read_buf */ 
    /* if dictionary would fill window, just replace the history */ if (dictLength >= s.w_size) {
        if (wrap === 0) {
            /*** CLEAR_HASH(s); ***/ $b8ea597934691048$var$zero(s.head); // Fill with NIL (= 0);
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
        }
        /* use the tail */ // dictionary = dictionary.slice(dictLength - s.w_size);
        let tmpDict = new Uint8Array(s.w_size);
        tmpDict.set(dictionary.subarray(dictLength - s.w_size, dictLength), 0);
        dictionary = tmpDict;
        dictLength = s.w_size;
    }
    /* insert dictionary into window and hash */ const avail = strm.avail_in;
    const next = strm.next_in;
    const input = strm.input;
    strm.avail_in = dictLength;
    strm.next_in = 0;
    strm.input = dictionary;
    $b8ea597934691048$var$fill_window(s);
    while(s.lookahead >= $b8ea597934691048$var$MIN_MATCH){
        let str = s.strstart;
        let n = s.lookahead - ($b8ea597934691048$var$MIN_MATCH - 1);
        do {
            /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = $b8ea597934691048$var$HASH(s, s.ins_h, s.window[str + $b8ea597934691048$var$MIN_MATCH - 1]);
            s.prev[str & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = str;
            str++;
        }while (--n);
        s.strstart = str;
        s.lookahead = $b8ea597934691048$var$MIN_MATCH - 1;
        $b8ea597934691048$var$fill_window(s);
    }
    s.strstart += s.lookahead;
    s.block_start = s.strstart;
    s.insert = s.lookahead;
    s.lookahead = 0;
    s.match_length = s.prev_length = $b8ea597934691048$var$MIN_MATCH - 1;
    s.match_available = 0;
    strm.next_in = next;
    strm.input = input;
    strm.avail_in = avail;
    s.wrap = wrap;
    return $b8ea597934691048$var$Z_OK$3;
};
var $b8ea597934691048$var$deflateInit_1 = $b8ea597934691048$var$deflateInit;
var $b8ea597934691048$var$deflateInit2_1 = $b8ea597934691048$var$deflateInit2;
var $b8ea597934691048$var$deflateReset_1 = $b8ea597934691048$var$deflateReset;
var $b8ea597934691048$var$deflateResetKeep_1 = $b8ea597934691048$var$deflateResetKeep;
var $b8ea597934691048$var$deflateSetHeader_1 = $b8ea597934691048$var$deflateSetHeader;
var $b8ea597934691048$var$deflate_2$1 = $b8ea597934691048$var$deflate$2;
var $b8ea597934691048$var$deflateEnd_1 = $b8ea597934691048$var$deflateEnd;
var $b8ea597934691048$var$deflateSetDictionary_1 = $b8ea597934691048$var$deflateSetDictionary;
var $b8ea597934691048$var$deflateInfo = 'pako deflate (from Nodeca project)';
/* Not implemented
module.exports.deflateBound = deflateBound;
module.exports.deflateCopy = deflateCopy;
module.exports.deflateGetDictionary = deflateGetDictionary;
module.exports.deflateParams = deflateParams;
module.exports.deflatePending = deflatePending;
module.exports.deflatePrime = deflatePrime;
module.exports.deflateTune = deflateTune;
*/ var $b8ea597934691048$var$deflate_1$2 = {
    deflateInit: $b8ea597934691048$var$deflateInit_1,
    deflateInit2: $b8ea597934691048$var$deflateInit2_1,
    deflateReset: $b8ea597934691048$var$deflateReset_1,
    deflateResetKeep: $b8ea597934691048$var$deflateResetKeep_1,
    deflateSetHeader: $b8ea597934691048$var$deflateSetHeader_1,
    deflate: $b8ea597934691048$var$deflate_2$1,
    deflateEnd: $b8ea597934691048$var$deflateEnd_1,
    deflateSetDictionary: $b8ea597934691048$var$deflateSetDictionary_1,
    deflateInfo: $b8ea597934691048$var$deflateInfo
};
const $b8ea597934691048$var$_has = (obj, key)=>{
    return Object.prototype.hasOwnProperty.call(obj, key);
};
var $b8ea597934691048$var$assign = function(obj /*from1, from2, from3, ...*/ ) {
    const sources = Array.prototype.slice.call(arguments, 1);
    while(sources.length){
        const source = sources.shift();
        if (!source) continue;
        if (typeof source !== 'object') throw new TypeError(source + 'must be non-object');
        for(const p in source)if ($b8ea597934691048$var$_has(source, p)) obj[p] = source[p];
    }
    return obj;
};
// Join array of chunks to single array.
var $b8ea597934691048$var$flattenChunks = (chunks)=>{
    // calculate data length
    let len = 0;
    for(let i = 0, l = chunks.length; i < l; i++)len += chunks[i].length;
    // join chunks
    const result = new Uint8Array(len);
    for(let i = 0, pos = 0, l = chunks.length; i < l; i++){
        let chunk = chunks[i];
        result.set(chunk, pos);
        pos += chunk.length;
    }
    return result;
};
var $b8ea597934691048$var$common = {
    assign: $b8ea597934691048$var$assign,
    flattenChunks: $b8ea597934691048$var$flattenChunks
};
// String encode/decode helpers
// Quick check if we can use fast array to bin string conversion
//
// - apply(Array) can fail on Android 2.2
// - apply(Uint8Array) can fail on iOS 5.1 Safari
//
let $b8ea597934691048$var$STR_APPLY_UIA_OK = true;
try {
    String.fromCharCode.apply(null, new Uint8Array(1));
} catch (__) {
    $b8ea597934691048$var$STR_APPLY_UIA_OK = false;
}
// Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
const $b8ea597934691048$var$_utf8len = new Uint8Array(256);
for(let q = 0; q < 256; q++)$b8ea597934691048$var$_utf8len[q] = q >= 252 ? 6 : q >= 248 ? 5 : q >= 240 ? 4 : q >= 224 ? 3 : q >= 192 ? 2 : 1;
$b8ea597934691048$var$_utf8len[254] = $b8ea597934691048$var$_utf8len[254] = 1; // Invalid sequence start
// convert string to array (typed, when possible)
var $b8ea597934691048$var$string2buf = (str)=>{
    if (typeof TextEncoder === 'function' && TextEncoder.prototype.encode) return new TextEncoder().encode(str);
    let buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
    // count binary size
    for(m_pos = 0; m_pos < str_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
    }
    // allocate buffer
    buf = new Uint8Array(buf_len);
    // convert
    for(i = 0, m_pos = 0; i < buf_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        if (c < 0x80) /* one byte */ buf[i++] = c;
        else if (c < 0x800) {
            /* two bytes */ buf[i++] = 0xC0 | c >>> 6;
            buf[i++] = 0x80 | c & 0x3f;
        } else if (c < 0x10000) {
            /* three bytes */ buf[i++] = 0xE0 | c >>> 12;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        } else {
            /* four bytes */ buf[i++] = 0xf0 | c >>> 18;
            buf[i++] = 0x80 | c >>> 12 & 0x3f;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        }
    }
    return buf;
};
// Helper
const $b8ea597934691048$var$buf2binstring = (buf, len)=>{
    // On Chrome, the arguments in a function call that are allowed is `65534`.
    // If the length of the buffer is smaller than that, we can use this optimization,
    // otherwise we will take a slower path.
    if (len < 65534) {
        if (buf.subarray && $b8ea597934691048$var$STR_APPLY_UIA_OK) return String.fromCharCode.apply(null, buf.length === len ? buf : buf.subarray(0, len));
    }
    let result = '';
    for(let i = 0; i < len; i++)result += String.fromCharCode(buf[i]);
    return result;
};
// convert array to string
var $b8ea597934691048$var$buf2string = (buf, max)=>{
    const len = max || buf.length;
    if (typeof TextDecoder === 'function' && TextDecoder.prototype.decode) return new TextDecoder().decode(buf.subarray(0, max));
    let i, out;
    // Reserve max possible length (2 words per char)
    // NB: by unknown reasons, Array is significantly faster for
    //     String.fromCharCode.apply than Uint16Array.
    const utf16buf = new Array(len * 2);
    for(out = 0, i = 0; i < len;){
        let c = buf[i++];
        // quick process ascii
        if (c < 0x80) {
            utf16buf[out++] = c;
            continue;
        }
        let c_len = $b8ea597934691048$var$_utf8len[c];
        // skip 5 & 6 byte codes
        if (c_len > 4) {
            utf16buf[out++] = 0xfffd;
            i += c_len - 1;
            continue;
        }
        // apply mask on first byte
        c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
        // join the rest
        while(c_len > 1 && i < len){
            c = c << 6 | buf[i++] & 0x3f;
            c_len--;
        }
        // terminated by end of string?
        if (c_len > 1) {
            utf16buf[out++] = 0xfffd;
            continue;
        }
        if (c < 0x10000) utf16buf[out++] = c;
        else {
            c -= 0x10000;
            utf16buf[out++] = 0xd800 | c >> 10 & 0x3ff;
            utf16buf[out++] = 0xdc00 | c & 0x3ff;
        }
    }
    return $b8ea597934691048$var$buf2binstring(utf16buf, out);
};
// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
var $b8ea597934691048$var$utf8border = (buf, max)=>{
    max = max || buf.length;
    if (max > buf.length) max = buf.length;
    // go back from last position, until start of sequence found
    let pos = max - 1;
    while(pos >= 0 && (buf[pos] & 0xC0) === 0x80)pos--;
    // Very small and broken sequence,
    // return max, because we should return something anyway.
    if (pos < 0) return max;
    // If we came to start of buffer - that means buffer is too small,
    // return max too.
    if (pos === 0) return max;
    return pos + $b8ea597934691048$var$_utf8len[buf[pos]] > max ? pos : max;
};
var $b8ea597934691048$var$strings = {
    string2buf: $b8ea597934691048$var$string2buf,
    buf2string: $b8ea597934691048$var$buf2string,
    utf8border: $b8ea597934691048$var$utf8border
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $b8ea597934691048$var$ZStream() {
    /* next input byte */ this.input = null; // JS specific, because we have no pointers
    this.next_in = 0;
    /* number of bytes available at input */ this.avail_in = 0;
    /* total number of input bytes read so far */ this.total_in = 0;
    /* next output byte should be put there */ this.output = null; // JS specific, because we have no pointers
    this.next_out = 0;
    /* remaining free space at output */ this.avail_out = 0;
    /* total number of bytes output so far */ this.total_out = 0;
    /* last error message, NULL if no error */ this.msg = '' /*Z_NULL*/ ;
    /* not visible by applications */ this.state = null;
    /* best guess about the data type: binary or text */ this.data_type = 2 /*Z_UNKNOWN*/ ;
    /* adler32 value of the uncompressed data */ this.adler = 0;
}
var $b8ea597934691048$var$zstream = $b8ea597934691048$var$ZStream;
const $b8ea597934691048$var$toString$1 = Object.prototype.toString;
/* Public constants ==========================================================*/ /* ===========================================================================*/ const { Z_NO_FLUSH: $b8ea597934691048$var$Z_NO_FLUSH$1, Z_SYNC_FLUSH: $b8ea597934691048$var$Z_SYNC_FLUSH, Z_FULL_FLUSH: $b8ea597934691048$var$Z_FULL_FLUSH, Z_FINISH: $b8ea597934691048$var$Z_FINISH$2, Z_OK: $b8ea597934691048$var$Z_OK$2, Z_STREAM_END: $b8ea597934691048$var$Z_STREAM_END$2, Z_DEFAULT_COMPRESSION: $b8ea597934691048$var$Z_DEFAULT_COMPRESSION, Z_DEFAULT_STRATEGY: $b8ea597934691048$var$Z_DEFAULT_STRATEGY, Z_DEFLATED: $b8ea597934691048$var$Z_DEFLATED$1 } = $b8ea597934691048$var$constants$2;
/* ===========================================================================*/ /**
 * class Deflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[deflate]],
 * [[deflateRaw]] and [[gzip]].
 **/ /* internal
 * Deflate.chunks -> Array
 *
 * Chunks of output data, if [[Deflate#onData]] not overridden.
 **/ /**
 * Deflate.result -> Uint8Array
 *
 * Compressed result, generated by default [[Deflate#onData]]
 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Deflate#push]] with `Z_FINISH` / `true` param).
 **/ /**
 * Deflate.err -> Number
 *
 * Error code after deflate finished. 0 (Z_OK) on success.
 * You will not need it in real life, because deflate errors
 * are possible only on wrong options or bad `onData` / `onEnd`
 * custom handlers.
 **/ /**
 * Deflate.msg -> String
 *
 * Error message, if [[Deflate.err]] != 0
 **/ /**
 * new Deflate(options)
 * - options (Object): zlib deflate options.
 *
 * Creates new deflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `level`
 * - `windowBits`
 * - `memLevel`
 * - `strategy`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw deflate
 * - `gzip` (Boolean) - create gzip wrapper
 * - `header` (Object) - custom header for gzip
 *   - `text` (Boolean) - true if compressed data believed to be text
 *   - `time` (Number) - modification time, unix timestamp
 *   - `os` (Number) - operation system code
 *   - `extra` (Array) - array of bytes with extra data (max 65536)
 *   - `name` (String) - file name (binary string)
 *   - `comment` (String) - comment (binary string)
 *   - `hcrc` (Boolean) - true if header crc should be added
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 *   , chunk1 = new Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = new Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * const deflate = new pako.Deflate({ level: 3});
 *
 * deflate.push(chunk1, false);
 * deflate.push(chunk2, true);  // true -> last chunk
 *
 * if (deflate.err) { throw new Error(deflate.err); }
 *
 * console.log(deflate.result);
 * ```
 **/ function $b8ea597934691048$var$Deflate$1(options) {
    this.options = $b8ea597934691048$var$common.assign({
        level: $b8ea597934691048$var$Z_DEFAULT_COMPRESSION,
        method: $b8ea597934691048$var$Z_DEFLATED$1,
        chunkSize: 16384,
        windowBits: 15,
        memLevel: 8,
        strategy: $b8ea597934691048$var$Z_DEFAULT_STRATEGY
    }, options || {});
    let opt = this.options;
    if (opt.raw && opt.windowBits > 0) opt.windowBits = -opt.windowBits;
    else if (opt.gzip && opt.windowBits > 0 && opt.windowBits < 16) opt.windowBits += 16;
    this.err = 0; // error code, if happens (0 = Z_OK)
    this.msg = ''; // error message
    this.ended = false; // used to avoid multiple onEnd() calls
    this.chunks = []; // chunks of compressed data
    this.strm = new $b8ea597934691048$var$zstream();
    this.strm.avail_out = 0;
    let status = $b8ea597934691048$var$deflate_1$2.deflateInit2(this.strm, opt.level, opt.method, opt.windowBits, opt.memLevel, opt.strategy);
    if (status !== $b8ea597934691048$var$Z_OK$2) throw new Error($b8ea597934691048$var$messages[status]);
    if (opt.header) $b8ea597934691048$var$deflate_1$2.deflateSetHeader(this.strm, opt.header);
    if (opt.dictionary) {
        let dict;
        // Convert data if needed
        if (typeof opt.dictionary === 'string') // If we need to compress text, change encoding to utf8.
        dict = $b8ea597934691048$var$strings.string2buf(opt.dictionary);
        else if ($b8ea597934691048$var$toString$1.call(opt.dictionary) === '[object ArrayBuffer]') dict = new Uint8Array(opt.dictionary);
        else dict = opt.dictionary;
        status = $b8ea597934691048$var$deflate_1$2.deflateSetDictionary(this.strm, dict);
        if (status !== $b8ea597934691048$var$Z_OK$2) throw new Error($b8ea597934691048$var$messages[status]);
        this._dict_set = true;
    }
}
/**
 * Deflate#push(data[, flush_mode]) -> Boolean
 * - data (Uint8Array|ArrayBuffer|String): input data. Strings will be
 *   converted to utf8 byte sequence.
 * - flush_mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
 * new compressed chunks. Returns `true` on success. The last data block must
 * have `flush_mode` Z_FINISH (or `true`). That will flush internal pending
 * buffers and call [[Deflate#onEnd]].
 *
 * On fail call [[Deflate#onEnd]] with error code and return false.
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ $b8ea597934691048$var$Deflate$1.prototype.push = function(data, flush_mode) {
    const strm = this.strm;
    const chunkSize = this.options.chunkSize;
    let status, _flush_mode;
    if (this.ended) return false;
    if (flush_mode === ~~flush_mode) _flush_mode = flush_mode;
    else _flush_mode = flush_mode === true ? $b8ea597934691048$var$Z_FINISH$2 : $b8ea597934691048$var$Z_NO_FLUSH$1;
    // Convert data if needed
    if (typeof data === 'string') // If we need to compress text, change encoding to utf8.
    strm.input = $b8ea597934691048$var$strings.string2buf(data);
    else if ($b8ea597934691048$var$toString$1.call(data) === '[object ArrayBuffer]') strm.input = new Uint8Array(data);
    else strm.input = data;
    strm.next_in = 0;
    strm.avail_in = strm.input.length;
    for(;;){
        if (strm.avail_out === 0) {
            strm.output = new Uint8Array(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
        }
        // Make sure avail_out > 6 to avoid repeating markers
        if ((_flush_mode === $b8ea597934691048$var$Z_SYNC_FLUSH || _flush_mode === $b8ea597934691048$var$Z_FULL_FLUSH) && strm.avail_out <= 6) {
            this.onData(strm.output.subarray(0, strm.next_out));
            strm.avail_out = 0;
            continue;
        }
        status = $b8ea597934691048$var$deflate_1$2.deflate(strm, _flush_mode);
        // Ended => flush and finish
        if (status === $b8ea597934691048$var$Z_STREAM_END$2) {
            if (strm.next_out > 0) this.onData(strm.output.subarray(0, strm.next_out));
            status = $b8ea597934691048$var$deflate_1$2.deflateEnd(this.strm);
            this.onEnd(status);
            this.ended = true;
            return status === $b8ea597934691048$var$Z_OK$2;
        }
        // Flush if out buffer full
        if (strm.avail_out === 0) {
            this.onData(strm.output);
            continue;
        }
        // Flush if requested and has data
        if (_flush_mode > 0 && strm.next_out > 0) {
            this.onData(strm.output.subarray(0, strm.next_out));
            strm.avail_out = 0;
            continue;
        }
        if (strm.avail_in === 0) break;
    }
    return true;
};
/**
 * Deflate#onData(chunk) -> Void
 * - chunk (Uint8Array): output data.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ $b8ea597934691048$var$Deflate$1.prototype.onData = function(chunk) {
    this.chunks.push(chunk);
};
/**
 * Deflate#onEnd(status) -> Void
 * - status (Number): deflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called once after you tell deflate that the input stream is
 * complete (Z_FINISH). By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ $b8ea597934691048$var$Deflate$1.prototype.onEnd = function(status) {
    // On success - join
    if (status === $b8ea597934691048$var$Z_OK$2) this.result = $b8ea597934691048$var$common.flattenChunks(this.chunks);
    this.chunks = [];
    this.err = status;
    this.msg = this.strm.msg;
};
/**
 * deflate(data[, options]) -> Uint8Array
 * - data (Uint8Array|ArrayBuffer|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * Compress `data` with deflate algorithm and `options`.
 *
 * Supported options are:
 *
 * - level
 * - windowBits
 * - memLevel
 * - strategy
 * - dictionary
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 * const data = new Uint8Array([1,2,3,4,5,6,7,8,9]);
 *
 * console.log(pako.deflate(data));
 * ```
 **/ function $b8ea597934691048$var$deflate$1(input, options) {
    const deflator = new $b8ea597934691048$var$Deflate$1(options);
    deflator.push(input, true);
    // That will never happens, if you don't cheat with options :)
    if (deflator.err) throw deflator.msg || $b8ea597934691048$var$messages[deflator.err];
    return deflator.result;
}
/**
 * deflateRaw(data[, options]) -> Uint8Array
 * - data (Uint8Array|ArrayBuffer|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function $b8ea597934691048$var$deflateRaw$1(input, options) {
    options = options || {};
    options.raw = true;
    return $b8ea597934691048$var$deflate$1(input, options);
}
/**
 * gzip(data[, options]) -> Uint8Array
 * - data (Uint8Array|ArrayBuffer|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but create gzip wrapper instead of
 * deflate one.
 **/ function $b8ea597934691048$var$gzip$1(input, options) {
    options = options || {};
    options.gzip = true;
    return $b8ea597934691048$var$deflate$1(input, options);
}
var $b8ea597934691048$var$Deflate_1$1 = $b8ea597934691048$var$Deflate$1;
var $b8ea597934691048$var$deflate_2 = $b8ea597934691048$var$deflate$1;
var $b8ea597934691048$var$deflateRaw_1$1 = $b8ea597934691048$var$deflateRaw$1;
var $b8ea597934691048$var$gzip_1$1 = $b8ea597934691048$var$gzip$1;
var $b8ea597934691048$var$constants$1 = $b8ea597934691048$var$constants$2;
var $b8ea597934691048$var$deflate_1$1 = {
    Deflate: $b8ea597934691048$var$Deflate_1$1,
    deflate: $b8ea597934691048$var$deflate_2,
    deflateRaw: $b8ea597934691048$var$deflateRaw_1$1,
    gzip: $b8ea597934691048$var$gzip_1$1,
    constants: $b8ea597934691048$var$constants$1
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// See state defs from inflate.js
const $b8ea597934691048$var$BAD$1 = 16209; /* got a data error -- remain here until reset */ 
const $b8ea597934691048$var$TYPE$1 = 16191; /* i: waiting for type bits, including last-flag bit */ 
/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */ var $b8ea597934691048$var$inffast = function inflate_fast(strm, start) {
    let _in; /* local strm.input */ 
    let last; /* have enough input while in < last */ 
    let _out; /* local strm.output */ 
    let beg; /* inflate()'s initial strm.output */ 
    let end; /* while out < end, enough space available */ 
    //#ifdef INFLATE_STRICT
    let dmax; /* maximum distance from zlib header */ 
    //#endif
    let wsize; /* window size or zero if not using window */ 
    let whave; /* valid bytes in the window */ 
    let wnext; /* window write index */ 
    // Use `s_window` instead `window`, avoid conflict with instrumentation tools
    let s_window; /* allocated sliding window, if wsize != 0 */ 
    let hold; /* local strm.hold */ 
    let bits; /* local strm.bits */ 
    let lcode; /* local strm.lencode */ 
    let dcode; /* local strm.distcode */ 
    let lmask; /* mask for first level of length codes */ 
    let dmask; /* mask for first level of distance codes */ 
    let here; /* retrieved table entry */ 
    let op; /* code bits, operation, extra bits, or */ 
    /*  window position, window bytes to copy */ let len; /* match length, unused bytes */ 
    let dist; /* match distance */ 
    let from; /* where to copy match from */ 
    let from_source;
    let input, output; // JS specific, because we have no pointers
    /* copy state to local variables */ const state = strm.state;
    //here = state.here;
    _in = strm.next_in;
    input = strm.input;
    last = _in + (strm.avail_in - 5);
    _out = strm.next_out;
    output = strm.output;
    beg = _out - (start - strm.avail_out);
    end = _out + (strm.avail_out - 257);
    //#ifdef INFLATE_STRICT
    dmax = state.dmax;
    //#endif
    wsize = state.wsize;
    whave = state.whave;
    wnext = state.wnext;
    s_window = state.window;
    hold = state.hold;
    bits = state.bits;
    lcode = state.lencode;
    dcode = state.distcode;
    lmask = (1 << state.lenbits) - 1;
    dmask = (1 << state.distbits) - 1;
    /* decode literals and length/distances until end-of-block or not enough
     input data or output space */ top: do {
        if (bits < 15) {
            hold += input[_in++] << bits;
            bits += 8;
            hold += input[_in++] << bits;
            bits += 8;
        }
        here = lcode[hold & lmask];
        dolen: for(;;){
            op = here >>> 24 /*here.bits*/ ;
            hold >>>= op;
            bits -= op;
            op = here >>> 16 & 0xff /*here.op*/ ;
            if (op === 0) //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
            //        "inflate:         literal '%c'\n" :
            //        "inflate:         literal 0x%02x\n", here.val));
            output[_out++] = here & 0xffff /*here.val*/ ;
            else if (op & 16) {
                len = here & 0xffff /*here.val*/ ;
                op &= 15; /* number of extra bits */ 
                if (op) {
                    if (bits < op) {
                        hold += input[_in++] << bits;
                        bits += 8;
                    }
                    len += hold & (1 << op) - 1;
                    hold >>>= op;
                    bits -= op;
                }
                //Tracevv((stderr, "inflate:         length %u\n", len));
                if (bits < 15) {
                    hold += input[_in++] << bits;
                    bits += 8;
                    hold += input[_in++] << bits;
                    bits += 8;
                }
                here = dcode[hold & dmask];
                dodist: for(;;){
                    op = here >>> 24 /*here.bits*/ ;
                    hold >>>= op;
                    bits -= op;
                    op = here >>> 16 & 0xff /*here.op*/ ;
                    if (op & 16) {
                        dist = here & 0xffff /*here.val*/ ;
                        op &= 15; /* number of extra bits */ 
                        if (bits < op) {
                            hold += input[_in++] << bits;
                            bits += 8;
                            if (bits < op) {
                                hold += input[_in++] << bits;
                                bits += 8;
                            }
                        }
                        dist += hold & (1 << op) - 1;
                        //#ifdef INFLATE_STRICT
                        if (dist > dmax) {
                            strm.msg = 'invalid distance too far back';
                            state.mode = $b8ea597934691048$var$BAD$1;
                            break top;
                        }
                        //#endif
                        hold >>>= op;
                        bits -= op;
                        //Tracevv((stderr, "inflate:         distance %u\n", dist));
                        op = _out - beg; /* max distance in output */ 
                        if (dist > op) {
                            op = dist - op; /* distance back in window */ 
                            if (op > whave) {
                                if (state.sane) {
                                    strm.msg = 'invalid distance too far back';
                                    state.mode = $b8ea597934691048$var$BAD$1;
                                    break top;
                                }
                            }
                            from = 0; // window index
                            from_source = s_window;
                            if (wnext === 0) {
                                from += wsize - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            } else if (wnext < op) {
                                from += wsize + wnext - op;
                                op -= wnext;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = 0;
                                    if (wnext < len) {
                                        op = wnext;
                                        len -= op;
                                        do output[_out++] = s_window[from++];
                                        while (--op);
                                        from = _out - dist; /* rest from output */ 
                                        from_source = output;
                                    }
                                }
                            } else {
                                from += wnext - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            }
                            while(len > 2){
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                len -= 3;
                            }
                            if (len) {
                                output[_out++] = from_source[from++];
                                if (len > 1) output[_out++] = from_source[from++];
                            }
                        } else {
                            from = _out - dist; /* copy direct from output */ 
                            do {
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                len -= 3;
                            }while (len > 2);
                            if (len) {
                                output[_out++] = output[from++];
                                if (len > 1) output[_out++] = output[from++];
                            }
                        }
                    } else if ((op & 64) === 0) {
                        here = dcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                        continue dodist;
                    } else {
                        strm.msg = 'invalid distance code';
                        state.mode = $b8ea597934691048$var$BAD$1;
                        break top;
                    }
                    break; // need to emulate goto via "continue"
                }
            } else if ((op & 64) === 0) {
                here = lcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                continue dolen;
            } else if (op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.mode = $b8ea597934691048$var$TYPE$1;
                break top;
            } else {
                strm.msg = 'invalid literal/length code';
                state.mode = $b8ea597934691048$var$BAD$1;
                break top;
            }
            break; // need to emulate goto via "continue"
        }
    }while (_in < last && _out < end);
    /* return unused bytes (on entry, bits < 8, so in won't go too far back) */ len = bits >> 3;
    _in -= len;
    bits -= len << 3;
    hold &= (1 << bits) - 1;
    /* update state and return */ strm.next_in = _in;
    strm.next_out = _out;
    strm.avail_in = _in < last ? 5 + (last - _in) : 5 - (_in - last);
    strm.avail_out = _out < end ? 257 + (end - _out) : 257 - (_out - end);
    state.hold = hold;
    state.bits = bits;
    return;
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
const $b8ea597934691048$var$MAXBITS = 15;
const $b8ea597934691048$var$ENOUGH_LENS$1 = 852;
const $b8ea597934691048$var$ENOUGH_DISTS$1 = 592;
//const ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
const $b8ea597934691048$var$CODES$1 = 0;
const $b8ea597934691048$var$LENS$1 = 1;
const $b8ea597934691048$var$DISTS$1 = 2;
const $b8ea597934691048$var$lbase = new Uint16Array([
    /* Length codes 257..285 base */ 3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    13,
    15,
    17,
    19,
    23,
    27,
    31,
    35,
    43,
    51,
    59,
    67,
    83,
    99,
    115,
    131,
    163,
    195,
    227,
    258,
    0,
    0
]);
const $b8ea597934691048$var$lext = new Uint8Array([
    /* Length codes 257..285 extra */ 16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    16,
    72,
    78
]);
const $b8ea597934691048$var$dbase = new Uint16Array([
    /* Distance codes 0..29 base */ 1,
    2,
    3,
    4,
    5,
    7,
    9,
    13,
    17,
    25,
    33,
    49,
    65,
    97,
    129,
    193,
    257,
    385,
    513,
    769,
    1025,
    1537,
    2049,
    3073,
    4097,
    6145,
    8193,
    12289,
    16385,
    24577,
    0,
    0
]);
const $b8ea597934691048$var$dext = new Uint8Array([
    /* Distance codes 0..29 extra */ 16,
    16,
    16,
    16,
    17,
    17,
    18,
    18,
    19,
    19,
    20,
    20,
    21,
    21,
    22,
    22,
    23,
    23,
    24,
    24,
    25,
    25,
    26,
    26,
    27,
    27,
    28,
    28,
    29,
    29,
    64,
    64
]);
const $b8ea597934691048$var$inflate_table = (type, lens, lens_index, codes, table, table_index, work, opts)=>{
    const bits = opts.bits;
    //here = opts.here; /* table entry for duplication */
    let len = 0; /* a code's length in bits */ 
    let sym = 0; /* index of code symbols */ 
    let min = 0, max = 0; /* minimum and maximum code lengths */ 
    let root = 0; /* number of index bits for root table */ 
    let curr = 0; /* number of index bits for current table */ 
    let drop = 0; /* code bits to drop for sub-table */ 
    let left = 0; /* number of prefix codes available */ 
    let used = 0; /* code entries in table used */ 
    let huff = 0; /* Huffman code */ 
    let incr; /* for incrementing code, index */ 
    let fill; /* index for replicating entries */ 
    let low; /* low bits for current root entry */ 
    let mask; /* mask for low root bits */ 
    let next; /* next available space in table */ 
    let base = null; /* base value table to use */ 
    //  let shoextra;    /* extra bits table to use */
    let match; /* use base and extra for symbol >= match */ 
    const count = new Uint16Array($b8ea597934691048$var$MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
    const offs = new Uint16Array($b8ea597934691048$var$MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
    let extra = null;
    let here_bits, here_op, here_val;
    /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */ /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */ for(len = 0; len <= $b8ea597934691048$var$MAXBITS; len++)count[len] = 0;
    for(sym = 0; sym < codes; sym++)count[lens[lens_index + sym]]++;
    /* bound code lengths, force root to be within code lengths */ root = bits;
    for(max = $b8ea597934691048$var$MAXBITS; max >= 1; max--){
        if (count[max] !== 0) break;
    }
    if (root > max) root = max;
    if (max === 0) {
        //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
        //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
        //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
        table[table_index++] = 20971520;
        //table.op[opts.table_index] = 64;
        //table.bits[opts.table_index] = 1;
        //table.val[opts.table_index++] = 0;
        table[table_index++] = 20971520;
        opts.bits = 1;
        return 0; /* no symbols, but wait for decoding to report error */ 
    }
    for(min = 1; min < max; min++){
        if (count[min] !== 0) break;
    }
    if (root < min) root = min;
    /* check for an over-subscribed or incomplete set of lengths */ left = 1;
    for(len = 1; len <= $b8ea597934691048$var$MAXBITS; len++){
        left <<= 1;
        left -= count[len];
        if (left < 0) return -1;
         /* over-subscribed */ 
    }
    if (left > 0 && (type === $b8ea597934691048$var$CODES$1 || max !== 1)) return -1; /* incomplete set */ 
    /* generate offsets into symbol table for each length for sorting */ offs[1] = 0;
    for(len = 1; len < $b8ea597934691048$var$MAXBITS; len++)offs[len + 1] = offs[len] + count[len];
    /* sort symbols by length, by symbol order within each length */ for(sym = 0; sym < codes; sym++)if (lens[lens_index + sym] !== 0) work[offs[lens[lens_index + sym]]++] = sym;
    /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */ /* set up for code type */ // poor man optimization - use if-else instead of switch,
    // to avoid deopts in old v8
    if (type === $b8ea597934691048$var$CODES$1) {
        base = extra = work; /* dummy value--not used */ 
        match = 20;
    } else if (type === $b8ea597934691048$var$LENS$1) {
        base = $b8ea597934691048$var$lbase;
        extra = $b8ea597934691048$var$lext;
        match = 257;
    } else {
        base = $b8ea597934691048$var$dbase;
        extra = $b8ea597934691048$var$dext;
        match = 0;
    }
    /* initialize opts for loop */ huff = 0; /* starting code */ 
    sym = 0; /* starting code symbol */ 
    len = min; /* starting code length */ 
    next = table_index; /* current table to fill in */ 
    curr = root; /* current table index bits */ 
    drop = 0; /* current bits to drop from code for index */ 
    low = -1; /* trigger new sub-table when len > root */ 
    used = 1 << root; /* use root table entries */ 
    mask = used - 1; /* mask for comparing low */ 
    /* check available table space */ if (type === $b8ea597934691048$var$LENS$1 && used > $b8ea597934691048$var$ENOUGH_LENS$1 || type === $b8ea597934691048$var$DISTS$1 && used > $b8ea597934691048$var$ENOUGH_DISTS$1) return 1;
    /* process all codes and make table entries */ for(;;){
        /* create table entry */ here_bits = len - drop;
        if (work[sym] + 1 < match) {
            here_op = 0;
            here_val = work[sym];
        } else if (work[sym] >= match) {
            here_op = extra[work[sym] - match];
            here_val = base[work[sym] - match];
        } else {
            here_op = 96; /* end of block */ 
            here_val = 0;
        }
        /* replicate for those indices with low len bits equal to huff */ incr = 1 << len - drop;
        fill = 1 << curr;
        min = fill; /* save offset to next table */ 
        do {
            fill -= incr;
            table[next + (huff >> drop) + fill] = here_bits << 24 | here_op << 16 | here_val | 0;
        }while (fill !== 0);
        /* backwards increment the len-bit code huff */ incr = 1 << len - 1;
        while(huff & incr)incr >>= 1;
        if (incr !== 0) {
            huff &= incr - 1;
            huff += incr;
        } else huff = 0;
        /* go to next symbol, update count, len */ sym++;
        if (--count[len] === 0) {
            if (len === max) break;
            len = lens[lens_index + work[sym]];
        }
        /* create new sub-table if needed */ if (len > root && (huff & mask) !== low) {
            /* if first time, transition to sub-tables */ if (drop === 0) drop = root;
            /* increment past last table */ next += min; /* here min is 1 << curr */ 
            /* determine length of next table */ curr = len - drop;
            left = 1 << curr;
            while(curr + drop < max){
                left -= count[curr + drop];
                if (left <= 0) break;
                curr++;
                left <<= 1;
            }
            /* check for enough space */ used += 1 << curr;
            if (type === $b8ea597934691048$var$LENS$1 && used > $b8ea597934691048$var$ENOUGH_LENS$1 || type === $b8ea597934691048$var$DISTS$1 && used > $b8ea597934691048$var$ENOUGH_DISTS$1) return 1;
            /* point entry in root table to sub-table */ low = huff & mask;
            /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/ table[low] = root << 24 | curr << 16 | next - table_index | 0;
        }
    }
    /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */ if (huff !== 0) //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = len - drop << 24 | 4194304;
    /* set return parameters */ //opts.table_index += used;
    opts.bits = root;
    return 0;
};
var $b8ea597934691048$var$inftrees = $b8ea597934691048$var$inflate_table;
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
const $b8ea597934691048$var$CODES = 0;
const $b8ea597934691048$var$LENS = 1;
const $b8ea597934691048$var$DISTS = 2;
/* Public constants ==========================================================*/ /* ===========================================================================*/ const { Z_FINISH: $b8ea597934691048$var$Z_FINISH$1, Z_BLOCK: $b8ea597934691048$var$Z_BLOCK, Z_TREES: $b8ea597934691048$var$Z_TREES, Z_OK: $b8ea597934691048$var$Z_OK$1, Z_STREAM_END: $b8ea597934691048$var$Z_STREAM_END$1, Z_NEED_DICT: $b8ea597934691048$var$Z_NEED_DICT$1, Z_STREAM_ERROR: $b8ea597934691048$var$Z_STREAM_ERROR$1, Z_DATA_ERROR: $b8ea597934691048$var$Z_DATA_ERROR$1, Z_MEM_ERROR: $b8ea597934691048$var$Z_MEM_ERROR$1, Z_BUF_ERROR: $b8ea597934691048$var$Z_BUF_ERROR, Z_DEFLATED: $b8ea597934691048$var$Z_DEFLATED } = $b8ea597934691048$var$constants$2;
/* STATES ====================================================================*/ /* ===========================================================================*/ const $b8ea597934691048$var$HEAD = 16180; /* i: waiting for magic header */ 
const $b8ea597934691048$var$FLAGS = 16181; /* i: waiting for method and flags (gzip) */ 
const $b8ea597934691048$var$TIME = 16182; /* i: waiting for modification time (gzip) */ 
const $b8ea597934691048$var$OS = 16183; /* i: waiting for extra flags and operating system (gzip) */ 
const $b8ea597934691048$var$EXLEN = 16184; /* i: waiting for extra length (gzip) */ 
const $b8ea597934691048$var$EXTRA = 16185; /* i: waiting for extra bytes (gzip) */ 
const $b8ea597934691048$var$NAME = 16186; /* i: waiting for end of file name (gzip) */ 
const $b8ea597934691048$var$COMMENT = 16187; /* i: waiting for end of comment (gzip) */ 
const $b8ea597934691048$var$HCRC = 16188; /* i: waiting for header crc (gzip) */ 
const $b8ea597934691048$var$DICTID = 16189; /* i: waiting for dictionary check value */ 
const $b8ea597934691048$var$DICT = 16190; /* waiting for inflateSetDictionary() call */ 
const $b8ea597934691048$var$TYPE = 16191; /* i: waiting for type bits, including last-flag bit */ 
const $b8ea597934691048$var$TYPEDO = 16192; /* i: same, but skip check to exit inflate on new block */ 
const $b8ea597934691048$var$STORED = 16193; /* i: waiting for stored size (length and complement) */ 
const $b8ea597934691048$var$COPY_ = 16194; /* i/o: same as COPY below, but only first time in */ 
const $b8ea597934691048$var$COPY = 16195; /* i/o: waiting for input or output to copy stored block */ 
const $b8ea597934691048$var$TABLE = 16196; /* i: waiting for dynamic block table lengths */ 
const $b8ea597934691048$var$LENLENS = 16197; /* i: waiting for code length code lengths */ 
const $b8ea597934691048$var$CODELENS = 16198; /* i: waiting for length/lit and distance code lengths */ 
const $b8ea597934691048$var$LEN_ = 16199; /* i: same as LEN below, but only first time in */ 
const $b8ea597934691048$var$LEN = 16200; /* i: waiting for length/lit/eob code */ 
const $b8ea597934691048$var$LENEXT = 16201; /* i: waiting for length extra bits */ 
const $b8ea597934691048$var$DIST = 16202; /* i: waiting for distance code */ 
const $b8ea597934691048$var$DISTEXT = 16203; /* i: waiting for distance extra bits */ 
const $b8ea597934691048$var$MATCH = 16204; /* o: waiting for output space to copy string */ 
const $b8ea597934691048$var$LIT = 16205; /* o: waiting for output space to write literal */ 
const $b8ea597934691048$var$CHECK = 16206; /* i: waiting for 32-bit check value */ 
const $b8ea597934691048$var$LENGTH = 16207; /* i: waiting for 32-bit length (gzip) */ 
const $b8ea597934691048$var$DONE = 16208; /* finished check, done -- remain here until reset */ 
const $b8ea597934691048$var$BAD = 16209; /* got a data error -- remain here until reset */ 
const $b8ea597934691048$var$MEM = 16210; /* got an inflate() memory error -- remain here until reset */ 
const $b8ea597934691048$var$SYNC = 16211; /* looking for synchronization bytes to restart inflate() */ 
/* ===========================================================================*/ const $b8ea597934691048$var$ENOUGH_LENS = 852;
const $b8ea597934691048$var$ENOUGH_DISTS = 592;
//const ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
const $b8ea597934691048$var$MAX_WBITS = 15;
/* 32K LZ77 window */ const $b8ea597934691048$var$DEF_WBITS = $b8ea597934691048$var$MAX_WBITS;
const $b8ea597934691048$var$zswap32 = (q)=>{
    return (q >>> 24 & 0xff) + (q >>> 8 & 0xff00) + ((q & 0xff00) << 8) + ((q & 0xff) << 24);
};
function $b8ea597934691048$var$InflateState() {
    this.strm = null; /* pointer back to this zlib stream */ 
    this.mode = 0; /* current inflate mode */ 
    this.last = false; /* true if processing last block */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip,
                                 bit 2 true to validate check value */ 
    this.havedict = false; /* true if dictionary provided */ 
    this.flags = 0; /* gzip header method and flags (0 if zlib), or
                                 -1 if raw or no header yet */ 
    this.dmax = 0; /* zlib header max distance (INFLATE_STRICT) */ 
    this.check = 0; /* protected copy of check value */ 
    this.total = 0; /* protected copy of output count */ 
    // TODO: may be {}
    this.head = null; /* where to save gzip header information */ 
    /* sliding window */ this.wbits = 0; /* log base 2 of requested window size */ 
    this.wsize = 0; /* window size or zero if not using window */ 
    this.whave = 0; /* valid bytes in the window */ 
    this.wnext = 0; /* window write index */ 
    this.window = null; /* allocated sliding window, if needed */ 
    /* bit accumulator */ this.hold = 0; /* input bit accumulator */ 
    this.bits = 0; /* number of bits in "in" */ 
    /* for string and stored block copying */ this.length = 0; /* literal or length of data to copy */ 
    this.offset = 0; /* distance back to copy string from */ 
    /* for table and code decoding */ this.extra = 0; /* extra bits needed */ 
    /* fixed and dynamic code tables */ this.lencode = null; /* starting table for length/literal codes */ 
    this.distcode = null; /* starting table for distance codes */ 
    this.lenbits = 0; /* index bits for lencode */ 
    this.distbits = 0; /* index bits for distcode */ 
    /* dynamic table building */ this.ncode = 0; /* number of code length code lengths */ 
    this.nlen = 0; /* number of length code lengths */ 
    this.ndist = 0; /* number of distance code lengths */ 
    this.have = 0; /* number of code lengths in lens[] */ 
    this.next = null; /* next available space in codes[] */ 
    this.lens = new Uint16Array(320); /* temporary storage for code lengths */ 
    this.work = new Uint16Array(288); /* work area for code table building */ 
    /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */ //this.codes = new Int32Array(ENOUGH);       /* space for code tables */
    this.lendyn = null; /* dynamic table for length/literal codes (JS specific) */ 
    this.distdyn = null; /* dynamic table for distance codes (JS specific) */ 
    this.sane = 0; /* if false, allow invalid distance too far */ 
    this.back = 0; /* bits back of last unprocessed length/lit */ 
    this.was = 0; /* initial length of match */ 
}
const $b8ea597934691048$var$inflateStateCheck = (strm)=>{
    if (!strm) return 1;
    const state = strm.state;
    if (!state || state.strm !== strm || state.mode < $b8ea597934691048$var$HEAD || state.mode > $b8ea597934691048$var$SYNC) return 1;
    return 0;
};
const $b8ea597934691048$var$inflateResetKeep = (strm)=>{
    if ($b8ea597934691048$var$inflateStateCheck(strm)) return $b8ea597934691048$var$Z_STREAM_ERROR$1;
    const state = strm.state;
    strm.total_in = strm.total_out = state.total = 0;
    strm.msg = ''; /*Z_NULL*/ 
    if (state.wrap) strm.adler = state.wrap & 1;
    state.mode = $b8ea597934691048$var$HEAD;
    state.last = 0;
    state.havedict = 0;
    state.flags = -1;
    state.dmax = 32768;
    state.head = null /*Z_NULL*/ ;
    state.hold = 0;
    state.bits = 0;
    //state.lencode = state.distcode = state.next = state.codes;
    state.lencode = state.lendyn = new Int32Array($b8ea597934691048$var$ENOUGH_LENS);
    state.distcode = state.distdyn = new Int32Array($b8ea597934691048$var$ENOUGH_DISTS);
    state.sane = 1;
    state.back = -1;
    //Tracev((stderr, "inflate: reset\n"));
    return $b8ea597934691048$var$Z_OK$1;
};
const $b8ea597934691048$var$inflateReset = (strm)=>{
    if ($b8ea597934691048$var$inflateStateCheck(strm)) return $b8ea597934691048$var$Z_STREAM_ERROR$1;
    const state = strm.state;
    state.wsize = 0;
    state.whave = 0;
    state.wnext = 0;
    return $b8ea597934691048$var$inflateResetKeep(strm);
};
const $b8ea597934691048$var$inflateReset2 = (strm, windowBits)=>{
    let wrap;
    /* get the state */ if ($b8ea597934691048$var$inflateStateCheck(strm)) return $b8ea597934691048$var$Z_STREAM_ERROR$1;
    const state = strm.state;
    /* extract wrap request from windowBits parameter */ if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else {
        wrap = (windowBits >> 4) + 5;
        if (windowBits < 48) windowBits &= 15;
    }
    /* set number of window bits, free window if different */ if (windowBits && (windowBits < 8 || windowBits > 15)) return $b8ea597934691048$var$Z_STREAM_ERROR$1;
    if (state.window !== null && state.wbits !== windowBits) state.window = null;
    /* update state and reset the rest of it */ state.wrap = wrap;
    state.wbits = windowBits;
    return $b8ea597934691048$var$inflateReset(strm);
};
const $b8ea597934691048$var$inflateInit2 = (strm, windowBits)=>{
    if (!strm) return $b8ea597934691048$var$Z_STREAM_ERROR$1;
    //strm.msg = Z_NULL;                 /* in case we return an error */
    const state = new $b8ea597934691048$var$InflateState();
    //if (state === Z_NULL) return Z_MEM_ERROR;
    //Tracev((stderr, "inflate: allocated\n"));
    strm.state = state;
    state.strm = strm;
    state.window = null /*Z_NULL*/ ;
    state.mode = $b8ea597934691048$var$HEAD; /* to pass state test in inflateReset2() */ 
    const ret = $b8ea597934691048$var$inflateReset2(strm, windowBits);
    if (ret !== $b8ea597934691048$var$Z_OK$1) strm.state = null /*Z_NULL*/ ;
    return ret;
};
const $b8ea597934691048$var$inflateInit = (strm)=>{
    return $b8ea597934691048$var$inflateInit2(strm, $b8ea597934691048$var$DEF_WBITS);
};
/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */ let $b8ea597934691048$var$virgin = true;
let $b8ea597934691048$var$lenfix, $b8ea597934691048$var$distfix; // We have no pointers in JS, so keep tables separate
const $b8ea597934691048$var$fixedtables = (state)=>{
    /* build fixed huffman tables if first call (may not be thread safe) */ if ($b8ea597934691048$var$virgin) {
        $b8ea597934691048$var$lenfix = new Int32Array(512);
        $b8ea597934691048$var$distfix = new Int32Array(32);
        /* literal/length table */ let sym = 0;
        while(sym < 144)state.lens[sym++] = 8;
        while(sym < 256)state.lens[sym++] = 9;
        while(sym < 280)state.lens[sym++] = 7;
        while(sym < 288)state.lens[sym++] = 8;
        $b8ea597934691048$var$inftrees($b8ea597934691048$var$LENS, state.lens, 0, 288, $b8ea597934691048$var$lenfix, 0, state.work, {
            bits: 9
        });
        /* distance table */ sym = 0;
        while(sym < 32)state.lens[sym++] = 5;
        $b8ea597934691048$var$inftrees($b8ea597934691048$var$DISTS, state.lens, 0, 32, $b8ea597934691048$var$distfix, 0, state.work, {
            bits: 5
        });
        /* do this just once */ $b8ea597934691048$var$virgin = false;
    }
    state.lencode = $b8ea597934691048$var$lenfix;
    state.lenbits = 9;
    state.distcode = $b8ea597934691048$var$distfix;
    state.distbits = 5;
};
/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */ const $b8ea597934691048$var$updatewindow = (strm, src, end, copy)=>{
    let dist;
    const state = strm.state;
    /* if it hasn't been done already, allocate space for the window */ if (state.window === null) {
        state.wsize = 1 << state.wbits;
        state.wnext = 0;
        state.whave = 0;
        state.window = new Uint8Array(state.wsize);
    }
    /* copy state->wsize or less output bytes into the circular window */ if (copy >= state.wsize) {
        state.window.set(src.subarray(end - state.wsize, end), 0);
        state.wnext = 0;
        state.whave = state.wsize;
    } else {
        dist = state.wsize - state.wnext;
        if (dist > copy) dist = copy;
        //zmemcpy(state->window + state->wnext, end - copy, dist);
        state.window.set(src.subarray(end - copy, end - copy + dist), state.wnext);
        copy -= dist;
        if (copy) {
            //zmemcpy(state->window, end - copy, copy);
            state.window.set(src.subarray(end - copy, end), 0);
            state.wnext = copy;
            state.whave = state.wsize;
        } else {
            state.wnext += dist;
            if (state.wnext === state.wsize) state.wnext = 0;
            if (state.whave < state.wsize) state.whave += dist;
        }
    }
    return 0;
};
const $b8ea597934691048$var$inflate$2 = (strm, flush)=>{
    let state;
    let input, output; // input/output buffers
    let next; /* next input INDEX */ 
    let put; /* next output INDEX */ 
    let have, left; /* available input and output */ 
    let hold; /* bit buffer */ 
    let bits; /* bits in bit buffer */ 
    let _in, _out; /* save starting available input and output */ 
    let copy; /* number of stored or match bytes to copy */ 
    let from; /* where to copy match bytes from */ 
    let from_source;
    let here = 0; /* current decoding table entry */ 
    let here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
    //let last;                   /* parent table entry */
    let last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
    let len; /* length to copy for repeats, bits to drop */ 
    let ret; /* return code */ 
    const hbuf = new Uint8Array(4); /* buffer for gzip header crc calculation */ 
    let opts;
    let n; // temporary variable for NEED_BITS
    const order = /* permutation of code lengths */ new Uint8Array([
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
    ]);
    if ($b8ea597934691048$var$inflateStateCheck(strm) || !strm.output || !strm.input && strm.avail_in !== 0) return $b8ea597934691048$var$Z_STREAM_ERROR$1;
    state = strm.state;
    if (state.mode === $b8ea597934691048$var$TYPE) state.mode = $b8ea597934691048$var$TYPEDO;
     /* skip check */ 
    //--- LOAD() ---
    put = strm.next_out;
    output = strm.output;
    left = strm.avail_out;
    next = strm.next_in;
    input = strm.input;
    have = strm.avail_in;
    hold = state.hold;
    bits = state.bits;
    //---
    _in = have;
    _out = left;
    ret = $b8ea597934691048$var$Z_OK$1;
    inf_leave: for(;;)switch(state.mode){
        case $b8ea597934691048$var$HEAD:
            if (state.wrap === 0) {
                state.mode = $b8ea597934691048$var$TYPEDO;
                break;
            }
            //=== NEEDBITS(16);
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.wrap & 2 && hold === 0x8b1f) {
                if (state.wbits === 0) state.wbits = 15;
                state.check = 0 /*crc32(0L, Z_NULL, 0)*/ ;
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $b8ea597934691048$var$crc32_1(state.check, hbuf, 2, 0);
                //===//
                //=== INITBITS();
                hold = 0;
                bits = 0;
                //===//
                state.mode = $b8ea597934691048$var$FLAGS;
                break;
            }
            if (state.head) state.head.done = false;
            if (!(state.wrap & 1) || /* check if zlib header allowed */ (((hold & 0xff) << 8) + (hold >> 8)) % 31) {
                strm.msg = 'incorrect header check';
                state.mode = $b8ea597934691048$var$BAD;
                break;
            }
            if ((hold & 0x0f) !== $b8ea597934691048$var$Z_DEFLATED) {
                strm.msg = 'unknown compression method';
                state.mode = $b8ea597934691048$var$BAD;
                break;
            }
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            len = (hold & 0x0f) + 8;
            if (state.wbits === 0) state.wbits = len;
            if (len > 15 || len > state.wbits) {
                strm.msg = 'invalid window size';
                state.mode = $b8ea597934691048$var$BAD;
                break;
            }
            // !!! pako patch. Force use `options.windowBits` if passed.
            // Required to always use max window size by default.
            state.dmax = 1 << state.wbits;
            //state.dmax = 1 << len;
            state.flags = 0; /* indicate zlib header */ 
            //Tracev((stderr, "inflate:   zlib header ok\n"));
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = hold & 0x200 ? $b8ea597934691048$var$DICTID : $b8ea597934691048$var$TYPE;
            //=== INITBITS();
            hold = 0;
            bits = 0;
            break;
        case $b8ea597934691048$var$FLAGS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.flags = hold;
            if ((state.flags & 0xff) !== $b8ea597934691048$var$Z_DEFLATED) {
                strm.msg = 'unknown compression method';
                state.mode = $b8ea597934691048$var$BAD;
                break;
            }
            if (state.flags & 0xe000) {
                strm.msg = 'unknown header flags set';
                state.mode = $b8ea597934691048$var$BAD;
                break;
            }
            if (state.head) state.head.text = hold >> 8 & 1;
            if (state.flags & 0x0200 && state.wrap & 4) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $b8ea597934691048$var$crc32_1(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $b8ea597934691048$var$TIME;
        /* falls through */ case $b8ea597934691048$var$TIME:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) state.head.time = hold;
            if (state.flags & 0x0200 && state.wrap & 4) {
                //=== CRC4(state.check, hold)
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                hbuf[2] = hold >>> 16 & 0xff;
                hbuf[3] = hold >>> 24 & 0xff;
                state.check = $b8ea597934691048$var$crc32_1(state.check, hbuf, 4, 0);
            //===
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $b8ea597934691048$var$OS;
        /* falls through */ case $b8ea597934691048$var$OS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) {
                state.head.xflags = hold & 0xff;
                state.head.os = hold >> 8;
            }
            if (state.flags & 0x0200 && state.wrap & 4) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $b8ea597934691048$var$crc32_1(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $b8ea597934691048$var$EXLEN;
        /* falls through */ case $b8ea597934691048$var$EXLEN:
            if (state.flags & 0x0400) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length = hold;
                if (state.head) state.head.extra_len = hold;
                if (state.flags & 0x0200 && state.wrap & 4) {
                    //=== CRC2(state.check, hold);
                    hbuf[0] = hold & 0xff;
                    hbuf[1] = hold >>> 8 & 0xff;
                    state.check = $b8ea597934691048$var$crc32_1(state.check, hbuf, 2, 0);
                //===//
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            } else if (state.head) state.head.extra = null /*Z_NULL*/ ;
            state.mode = $b8ea597934691048$var$EXTRA;
        /* falls through */ case $b8ea597934691048$var$EXTRA:
            if (state.flags & 0x0400) {
                copy = state.length;
                if (copy > have) copy = have;
                if (copy) {
                    if (state.head) {
                        len = state.head.extra_len - state.length;
                        if (!state.head.extra) // Use untyped array for more convenient processing later
                        state.head.extra = new Uint8Array(state.head.extra_len);
                        state.head.extra.set(input.subarray(next, // extra field is limited to 65536 bytes
                        // - no need for additional size check
                        next + copy), /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/ len);
                    //zmemcpy(state.head.extra + len, next,
                    //        len + copy > state.head.extra_max ?
                    //        state.head.extra_max - len : copy);
                    }
                    if (state.flags & 0x0200 && state.wrap & 4) state.check = $b8ea597934691048$var$crc32_1(state.check, input, copy, next);
                    have -= copy;
                    next += copy;
                    state.length -= copy;
                }
                if (state.length) break inf_leave;
            }
            state.length = 0;
            state.mode = $b8ea597934691048$var$NAME;
        /* falls through */ case $b8ea597934691048$var$NAME:
            if (state.flags & 0x0800) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    // TODO: 2 or 1 bytes?
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.name_max*/ ) state.head.name += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200 && state.wrap & 4) state.check = $b8ea597934691048$var$crc32_1(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.name = null;
            state.length = 0;
            state.mode = $b8ea597934691048$var$COMMENT;
        /* falls through */ case $b8ea597934691048$var$COMMENT:
            if (state.flags & 0x1000) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.comm_max*/ ) state.head.comment += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200 && state.wrap & 4) state.check = $b8ea597934691048$var$crc32_1(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.comment = null;
            state.mode = $b8ea597934691048$var$HCRC;
        /* falls through */ case $b8ea597934691048$var$HCRC:
            if (state.flags & 0x0200) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (state.wrap & 4 && hold !== (state.check & 0xffff)) {
                    strm.msg = 'header crc mismatch';
                    state.mode = $b8ea597934691048$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            }
            if (state.head) {
                state.head.hcrc = state.flags >> 9 & 1;
                state.head.done = true;
            }
            strm.adler = state.check = 0;
            state.mode = $b8ea597934691048$var$TYPE;
            break;
        case $b8ea597934691048$var$DICTID:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            strm.adler = state.check = $b8ea597934691048$var$zswap32(hold);
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $b8ea597934691048$var$DICT;
        /* falls through */ case $b8ea597934691048$var$DICT:
            if (state.havedict === 0) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                return $b8ea597934691048$var$Z_NEED_DICT$1;
            }
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = $b8ea597934691048$var$TYPE;
        /* falls through */ case $b8ea597934691048$var$TYPE:
            if (flush === $b8ea597934691048$var$Z_BLOCK || flush === $b8ea597934691048$var$Z_TREES) break inf_leave;
        /* falls through */ case $b8ea597934691048$var$TYPEDO:
            if (state.last) {
                //--- BYTEBITS() ---//
                hold >>>= bits & 7;
                bits -= bits & 7;
                //---//
                state.mode = $b8ea597934691048$var$CHECK;
                break;
            }
            //=== NEEDBITS(3); */
            while(bits < 3){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.last = hold & 0x01 /*BITS(1)*/ ;
            //--- DROPBITS(1) ---//
            hold >>>= 1;
            bits -= 1;
            //---//
            switch(hold & 0x03){
                case 0:
                    /* stored block */ //Tracev((stderr, "inflate:     stored block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $b8ea597934691048$var$STORED;
                    break;
                case 1:
                    /* fixed block */ $b8ea597934691048$var$fixedtables(state);
                    //Tracev((stderr, "inflate:     fixed codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $b8ea597934691048$var$LEN_; /* decode codes */ 
                    if (flush === $b8ea597934691048$var$Z_TREES) {
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                        break inf_leave;
                    }
                    break;
                case 2:
                    /* dynamic block */ //Tracev((stderr, "inflate:     dynamic codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $b8ea597934691048$var$TABLE;
                    break;
                case 3:
                    strm.msg = 'invalid block type';
                    state.mode = $b8ea597934691048$var$BAD;
            }
            //--- DROPBITS(2) ---//
            hold >>>= 2;
            bits -= 2;
            break;
        case $b8ea597934691048$var$STORED:
            //--- BYTEBITS() ---// /* go to byte boundary */
            hold >>>= bits & 7;
            bits -= bits & 7;
            //---//
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if ((hold & 0xffff) !== (hold >>> 16 ^ 0xffff)) {
                strm.msg = 'invalid stored block lengths';
                state.mode = $b8ea597934691048$var$BAD;
                break;
            }
            state.length = hold & 0xffff;
            //Tracev((stderr, "inflate:       stored length %u\n",
            //        state.length));
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $b8ea597934691048$var$COPY_;
            if (flush === $b8ea597934691048$var$Z_TREES) break inf_leave;
        /* falls through */ case $b8ea597934691048$var$COPY_:
            state.mode = $b8ea597934691048$var$COPY;
        /* falls through */ case $b8ea597934691048$var$COPY:
            copy = state.length;
            if (copy) {
                if (copy > have) copy = have;
                if (copy > left) copy = left;
                if (copy === 0) break inf_leave;
                //--- zmemcpy(put, next, copy); ---
                output.set(input.subarray(next, next + copy), put);
                //---//
                have -= copy;
                next += copy;
                left -= copy;
                put += copy;
                state.length -= copy;
                break;
            }
            //Tracev((stderr, "inflate:       stored end\n"));
            state.mode = $b8ea597934691048$var$TYPE;
            break;
        case $b8ea597934691048$var$TABLE:
            //=== NEEDBITS(14); */
            while(bits < 14){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.nlen = (hold & 0x1f) + 257;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ndist = (hold & 0x1f) + 1;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ncode = (hold & 0x0f) + 4;
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            //#ifndef PKZIP_BUG_WORKAROUND
            if (state.nlen > 286 || state.ndist > 30) {
                strm.msg = 'too many length or distance symbols';
                state.mode = $b8ea597934691048$var$BAD;
                break;
            }
            //#endif
            //Tracev((stderr, "inflate:       table sizes ok\n"));
            state.have = 0;
            state.mode = $b8ea597934691048$var$LENLENS;
        /* falls through */ case $b8ea597934691048$var$LENLENS:
            while(state.have < state.ncode){
                //=== NEEDBITS(3);
                while(bits < 3){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.lens[order[state.have++]] = hold & 0x07; //BITS(3);
                //--- DROPBITS(3) ---//
                hold >>>= 3;
                bits -= 3;
            //---//
            }
            while(state.have < 19)state.lens[order[state.have++]] = 0;
            // We have separate tables & no pointers. 2 commented lines below not needed.
            //state.next = state.codes;
            //state.lencode = state.next;
            // Switch to use dynamic table
            state.lencode = state.lendyn;
            state.lenbits = 7;
            opts = {
                bits: state.lenbits
            };
            ret = $b8ea597934691048$var$inftrees($b8ea597934691048$var$CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
            state.lenbits = opts.bits;
            if (ret) {
                strm.msg = 'invalid code lengths set';
                state.mode = $b8ea597934691048$var$BAD;
                break;
            }
            //Tracev((stderr, "inflate:       code lengths ok\n"));
            state.have = 0;
            state.mode = $b8ea597934691048$var$CODELENS;
        /* falls through */ case $b8ea597934691048$var$CODELENS:
            while(state.have < state.nlen + state.ndist){
                for(;;){
                    here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                if (here_val < 16) {
                    //--- DROPBITS(here.bits) ---//
                    hold >>>= here_bits;
                    bits -= here_bits;
                    //---//
                    state.lens[state.have++] = here_val;
                } else {
                    if (here_val === 16) {
                        //=== NEEDBITS(here.bits + 2);
                        n = here_bits + 2;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        if (state.have === 0) {
                            strm.msg = 'invalid bit length repeat';
                            state.mode = $b8ea597934691048$var$BAD;
                            break;
                        }
                        len = state.lens[state.have - 1];
                        copy = 3 + (hold & 0x03); //BITS(2);
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                    //---//
                    } else if (here_val === 17) {
                        //=== NEEDBITS(here.bits + 3);
                        n = here_bits + 3;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 3 + (hold & 0x07); //BITS(3);
                        //--- DROPBITS(3) ---//
                        hold >>>= 3;
                        bits -= 3;
                    //---//
                    } else {
                        //=== NEEDBITS(here.bits + 7);
                        n = here_bits + 7;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 11 + (hold & 0x7f); //BITS(7);
                        //--- DROPBITS(7) ---//
                        hold >>>= 7;
                        bits -= 7;
                    //---//
                    }
                    if (state.have + copy > state.nlen + state.ndist) {
                        strm.msg = 'invalid bit length repeat';
                        state.mode = $b8ea597934691048$var$BAD;
                        break;
                    }
                    while(copy--)state.lens[state.have++] = len;
                }
            }
            /* handle error breaks in while */ if (state.mode === $b8ea597934691048$var$BAD) break;
            /* check for end-of-block code (better have one) */ if (state.lens[256] === 0) {
                strm.msg = 'invalid code -- missing end-of-block';
                state.mode = $b8ea597934691048$var$BAD;
                break;
            }
            /* build code tables -- note: do not change the lenbits or distbits
           values here (9 and 6) without reading the comments in inftrees.h
           concerning the ENOUGH constants, which depend on those values */ state.lenbits = 9;
            opts = {
                bits: state.lenbits
            };
            ret = $b8ea597934691048$var$inftrees($b8ea597934691048$var$LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.lenbits = opts.bits;
            // state.lencode = state.next;
            if (ret) {
                strm.msg = 'invalid literal/lengths set';
                state.mode = $b8ea597934691048$var$BAD;
                break;
            }
            state.distbits = 6;
            //state.distcode.copy(state.codes);
            // Switch to use dynamic table
            state.distcode = state.distdyn;
            opts = {
                bits: state.distbits
            };
            ret = $b8ea597934691048$var$inftrees($b8ea597934691048$var$DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.distbits = opts.bits;
            // state.distcode = state.next;
            if (ret) {
                strm.msg = 'invalid distances set';
                state.mode = $b8ea597934691048$var$BAD;
                break;
            }
            //Tracev((stderr, 'inflate:       codes ok\n'));
            state.mode = $b8ea597934691048$var$LEN_;
            if (flush === $b8ea597934691048$var$Z_TREES) break inf_leave;
        /* falls through */ case $b8ea597934691048$var$LEN_:
            state.mode = $b8ea597934691048$var$LEN;
        /* falls through */ case $b8ea597934691048$var$LEN:
            if (have >= 6 && left >= 258) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                $b8ea597934691048$var$inffast(strm, _out);
                //--- LOAD() ---
                put = strm.next_out;
                output = strm.output;
                left = strm.avail_out;
                next = strm.next_in;
                input = strm.input;
                have = strm.avail_in;
                hold = state.hold;
                bits = state.bits;
                //---
                if (state.mode === $b8ea597934691048$var$TYPE) state.back = -1;
                break;
            }
            state.back = 0;
            for(;;){
                here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if (here_op && (here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.lencode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            state.length = here_val;
            if (here_op === 0) {
                //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
                //        "inflate:         literal '%c'\n" :
                //        "inflate:         literal 0x%02x\n", here.val));
                state.mode = $b8ea597934691048$var$LIT;
                break;
            }
            if (here_op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.back = -1;
                state.mode = $b8ea597934691048$var$TYPE;
                break;
            }
            if (here_op & 64) {
                strm.msg = 'invalid literal/length code';
                state.mode = $b8ea597934691048$var$BAD;
                break;
            }
            state.extra = here_op & 15;
            state.mode = $b8ea597934691048$var$LENEXT;
        /* falls through */ case $b8ea597934691048$var$LENEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //Tracevv((stderr, "inflate:         length %u\n", state.length));
            state.was = state.length;
            state.mode = $b8ea597934691048$var$DIST;
        /* falls through */ case $b8ea597934691048$var$DIST:
            for(;;){
                here = state.distcode[hold & (1 << state.distbits) - 1]; /*BITS(state.distbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if ((here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.distcode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            if (here_op & 64) {
                strm.msg = 'invalid distance code';
                state.mode = $b8ea597934691048$var$BAD;
                break;
            }
            state.offset = here_val;
            state.extra = here_op & 15;
            state.mode = $b8ea597934691048$var$DISTEXT;
        /* falls through */ case $b8ea597934691048$var$DISTEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.offset += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //#ifdef INFLATE_STRICT
            if (state.offset > state.dmax) {
                strm.msg = 'invalid distance too far back';
                state.mode = $b8ea597934691048$var$BAD;
                break;
            }
            //#endif
            //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
            state.mode = $b8ea597934691048$var$MATCH;
        /* falls through */ case $b8ea597934691048$var$MATCH:
            if (left === 0) break inf_leave;
            copy = _out - left;
            if (state.offset > copy) {
                copy = state.offset - copy;
                if (copy > state.whave) {
                    if (state.sane) {
                        strm.msg = 'invalid distance too far back';
                        state.mode = $b8ea597934691048$var$BAD;
                        break;
                    }
                }
                if (copy > state.wnext) {
                    copy -= state.wnext;
                    from = state.wsize - copy;
                } else from = state.wnext - copy;
                if (copy > state.length) copy = state.length;
                from_source = state.window;
            } else {
                from_source = output;
                from = put - state.offset;
                copy = state.length;
            }
            if (copy > left) copy = left;
            left -= copy;
            state.length -= copy;
            do output[put++] = from_source[from++];
            while (--copy);
            if (state.length === 0) state.mode = $b8ea597934691048$var$LEN;
            break;
        case $b8ea597934691048$var$LIT:
            if (left === 0) break inf_leave;
            output[put++] = state.length;
            left--;
            state.mode = $b8ea597934691048$var$LEN;
            break;
        case $b8ea597934691048$var$CHECK:
            if (state.wrap) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    // Use '|' instead of '+' to make sure that result is signed
                    hold |= input[next++] << bits;
                    bits += 8;
                }
                //===//
                _out -= left;
                strm.total_out += _out;
                state.total += _out;
                if (state.wrap & 4 && _out) strm.adler = state.check = /*UPDATE_CHECK(state.check, put - _out, _out);*/ state.flags ? $b8ea597934691048$var$crc32_1(state.check, output, _out, put - _out) : $b8ea597934691048$var$adler32_1(state.check, output, _out, put - _out);
                _out = left;
                // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
                if (state.wrap & 4 && (state.flags ? hold : $b8ea597934691048$var$zswap32(hold)) !== state.check) {
                    strm.msg = 'incorrect data check';
                    state.mode = $b8ea597934691048$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   check matches trailer\n"));
            }
            state.mode = $b8ea597934691048$var$LENGTH;
        /* falls through */ case $b8ea597934691048$var$LENGTH:
            if (state.wrap && state.flags) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (state.wrap & 4 && hold !== (state.total & 0xffffffff)) {
                    strm.msg = 'incorrect length check';
                    state.mode = $b8ea597934691048$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   length matches trailer\n"));
            }
            state.mode = $b8ea597934691048$var$DONE;
        /* falls through */ case $b8ea597934691048$var$DONE:
            ret = $b8ea597934691048$var$Z_STREAM_END$1;
            break inf_leave;
        case $b8ea597934691048$var$BAD:
            ret = $b8ea597934691048$var$Z_DATA_ERROR$1;
            break inf_leave;
        case $b8ea597934691048$var$MEM:
            return $b8ea597934691048$var$Z_MEM_ERROR$1;
        case $b8ea597934691048$var$SYNC:
        /* falls through */ default:
            return $b8ea597934691048$var$Z_STREAM_ERROR$1;
    }
    // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
    /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */ //--- RESTORE() ---
    strm.next_out = put;
    strm.avail_out = left;
    strm.next_in = next;
    strm.avail_in = have;
    state.hold = hold;
    state.bits = bits;
    //---
    if (state.wsize || _out !== strm.avail_out && state.mode < $b8ea597934691048$var$BAD && (state.mode < $b8ea597934691048$var$CHECK || flush !== $b8ea597934691048$var$Z_FINISH$1)) $b8ea597934691048$var$updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out);
    _in -= strm.avail_in;
    _out -= strm.avail_out;
    strm.total_in += _in;
    strm.total_out += _out;
    state.total += _out;
    if (state.wrap & 4 && _out) strm.adler = state.check = /*UPDATE_CHECK(state.check, strm.next_out - _out, _out);*/ state.flags ? $b8ea597934691048$var$crc32_1(state.check, output, _out, strm.next_out - _out) : $b8ea597934691048$var$adler32_1(state.check, output, _out, strm.next_out - _out);
    strm.data_type = state.bits + (state.last ? 64 : 0) + (state.mode === $b8ea597934691048$var$TYPE ? 128 : 0) + (state.mode === $b8ea597934691048$var$LEN_ || state.mode === $b8ea597934691048$var$COPY_ ? 256 : 0);
    if ((_in === 0 && _out === 0 || flush === $b8ea597934691048$var$Z_FINISH$1) && ret === $b8ea597934691048$var$Z_OK$1) ret = $b8ea597934691048$var$Z_BUF_ERROR;
    return ret;
};
const $b8ea597934691048$var$inflateEnd = (strm)=>{
    if ($b8ea597934691048$var$inflateStateCheck(strm)) return $b8ea597934691048$var$Z_STREAM_ERROR$1;
    let state = strm.state;
    if (state.window) state.window = null;
    strm.state = null;
    return $b8ea597934691048$var$Z_OK$1;
};
const $b8ea597934691048$var$inflateGetHeader = (strm, head)=>{
    /* check state */ if ($b8ea597934691048$var$inflateStateCheck(strm)) return $b8ea597934691048$var$Z_STREAM_ERROR$1;
    const state = strm.state;
    if ((state.wrap & 2) === 0) return $b8ea597934691048$var$Z_STREAM_ERROR$1;
    /* save header structure */ state.head = head;
    head.done = false;
    return $b8ea597934691048$var$Z_OK$1;
};
const $b8ea597934691048$var$inflateSetDictionary = (strm, dictionary)=>{
    const dictLength = dictionary.length;
    let state;
    let dictid;
    let ret;
    /* check state */ if ($b8ea597934691048$var$inflateStateCheck(strm)) return $b8ea597934691048$var$Z_STREAM_ERROR$1;
    state = strm.state;
    if (state.wrap !== 0 && state.mode !== $b8ea597934691048$var$DICT) return $b8ea597934691048$var$Z_STREAM_ERROR$1;
    /* check for correct dictionary identifier */ if (state.mode === $b8ea597934691048$var$DICT) {
        dictid = 1; /* adler32(0, null, 0)*/ 
        /* dictid = adler32(dictid, dictionary, dictLength); */ dictid = $b8ea597934691048$var$adler32_1(dictid, dictionary, dictLength, 0);
        if (dictid !== state.check) return $b8ea597934691048$var$Z_DATA_ERROR$1;
    }
    /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */ ret = $b8ea597934691048$var$updatewindow(strm, dictionary, dictLength, dictLength);
    if (ret) {
        state.mode = $b8ea597934691048$var$MEM;
        return $b8ea597934691048$var$Z_MEM_ERROR$1;
    }
    state.havedict = 1;
    // Tracev((stderr, "inflate:   dictionary set\n"));
    return $b8ea597934691048$var$Z_OK$1;
};
var $b8ea597934691048$var$inflateReset_1 = $b8ea597934691048$var$inflateReset;
var $b8ea597934691048$var$inflateReset2_1 = $b8ea597934691048$var$inflateReset2;
var $b8ea597934691048$var$inflateResetKeep_1 = $b8ea597934691048$var$inflateResetKeep;
var $b8ea597934691048$var$inflateInit_1 = $b8ea597934691048$var$inflateInit;
var $b8ea597934691048$var$inflateInit2_1 = $b8ea597934691048$var$inflateInit2;
var $b8ea597934691048$var$inflate_2$1 = $b8ea597934691048$var$inflate$2;
var $b8ea597934691048$var$inflateEnd_1 = $b8ea597934691048$var$inflateEnd;
var $b8ea597934691048$var$inflateGetHeader_1 = $b8ea597934691048$var$inflateGetHeader;
var $b8ea597934691048$var$inflateSetDictionary_1 = $b8ea597934691048$var$inflateSetDictionary;
var $b8ea597934691048$var$inflateInfo = 'pako inflate (from Nodeca project)';
/* Not implemented
module.exports.inflateCodesUsed = inflateCodesUsed;
module.exports.inflateCopy = inflateCopy;
module.exports.inflateGetDictionary = inflateGetDictionary;
module.exports.inflateMark = inflateMark;
module.exports.inflatePrime = inflatePrime;
module.exports.inflateSync = inflateSync;
module.exports.inflateSyncPoint = inflateSyncPoint;
module.exports.inflateUndermine = inflateUndermine;
module.exports.inflateValidate = inflateValidate;
*/ var $b8ea597934691048$var$inflate_1$2 = {
    inflateReset: $b8ea597934691048$var$inflateReset_1,
    inflateReset2: $b8ea597934691048$var$inflateReset2_1,
    inflateResetKeep: $b8ea597934691048$var$inflateResetKeep_1,
    inflateInit: $b8ea597934691048$var$inflateInit_1,
    inflateInit2: $b8ea597934691048$var$inflateInit2_1,
    inflate: $b8ea597934691048$var$inflate_2$1,
    inflateEnd: $b8ea597934691048$var$inflateEnd_1,
    inflateGetHeader: $b8ea597934691048$var$inflateGetHeader_1,
    inflateSetDictionary: $b8ea597934691048$var$inflateSetDictionary_1,
    inflateInfo: $b8ea597934691048$var$inflateInfo
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $b8ea597934691048$var$GZheader() {
    /* true if compressed data believed to be text */ this.text = 0;
    /* modification time */ this.time = 0;
    /* extra flags (not used when writing a gzip file) */ this.xflags = 0;
    /* operating system */ this.os = 0;
    /* pointer to extra field or Z_NULL if none */ this.extra = null;
    /* extra field length (valid if extra != Z_NULL) */ this.extra_len = 0; // Actually, we don't need it in JS,
    // but leave for few code modifications
    //
    // Setup limits is not necessary because in js we should not preallocate memory
    // for inflate use constant limit in 65536 bytes
    //
    /* space at extra (only when reading header) */ // this.extra_max  = 0;
    /* pointer to zero-terminated file name or Z_NULL */ this.name = '';
    /* space at name (only when reading header) */ // this.name_max   = 0;
    /* pointer to zero-terminated comment or Z_NULL */ this.comment = '';
    /* space at comment (only when reading header) */ // this.comm_max   = 0;
    /* true if there was or will be a header crc */ this.hcrc = 0;
    /* true when done reading gzip header (not used when writing a gzip file) */ this.done = false;
}
var $b8ea597934691048$var$gzheader = $b8ea597934691048$var$GZheader;
const $b8ea597934691048$var$toString = Object.prototype.toString;
/* Public constants ==========================================================*/ /* ===========================================================================*/ const { Z_NO_FLUSH: $b8ea597934691048$var$Z_NO_FLUSH, Z_FINISH: $b8ea597934691048$var$Z_FINISH, Z_OK: $b8ea597934691048$var$Z_OK, Z_STREAM_END: $b8ea597934691048$var$Z_STREAM_END, Z_NEED_DICT: $b8ea597934691048$var$Z_NEED_DICT, Z_STREAM_ERROR: $b8ea597934691048$var$Z_STREAM_ERROR, Z_DATA_ERROR: $b8ea597934691048$var$Z_DATA_ERROR, Z_MEM_ERROR: $b8ea597934691048$var$Z_MEM_ERROR } = $b8ea597934691048$var$constants$2;
/* ===========================================================================*/ /**
 * class Inflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[inflate]]
 * and [[inflateRaw]].
 **/ /* internal
 * inflate.chunks -> Array
 *
 * Chunks of output data, if [[Inflate#onData]] not overridden.
 **/ /**
 * Inflate.result -> Uint8Array|String
 *
 * Uncompressed result, generated by default [[Inflate#onData]]
 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Inflate#push]] with `Z_FINISH` / `true` param).
 **/ /**
 * Inflate.err -> Number
 *
 * Error code after inflate finished. 0 (Z_OK) on success.
 * Should be checked if broken data possible.
 **/ /**
 * Inflate.msg -> String
 *
 * Error message, if [[Inflate.err]] != 0
 **/ /**
 * new Inflate(options)
 * - options (Object): zlib inflate options.
 *
 * Creates new inflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `windowBits`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw inflate
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 * By default, when no options set, autodetect deflate/gzip data format via
 * wrapper header.
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 * const chunk1 = new Uint8Array([1,2,3,4,5,6,7,8,9])
 * const chunk2 = new Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * const inflate = new pako.Inflate({ level: 3});
 *
 * inflate.push(chunk1, false);
 * inflate.push(chunk2, true);  // true -> last chunk
 *
 * if (inflate.err) { throw new Error(inflate.err); }
 *
 * console.log(inflate.result);
 * ```
 **/ function $b8ea597934691048$var$Inflate$1(options) {
    this.options = $b8ea597934691048$var$common.assign({
        chunkSize: 65536,
        windowBits: 15,
        to: ''
    }, options || {});
    const opt = this.options;
    // Force window size for `raw` data, if not set directly,
    // because we have no header for autodetect.
    if (opt.raw && opt.windowBits >= 0 && opt.windowBits < 16) {
        opt.windowBits = -opt.windowBits;
        if (opt.windowBits === 0) opt.windowBits = -15;
    }
    // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
    if (opt.windowBits >= 0 && opt.windowBits < 16 && !(options && options.windowBits)) opt.windowBits += 32;
    // Gzip header has no info about windows size, we can do autodetect only
    // for deflate. So, if window size not set, force it to max when gzip possible
    if (opt.windowBits > 15 && opt.windowBits < 48) // bit 3 (16) -> gzipped data
    // bit 4 (32) -> autodetect gzip/deflate
    {
        if ((opt.windowBits & 15) === 0) opt.windowBits |= 15;
    }
    this.err = 0; // error code, if happens (0 = Z_OK)
    this.msg = ''; // error message
    this.ended = false; // used to avoid multiple onEnd() calls
    this.chunks = []; // chunks of compressed data
    this.strm = new $b8ea597934691048$var$zstream();
    this.strm.avail_out = 0;
    let status = $b8ea597934691048$var$inflate_1$2.inflateInit2(this.strm, opt.windowBits);
    if (status !== $b8ea597934691048$var$Z_OK) throw new Error($b8ea597934691048$var$messages[status]);
    this.header = new $b8ea597934691048$var$gzheader();
    $b8ea597934691048$var$inflate_1$2.inflateGetHeader(this.strm, this.header);
    // Setup dictionary
    if (opt.dictionary) {
        // Convert data if needed
        if (typeof opt.dictionary === 'string') opt.dictionary = $b8ea597934691048$var$strings.string2buf(opt.dictionary);
        else if ($b8ea597934691048$var$toString.call(opt.dictionary) === '[object ArrayBuffer]') opt.dictionary = new Uint8Array(opt.dictionary);
        if (opt.raw) {
            status = $b8ea597934691048$var$inflate_1$2.inflateSetDictionary(this.strm, opt.dictionary);
            if (status !== $b8ea597934691048$var$Z_OK) throw new Error($b8ea597934691048$var$messages[status]);
        }
    }
}
/**
 * Inflate#push(data[, flush_mode]) -> Boolean
 * - data (Uint8Array|ArrayBuffer): input data
 * - flush_mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE
 *   flush modes. See constants. Skipped or `false` means Z_NO_FLUSH,
 *   `true` means Z_FINISH.
 *
 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
 * new output chunks. Returns `true` on success. If end of stream detected,
 * [[Inflate#onEnd]] will be called.
 *
 * `flush_mode` is not needed for normal operation, because end of stream
 * detected automatically. You may try to use it for advanced things, but
 * this functionality was not tested.
 *
 * On fail call [[Inflate#onEnd]] with error code and return false.
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ $b8ea597934691048$var$Inflate$1.prototype.push = function(data, flush_mode) {
    const strm = this.strm;
    const chunkSize = this.options.chunkSize;
    const dictionary = this.options.dictionary;
    let status, _flush_mode, last_avail_out;
    if (this.ended) return false;
    if (flush_mode === ~~flush_mode) _flush_mode = flush_mode;
    else _flush_mode = flush_mode === true ? $b8ea597934691048$var$Z_FINISH : $b8ea597934691048$var$Z_NO_FLUSH;
    // Convert data if needed
    if ($b8ea597934691048$var$toString.call(data) === '[object ArrayBuffer]') strm.input = new Uint8Array(data);
    else strm.input = data;
    strm.next_in = 0;
    strm.avail_in = strm.input.length;
    for(;;){
        if (strm.avail_out === 0) {
            strm.output = new Uint8Array(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
        }
        status = $b8ea597934691048$var$inflate_1$2.inflate(strm, _flush_mode);
        if (status === $b8ea597934691048$var$Z_NEED_DICT && dictionary) {
            status = $b8ea597934691048$var$inflate_1$2.inflateSetDictionary(strm, dictionary);
            if (status === $b8ea597934691048$var$Z_OK) status = $b8ea597934691048$var$inflate_1$2.inflate(strm, _flush_mode);
            else if (status === $b8ea597934691048$var$Z_DATA_ERROR) // Replace code with more verbose
            status = $b8ea597934691048$var$Z_NEED_DICT;
        }
        // Skip snyc markers if more data follows and not raw mode
        while(strm.avail_in > 0 && status === $b8ea597934691048$var$Z_STREAM_END && strm.state.wrap > 0 && data[strm.next_in] !== 0){
            $b8ea597934691048$var$inflate_1$2.inflateReset(strm);
            status = $b8ea597934691048$var$inflate_1$2.inflate(strm, _flush_mode);
        }
        switch(status){
            case $b8ea597934691048$var$Z_STREAM_ERROR:
            case $b8ea597934691048$var$Z_DATA_ERROR:
            case $b8ea597934691048$var$Z_NEED_DICT:
            case $b8ea597934691048$var$Z_MEM_ERROR:
                this.onEnd(status);
                this.ended = true;
                return false;
        }
        // Remember real `avail_out` value, because we may patch out buffer content
        // to align utf8 strings boundaries.
        last_avail_out = strm.avail_out;
        if (strm.next_out) {
            if (strm.avail_out === 0 || status === $b8ea597934691048$var$Z_STREAM_END) {
                if (this.options.to === 'string') {
                    let next_out_utf8 = $b8ea597934691048$var$strings.utf8border(strm.output, strm.next_out);
                    let tail = strm.next_out - next_out_utf8;
                    let utf8str = $b8ea597934691048$var$strings.buf2string(strm.output, next_out_utf8);
                    // move tail & realign counters
                    strm.next_out = tail;
                    strm.avail_out = chunkSize - tail;
                    if (tail) strm.output.set(strm.output.subarray(next_out_utf8, next_out_utf8 + tail), 0);
                    this.onData(utf8str);
                } else this.onData(strm.output.length === strm.next_out ? strm.output : strm.output.subarray(0, strm.next_out));
            }
        }
        // Must repeat iteration if out buffer is full
        if (status === $b8ea597934691048$var$Z_OK && last_avail_out === 0) continue;
        // Finalize if end of stream reached.
        if (status === $b8ea597934691048$var$Z_STREAM_END) {
            status = $b8ea597934691048$var$inflate_1$2.inflateEnd(this.strm);
            this.onEnd(status);
            this.ended = true;
            return true;
        }
        if (strm.avail_in === 0) break;
    }
    return true;
};
/**
 * Inflate#onData(chunk) -> Void
 * - chunk (Uint8Array|String): output data. When string output requested,
 *   each chunk will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ $b8ea597934691048$var$Inflate$1.prototype.onData = function(chunk) {
    this.chunks.push(chunk);
};
/**
 * Inflate#onEnd(status) -> Void
 * - status (Number): inflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called either after you tell inflate that the input stream is
 * complete (Z_FINISH). By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ $b8ea597934691048$var$Inflate$1.prototype.onEnd = function(status) {
    // On success - join
    if (status === $b8ea597934691048$var$Z_OK) {
        if (this.options.to === 'string') this.result = this.chunks.join('');
        else this.result = $b8ea597934691048$var$common.flattenChunks(this.chunks);
    }
    this.chunks = [];
    this.err = status;
    this.msg = this.strm.msg;
};
/**
 * inflate(data[, options]) -> Uint8Array|String
 * - data (Uint8Array|ArrayBuffer): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Decompress `data` with inflate/ungzip and `options`. Autodetect
 * format via wrapper header by default. That's why we don't provide
 * separate `ungzip` method.
 *
 * Supported options are:
 *
 * - windowBits
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako');
 * const input = pako.deflate(new Uint8Array([1,2,3,4,5,6,7,8,9]));
 * let output;
 *
 * try {
 *   output = pako.inflate(input);
 * } catch (err) {
 *   console.log(err);
 * }
 * ```
 **/ function $b8ea597934691048$var$inflate$1(input, options) {
    const inflator = new $b8ea597934691048$var$Inflate$1(options);
    inflator.push(input);
    // That will never happens, if you don't cheat with options :)
    if (inflator.err) throw inflator.msg || $b8ea597934691048$var$messages[inflator.err];
    return inflator.result;
}
/**
 * inflateRaw(data[, options]) -> Uint8Array|String
 * - data (Uint8Array|ArrayBuffer): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * The same as [[inflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function $b8ea597934691048$var$inflateRaw$1(input, options) {
    options = options || {};
    options.raw = true;
    return $b8ea597934691048$var$inflate$1(input, options);
}
/**
 * ungzip(data[, options]) -> Uint8Array|String
 * - data (Uint8Array|ArrayBuffer): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Just shortcut to [[inflate]], because it autodetects format
 * by header.content. Done for convenience.
 **/ var $b8ea597934691048$var$Inflate_1$1 = $b8ea597934691048$var$Inflate$1;
var $b8ea597934691048$var$inflate_2 = $b8ea597934691048$var$inflate$1;
var $b8ea597934691048$var$inflateRaw_1$1 = $b8ea597934691048$var$inflateRaw$1;
var $b8ea597934691048$var$ungzip$1 = $b8ea597934691048$var$inflate$1;
var $b8ea597934691048$var$constants = $b8ea597934691048$var$constants$2;
var $b8ea597934691048$var$inflate_1$1 = {
    Inflate: $b8ea597934691048$var$Inflate_1$1,
    inflate: $b8ea597934691048$var$inflate_2,
    inflateRaw: $b8ea597934691048$var$inflateRaw_1$1,
    ungzip: $b8ea597934691048$var$ungzip$1,
    constants: $b8ea597934691048$var$constants
};
const { Deflate: $b8ea597934691048$var$Deflate, deflate: $b8ea597934691048$var$deflate, deflateRaw: $b8ea597934691048$var$deflateRaw, gzip: $b8ea597934691048$var$gzip } = $b8ea597934691048$var$deflate_1$1;
const { Inflate: $b8ea597934691048$var$Inflate, inflate: $b8ea597934691048$var$inflate, inflateRaw: $b8ea597934691048$var$inflateRaw, ungzip: $b8ea597934691048$var$ungzip } = $b8ea597934691048$var$inflate_1$1;
var $b8ea597934691048$export$ae157b6234afe138 = $b8ea597934691048$var$Deflate;
var $b8ea597934691048$export$2316623ecd1285ab = $b8ea597934691048$var$deflate;
var $b8ea597934691048$export$e95d6a8f69fb340a = $b8ea597934691048$var$deflateRaw;
var $b8ea597934691048$export$69f0ea7cf3a331a8 = $b8ea597934691048$var$gzip;
var $b8ea597934691048$export$d1de70a877d6e43c = $b8ea597934691048$var$Inflate;
var $b8ea597934691048$export$cae1ce83fe4a1782 = $b8ea597934691048$var$inflate;
var $b8ea597934691048$export$d0f0aa2d05c905c5 = $b8ea597934691048$var$inflateRaw;
var $b8ea597934691048$export$95adf9d270383091 = $b8ea597934691048$var$ungzip;
var $b8ea597934691048$export$1a988e7317c65621 = $b8ea597934691048$var$constants$2;
var $b8ea597934691048$export$2e2bcd8739ae039 = {
    Deflate: $b8ea597934691048$export$ae157b6234afe138,
    deflate: $b8ea597934691048$export$2316623ecd1285ab,
    deflateRaw: $b8ea597934691048$export$e95d6a8f69fb340a,
    gzip: $b8ea597934691048$export$69f0ea7cf3a331a8,
    Inflate: $b8ea597934691048$export$d1de70a877d6e43c,
    inflate: $b8ea597934691048$export$cae1ce83fe4a1782,
    inflateRaw: $b8ea597934691048$export$d0f0aa2d05c905c5,
    ungzip: $b8ea597934691048$export$95adf9d270383091,
    constants: $b8ea597934691048$export$1a988e7317c65621
};


const $c5a0b96abcd6dbcd$export$55abd4691b317664 = window.history;
const $c5a0b96abcd6dbcd$var$location = window.location;
const $c5a0b96abcd6dbcd$export$c2ed3351cac403d1 = window.localStorage;
const $c5a0b96abcd6dbcd$var$navigator = window.navigator;
const $c5a0b96abcd6dbcd$export$128fa18b7194ef = new URL($c5a0b96abcd6dbcd$var$location);
const $c5a0b96abcd6dbcd$export$da1115b7645c376c = $c5a0b96abcd6dbcd$export$128fa18b7194ef.searchParams;
function $c5a0b96abcd6dbcd$export$22d6d01dd47e89dd(a, b, sort) {
    if (typeof sort === 'function') {
        a = a.toSorted(sort);
        b = b.toSorted(sort);
    }
    return a.length === b.length && a.every((value, index)=>b[index] === value);
}
function $c5a0b96abcd6dbcd$export$22012a5c726bef55(a, b, sort) {
    return a.some((v)=>$c5a0b96abcd6dbcd$export$22d6d01dd47e89dd(v, b, sort));
}
function $c5a0b96abcd6dbcd$export$f09b504682b60c87(str, seed = 0) {
    let h1 = 0xdeadbeef ^ seed;
    let h2 = 0x41c6ce57 ^ seed;
    for(let i = 0, ch; i < str.length; i++){
        ch = str.charCodeAt(i);
        h1 = Math.imul(h1 ^ ch, 2654435761);
        h2 = Math.imul(h2 ^ ch, 1597334677);
    }
    h1 = Math.imul(h1 ^ h1 >>> 16, 2246822507);
    h1 ^= Math.imul(h2 ^ h2 >>> 13, 3266489909);
    h2 = Math.imul(h2 ^ h2 >>> 16, 2246822507);
    h2 ^= Math.imul(h1 ^ h1 >>> 13, 3266489909);
    return 4294967296 * (2097151 & h2) + (h1 >>> 0);
}
function $c5a0b96abcd6dbcd$export$f654b28f82155665() {
    return new URL($c5a0b96abcd6dbcd$var$location.href.split(/[?#]/)[0]);
}
function $c5a0b96abcd6dbcd$export$307b18b61172f7ed(...parts) {
    return parts.join('-');
}
function $c5a0b96abcd6dbcd$export$1f72301cb8058614(date) {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
}
function $c5a0b96abcd6dbcd$export$c8245504e56d23ee(rand, array, max) {
    const available = Object.keys(array);
    if (max > available.length) max = available.length;
    const picked = [];
    for(; max > 0; max--)picked.push(Number(available.splice($c5a0b96abcd6dbcd$export$f863c42fae7e138a(rand, available.length - 1), 1)[0]));
    return picked;
}
function $c5a0b96abcd6dbcd$export$d4634d8e0b46181a(num) {
    const sign = Math.sign(num);
    if (sign === 0) return '=';
    else if (sign > 0) return '>';
    else return '<';
}
function $c5a0b96abcd6dbcd$export$afb15ede80c42aab(string) {
    const binString = window.atob($c5a0b96abcd6dbcd$var$base64unescape(string));
    // noinspection JSCheckFunctionSignatures
    return new TextDecoder().decode((0, $b8ea597934691048$export$2e2bcd8739ae039).inflate(Uint8Array.from(binString, (c)=>c.codePointAt(0))));
}
function $c5a0b96abcd6dbcd$export$4e633de97d65d1c8(string) {
    return $c5a0b96abcd6dbcd$var$base64escape(window.btoa(String.fromCodePoint(...(0, $b8ea597934691048$export$2e2bcd8739ae039).deflate(new TextEncoder().encode(string)))));
}
function $c5a0b96abcd6dbcd$var$base64escape(string) {
    // https://en.wikipedia.org/wiki/Base64#URL_applications
    return string.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}
function $c5a0b96abcd6dbcd$var$base64unescape(string) {
    return (string + '==='.slice((string.length + 3) % 4)).replace(/-/g, '+').replace(/_/g, '/');
}
function $c5a0b96abcd6dbcd$export$b1b145d64c7b5823(value, func) {
    return value === undefined ? value : func(value);
}
function $c5a0b96abcd6dbcd$export$f863c42fae7e138a(rand, max, min = 0) {
    return Math.floor(rand() * (max - min + 1) + min);
}
function $c5a0b96abcd6dbcd$export$32da5b5043dcd88c() {
    $c5a0b96abcd6dbcd$var$location.assign($c5a0b96abcd6dbcd$export$128fa18b7194ef.search);
}
function $c5a0b96abcd6dbcd$export$4b9a4be687eeedb5(str) {
    return str.split('').reverse().join('');
}
function $c5a0b96abcd6dbcd$export$448332262467e042(rand, array) {
    // https://en.wikipedia.org/wiki/Fisher%E2%80%93Yates_shuffle#The_modern_algorithm
    for(let i = array.length - 1; i > 0; i--){
        const j = Math.floor(rand() * (i + 1));
        const temp = array[i];
        array[i] = array[j];
        array[j] = temp;
    }
    return array;
}
function $c5a0b96abcd6dbcd$export$4f889fe9b45273af(a, b) {
    return Number(a) - Number(b);
}
function $c5a0b96abcd6dbcd$export$ea27ae0a69e9255c(a) {
    return function() {
        a |= 0;
        a = a + 0x9e3779b9 | 0;
        let t = a ^ a >>> 16;
        t = Math.imul(t, 0x21f0aaad);
        t = t ^ t >>> 15;
        t = Math.imul(t, 0x735a2d97);
        return ((t ^ t >>> 15) >>> 0) / 4294967296;
    };
}
async function $c5a0b96abcd6dbcd$export$e84ab21a5791681d(string) {
    try {
        await $c5a0b96abcd6dbcd$var$navigator.clipboard.writeText(string);
    } catch (error) {
        console.error('Could not write to clipboard.', error.message);
    }
}


const $77e640c1aaab669f$var$console = window.console = window.console || {
    debug: function() {}
};
const $77e640c1aaab669f$var$consoleDebug = $77e640c1aaab669f$var$console.debug;
function $77e640c1aaab669f$export$1c9f709888824e05(debug) {
    $77e640c1aaab669f$var$console.debug = debug ? $77e640c1aaab669f$var$consoleDebug : function() {};
}
// Silence debug logging by default
$77e640c1aaab669f$export$1c9f709888824e05((0, $c5a0b96abcd6dbcd$export$da1115b7645c376c).has('debug'));



const $274095b041d6d131$var$direction = 'direction';
const $274095b041d6d131$var$east = 'east';
const $274095b041d6d131$var$north = 'north';
const $274095b041d6d131$var$south = 'south';
const $274095b041d6d131$var$west = 'west';
const $274095b041d6d131$export$86ae6e8ac17a67c6 = Object.freeze({
    East: (0, $c5a0b96abcd6dbcd$export$307b18b61172f7ed)($274095b041d6d131$var$direction, $274095b041d6d131$var$east),
    North: (0, $c5a0b96abcd6dbcd$export$307b18b61172f7ed)($274095b041d6d131$var$direction, $274095b041d6d131$var$north),
    NorthEast: (0, $c5a0b96abcd6dbcd$export$307b18b61172f7ed)($274095b041d6d131$var$direction, $274095b041d6d131$var$north, $274095b041d6d131$var$east),
    NorthWest: (0, $c5a0b96abcd6dbcd$export$307b18b61172f7ed)($274095b041d6d131$var$direction, $274095b041d6d131$var$north, $274095b041d6d131$var$west),
    South: (0, $c5a0b96abcd6dbcd$export$307b18b61172f7ed)($274095b041d6d131$var$direction, $274095b041d6d131$var$south),
    SouthEast: (0, $c5a0b96abcd6dbcd$export$307b18b61172f7ed)($274095b041d6d131$var$direction, $274095b041d6d131$var$south, $274095b041d6d131$var$east),
    SouthWest: (0, $c5a0b96abcd6dbcd$export$307b18b61172f7ed)($274095b041d6d131$var$direction, $274095b041d6d131$var$south, $274095b041d6d131$var$west),
    West: (0, $c5a0b96abcd6dbcd$export$307b18b61172f7ed)($274095b041d6d131$var$direction, $274095b041d6d131$var$west)
});
const $274095b041d6d131$var$DiagonalDirections = Object.freeze([
    $274095b041d6d131$export$86ae6e8ac17a67c6.NorthEast,
    $274095b041d6d131$export$86ae6e8ac17a67c6.NorthWest,
    $274095b041d6d131$export$86ae6e8ac17a67c6.SouthEast,
    $274095b041d6d131$export$86ae6e8ac17a67c6.SouthWest
]);
class $274095b041d6d131$export$d6e0f5996cc55599 {
    column;
    id;
    row;
    #neighbors;
    constructor(row, column){
        this.id = [
            row,
            column
        ].join(',');
        this.row = Number(row);
        this.column = Number(column);
    }
    add(other) {
        return new $274095b041d6d131$export$d6e0f5996cc55599(this.row + other.row, this.column + other.column);
    }
    equals(other) {
        return this.id === other?.id;
    }
    getDirection(other) {
        return this.getNeighbors().find((neighbor)=>neighbor.coordinates.equals(other))?.direction;
    }
    getNeighbors() {
        if (!this.#neighbors) this.#neighbors = $274095b041d6d131$export$d6e0f5996cc55599.getNeighbors(this);
        return this.#neighbors;
    }
    getNeighborsCrossing(other) {
        const crossing = $274095b041d6d131$export$d6e0f5996cc55599.Crossings[this.getDirection(other)] ?? [];
        return this.getNeighbors().filter((neighbor)=>crossing.includes(neighbor.direction));
    }
    isNeighbor(other) {
        return this.getNeighbors().some((neighbor)=>neighbor.coordinates.equals(other));
    }
    toString() {
        return this.id;
    }
    static getNeighbors(coordinates) {
        return $274095b041d6d131$export$d6e0f5996cc55599.Neighbors.map((neighbor)=>new $274095b041d6d131$export$d6e0f5996cc55599.Neighbor(coordinates.add(neighbor.coordinates), neighbor.direction));
    }
    static Crossings = Object.freeze({
        [$274095b041d6d131$export$86ae6e8ac17a67c6.NorthEast]: [
            $274095b041d6d131$export$86ae6e8ac17a67c6.North,
            $274095b041d6d131$export$86ae6e8ac17a67c6.East
        ],
        [$274095b041d6d131$export$86ae6e8ac17a67c6.NorthWest]: [
            $274095b041d6d131$export$86ae6e8ac17a67c6.North,
            $274095b041d6d131$export$86ae6e8ac17a67c6.West
        ],
        [$274095b041d6d131$export$86ae6e8ac17a67c6.SouthEast]: [
            $274095b041d6d131$export$86ae6e8ac17a67c6.South,
            $274095b041d6d131$export$86ae6e8ac17a67c6.East
        ],
        [$274095b041d6d131$export$86ae6e8ac17a67c6.SouthWest]: [
            $274095b041d6d131$export$86ae6e8ac17a67c6.South,
            $274095b041d6d131$export$86ae6e8ac17a67c6.West
        ]
    });
    static Neighbor = class {
        coordinates;
        direction;
        isDirectionDiagonal;
        constructor(coordinates, direction){
            this.coordinates = coordinates;
            this.direction = direction;
            this.isDirectionDiagonal = $274095b041d6d131$var$DiagonalDirections.includes(direction);
        }
    };
    static Neighbors = Object.freeze([
        new $274095b041d6d131$export$d6e0f5996cc55599.Neighbor(new $274095b041d6d131$export$d6e0f5996cc55599(0, 1), $274095b041d6d131$export$86ae6e8ac17a67c6.East),
        new $274095b041d6d131$export$d6e0f5996cc55599.Neighbor(new $274095b041d6d131$export$d6e0f5996cc55599(-1, 0), $274095b041d6d131$export$86ae6e8ac17a67c6.North),
        new $274095b041d6d131$export$d6e0f5996cc55599.Neighbor(new $274095b041d6d131$export$d6e0f5996cc55599(-1, 1), $274095b041d6d131$export$86ae6e8ac17a67c6.NorthEast),
        new $274095b041d6d131$export$d6e0f5996cc55599.Neighbor(new $274095b041d6d131$export$d6e0f5996cc55599(-1, -1), $274095b041d6d131$export$86ae6e8ac17a67c6.NorthWest),
        new $274095b041d6d131$export$d6e0f5996cc55599.Neighbor(new $274095b041d6d131$export$d6e0f5996cc55599(1, 0), $274095b041d6d131$export$86ae6e8ac17a67c6.South),
        new $274095b041d6d131$export$d6e0f5996cc55599.Neighbor(new $274095b041d6d131$export$d6e0f5996cc55599(1, 1), $274095b041d6d131$export$86ae6e8ac17a67c6.SouthEast),
        new $274095b041d6d131$export$d6e0f5996cc55599.Neighbor(new $274095b041d6d131$export$d6e0f5996cc55599(1, -1), $274095b041d6d131$export$86ae6e8ac17a67c6.SouthWest),
        new $274095b041d6d131$export$d6e0f5996cc55599.Neighbor(new $274095b041d6d131$export$d6e0f5996cc55599(0, -1), $274095b041d6d131$export$86ae6e8ac17a67c6.West)
    ]);
}



let $6b10fa0db6bfe928$var$nextValue = 0;
class $6b10fa0db6bfe928$export$48ea269755562084 {
    name;
    value;
    constructor(name){
        this.name = name;
        this.value = 1 << $6b10fa0db6bfe928$var$nextValue++;
    }
}
class $6b10fa0db6bfe928$export$434ba092ed0eee4e {
    #value;
    constructor(...flags){
        this.set(...flags);
    }
    add(...flags) {
        flags.forEach((flag)=>{
            this.#value |= flag.value;
        });
        return this;
    }
    get() {
        return this.#value;
    }
    has(...flags) {
        return flags.some((flag)=>(this.#value & flag.value) > 0);
    }
    remove(...flags) {
        flags.forEach((flag)=>{
            this.#value &= ~flag.value;
        });
        return this;
    }
    set(...flags) {
        this.#value = 0;
        flags.forEach((flag)=>{
            if (typeof flag === 'number') this.#value = flag;
            else if (flag instanceof $6b10fa0db6bfe928$export$434ba092ed0eee4e) this.#value = flag.get();
            else if (flag instanceof $6b10fa0db6bfe928$export$48ea269755562084) this.add(flag);
        });
        return this;
    }
    toString(flags) {
        return flags.flatMap((flag)=>this.has(flag) ? [
                flag.name
            ] : []).join(',');
    }
}


class $7cd91973a7925acd$export$b20b719ec758a20f {
    #events = [];
    #options = {
        context: undefined,
        element: document
    };
    constructor(options = {}, events = []){
        this.#options = Object.assign(this.#options, options);
        this.add(events);
    }
    add(options = {}, events = []) {
        // Allow omission of options
        if (Array.isArray(options)) {
            events = options;
            options = {};
        }
        if (events.length === 0) return;
        this.#events = this.#events.concat(events.map((event)=>{
            event = Object.assign({}, this.#options, options, event);
            if (!event.type) throw new Error('Event type is required');
            else if (!Array.isArray(event.type)) event.type = [
                event.type
            ];
            if (event.context) {
                if (!Array.isArray(event.context)) event.context = [
                    event.context
                ];
                event.handler = event.handler.bind(...event.context);
            }
            event.type.forEach((type)=>event.element.addEventListener(type, event.handler, event.options));
            return event;
        }));
    }
    remove() {
        this.#events.forEach((event)=>event.type.forEach((type)=>event.element.removeEventListener(type, event.handler)));
        this.#events = [];
    }
}


const $28857821e2b8567e$var$$grid = document.getElementById('grid');
class $28857821e2b8567e$export$f6f0c3fe4ec306ea {
    #$content = document.createElement('span');
    #$element = document.createElement('div');
    #coordinates;
    #eventListeners = new (0, $7cd91973a7925acd$export$b20b719ec758a20f)({
        context: this,
        element: this.#$element
    });
    #state;
    constructor(coordinates, state){
        this.#coordinates = coordinates;
        this.#state = state;
        this.#eventListeners.add([
            {
                type: 'pointerdown',
                handler: this.#onSelect
            },
            {
                type: 'pointerenter',
                handler: this.#onSelect
            }
        ]);
        this.#$content.className = 'content';
        const $background = document.createElement('div');
        $background.classList.add('background');
        $background.append(this.#$content);
        this.#$element.append($background);
        this.update();
    }
    equals(other) {
        return this.getIndex() === other.getIndex();
    }
    getContent() {
        return this.#state.content;
    }
    getCoordinates() {
        return this.#coordinates;
    }
    getDirection(other) {
        return this.getCoordinates().getDirection(other.getCoordinates());
    }
    getElement() {
        return this.#$element;
    }
    getFlags() {
        return this.#state.getFlags();
    }
    getIndex() {
        return this.#state.index;
    }
    isConnected(other) {
        return this.getFlags().has($28857821e2b8567e$export$f6f0c3fe4ec306ea.FlagsByName[this.getDirection(other)]);
    }
    isNeighbor(other) {
        return this.getCoordinates().isNeighbor(other?.getCoordinates());
    }
    reset() {
        this.update((state)=>{
            const flags = new (0, $6b10fa0db6bfe928$export$434ba092ed0eee4e)();
            const existing = state.getFlags();
            $28857821e2b8567e$export$f6f0c3fe4ec306ea.StickyFlags.filter((flag)=>existing.has(flag)).forEach((flag)=>flags.add(flag));
            return state.copy({
                flags: flags
            });
        });
    }
    toString() {
        return `[${$28857821e2b8567e$export$f6f0c3fe4ec306ea.Name}:${this.getCoordinates.toString()}]`;
    }
    update(state) {
        if (state !== undefined) {
            if (typeof state === 'function') state = state(this.#state);
            if (!(state instanceof $28857821e2b8567e$export$f6f0c3fe4ec306ea.State)) throw new Error('Cannot update cell state: value given is not of type Cell.State');
            this.#state = state;
        }
        this.#$element.className = $28857821e2b8567e$export$f6f0c3fe4ec306ea.Name;
        this.#$element.dataset.index = this.getIndex();
        const flags = this.getFlags();
        const activeFlags = Object.values($28857821e2b8567e$export$f6f0c3fe4ec306ea.Flags).filter((flag)=>flags.has(flag));
        activeFlags.forEach((flag)=>this.#$element.classList.add((0, $c5a0b96abcd6dbcd$export$307b18b61172f7ed)($28857821e2b8567e$export$f6f0c3fe4ec306ea.Name, flag.name)));
        this.#$content.textContent = this.#state.content;
        return this.#state;
    }
    #onSelect(event) {
        if (event.type === 'pointerdown') // Release pointer capture on target so other cells can receive events.
        event.target.releasePointerCapture(event.pointerId);
        if (event.buttons > 0) {
            // User has clicked or touched the cell
            const detail = {
                cell: this,
                event: event
            };
            setTimeout(()=>$28857821e2b8567e$var$$grid.dispatchEvent(new CustomEvent($28857821e2b8567e$export$f6f0c3fe4ec306ea.Events.Select, {
                    detail: detail
                })));
        }
    }
    static Events = Object.freeze({
        Select: 'cell-select'
    });
    static Flags = Object.freeze({
        Active: new (0, $6b10fa0db6bfe928$export$48ea269755562084)('active'),
        DirectionEast: new (0, $6b10fa0db6bfe928$export$48ea269755562084)((0, $274095b041d6d131$export$86ae6e8ac17a67c6).East),
        DirectionNorth: new (0, $6b10fa0db6bfe928$export$48ea269755562084)((0, $274095b041d6d131$export$86ae6e8ac17a67c6).North),
        DirectionNorthEast: new (0, $6b10fa0db6bfe928$export$48ea269755562084)((0, $274095b041d6d131$export$86ae6e8ac17a67c6).NorthEast),
        DirectionNorthWest: new (0, $6b10fa0db6bfe928$export$48ea269755562084)((0, $274095b041d6d131$export$86ae6e8ac17a67c6).NorthWest),
        DirectionSouth: new (0, $6b10fa0db6bfe928$export$48ea269755562084)((0, $274095b041d6d131$export$86ae6e8ac17a67c6).South),
        DirectionSouthEast: new (0, $6b10fa0db6bfe928$export$48ea269755562084)((0, $274095b041d6d131$export$86ae6e8ac17a67c6).SouthEast),
        DirectionSouthWest: new (0, $6b10fa0db6bfe928$export$48ea269755562084)((0, $274095b041d6d131$export$86ae6e8ac17a67c6).SouthWest),
        DirectionWest: new (0, $6b10fa0db6bfe928$export$48ea269755562084)((0, $274095b041d6d131$export$86ae6e8ac17a67c6).West),
        First: new (0, $6b10fa0db6bfe928$export$48ea269755562084)('first'),
        Hint: new (0, $6b10fa0db6bfe928$export$48ea269755562084)('hint'),
        Last: new (0, $6b10fa0db6bfe928$export$48ea269755562084)('last'),
        Path: new (0, $6b10fa0db6bfe928$export$48ea269755562084)('path'),
        Revealed: new (0, $6b10fa0db6bfe928$export$48ea269755562084)('revealed'),
        Selected: new (0, $6b10fa0db6bfe928$export$48ea269755562084)('selected'),
        Swap: new (0, $6b10fa0db6bfe928$export$48ea269755562084)('swap'),
        Swapped: new (0, $6b10fa0db6bfe928$export$48ea269755562084)('swapped'),
        Validated: new (0, $6b10fa0db6bfe928$export$48ea269755562084)('validated'),
        WordEnd: new (0, $6b10fa0db6bfe928$export$48ea269755562084)('word-end'),
        WordStart: new (0, $6b10fa0db6bfe928$export$48ea269755562084)('word-start')
    });
    static FlagsByName = Object.fromEntries(Object.values($28857821e2b8567e$export$f6f0c3fe4ec306ea.Flags).map((flag)=>[
            flag.name,
            flag
        ]));
    static StickyFlags = Object.freeze([
        $28857821e2b8567e$export$f6f0c3fe4ec306ea.Flags.Hint,
        $28857821e2b8567e$export$f6f0c3fe4ec306ea.Flags.Swapped
    ]);
    static Name = 'cell';
    static State = class {
        index;
        content;
        flags;
        #flags;
        constructor(index, content, flags = 0){
            this.index = index;
            this.content = content;
            this.flags = flags instanceof (0, $6b10fa0db6bfe928$export$434ba092ed0eee4e) ? flags.get() : flags;
        }
        copy(settings) {
            return new $28857821e2b8567e$export$f6f0c3fe4ec306ea.State(settings.index ?? this.index, settings.content ?? this.content, settings.flags ?? this.flags);
        }
        getFlags() {
            return this.#flags ?? (this.#flags = new (0, $6b10fa0db6bfe928$export$434ba092ed0eee4e)(this.flags));
        }
        static fromObject(obj) {
            return new $28857821e2b8567e$export$f6f0c3fe4ec306ea.State(obj.index, obj.content, obj.flags);
        }
    };
}




class $40d8a77a984c51a9$export$94affb487e701bf2 {
    encoding;
    getter;
    key;
    setter;
    constructor(key, getter, setter, encoding = []){
        this.key = key;
        this.getter = getter;
        this.setter = setter;
        this.encoding = encoding;
    }
    copy(settings) {
        return new $40d8a77a984c51a9$export$94affb487e701bf2(settings.key ?? this.key, settings.getter ?? this.getter, settings.setter ?? this.setter, settings.encoding ?? this.encoding);
    }
    decode(value) {
        if (value === null || value === undefined) return;
        if (this.encoding.includes($40d8a77a984c51a9$export$94affb487e701bf2.Encoders.Base64)) value = (0, $c5a0b96abcd6dbcd$export$afb15ede80c42aab)(value);
        if (this.encoding.includes($40d8a77a984c51a9$export$94affb487e701bf2.Encoders.Json)) value = JSON.parse(value);
        return value;
    }
    encode(value) {
        if (value === null || value === undefined) return;
        if (this.encoding.includes($40d8a77a984c51a9$export$94affb487e701bf2.Encoders.Json)) value = JSON.stringify(value);
        if (this.encoding.includes($40d8a77a984c51a9$export$94affb487e701bf2.Encoders.Base64)) value = (0, $c5a0b96abcd6dbcd$export$4e633de97d65d1c8)(value);
        return value;
    }
    get() {
        return this.decode(this.getter(this.key));
    }
    set(value) {
        return this.setter(this.key, this.encode(value));
    }
    static localStorage(key, encoding) {
        return new $40d8a77a984c51a9$export$94affb487e701bf2(key, (0, $c5a0b96abcd6dbcd$export$c2ed3351cac403d1).getItem.bind((0, $c5a0b96abcd6dbcd$export$c2ed3351cac403d1)), (0, $c5a0b96abcd6dbcd$export$c2ed3351cac403d1).setItem.bind((0, $c5a0b96abcd6dbcd$export$c2ed3351cac403d1)), encoding);
    }
    static urlParams(key, encoding) {
        return new $40d8a77a984c51a9$export$94affb487e701bf2(key, (0, $c5a0b96abcd6dbcd$export$da1115b7645c376c).get.bind((0, $c5a0b96abcd6dbcd$export$da1115b7645c376c)), (0, $c5a0b96abcd6dbcd$export$da1115b7645c376c).set.bind((0, $c5a0b96abcd6dbcd$export$da1115b7645c376c)), encoding);
    }
    static Encoders = Object.freeze({
        Base64: 'base64',
        Json: 'json'
    });
}


class $4c3397e7d04ad378$export$7254cc27399e90bd {
    #cache;
    #persistence;
    #value;
    constructor(key, defaultValue, options){
        options = Object.assign({
            encoding: [
                (0, $40d8a77a984c51a9$export$94affb487e701bf2).Encoders.Json
            ],
            overrides: [],
            persistence: true
        }, options);
        this.#cache = (0, $40d8a77a984c51a9$export$94affb487e701bf2).localStorage(key, options.encoding);
        this.#persistence = options.persistence !== false;
        this.#value = structuredClone(defaultValue);
        if (this.#persistence) try {
            const value = this.#cache.get();
            if (value !== undefined) {
                console.debug(`Found local cache for key '${key}'.`, value);
                this.set(value);
            }
        } catch (e) {
            console.error(`Could not load cache for key '${key}': ${e.message}`);
        }
        const overrides = options.overrides ?? [];
        overrides.forEach((cache)=>{
            try {
                const value = cache.get();
                if (value !== undefined) {
                    console.debug(`Overriding local cache at key '${cache.key}'.`, value);
                    this.set(cache.key, value);
                }
            } catch (e) {
                console.error(`Could not override local cache at key '${cache.key}': ${e.message}`);
            }
        });
    }
    get(key) {
        return structuredClone(key === undefined ? this.#value : this.#value[key]);
    }
    set(key, value) {
        if (arguments.length === 1) {
            value = key;
            key = this.#cache.key;
        }
        if (value === undefined) return;
        const isCacheKey = key === this.#cache.key;
        value = structuredClone(value);
        if (isCacheKey) this.#value = value;
        else this.#value[key] = value;
        if (this.#persistence) this.#cache.set(this.#value);
        return this.get();
    }
    update(updater) {
        const state = this.get();
        return this.set(updater(state) ?? state);
    }
}



class $31f1f142de46960c$export$beccbe55c9efb032 {
    character;
    frequency;
    points;
    weight;
    constructor(character){
        this.character = character;
        this.frequency = $31f1f142de46960c$export$beccbe55c9efb032.frequencies[character];
        // Assign points to the letter based on which tier it falls into. Every letter is worth at least one point and
        // will gain an additional point for each cumulative tier it is in.
        this.points = $31f1f142de46960c$export$beccbe55c9efb032.pointTiers.reduce((points, tier)=>points + (this.frequency < tier ? 1 : 0), 1);
        // Calculate the weight of the letter based on the cumulative frequency of this letter and all those before it.
        // Weight is on a sliding scale between 0 and 1.
        const characters = $31f1f142de46960c$export$beccbe55c9efb032.characters.slice(0, $31f1f142de46960c$export$beccbe55c9efb032.characters.indexOf(character) + 1);
        this.weight = characters.reduce((weight, character)=>weight + $31f1f142de46960c$export$beccbe55c9efb032.frequencies[character], 0);
    }
    /**
   * Stores letters by their frequency of usage. The values must add up to 1.
   * @see https://en.wikipedia.org/wiki/Letter_frequency#Relative_frequencies_of_letters_in_the_English_language
   * @type {Object.<string, number>}
   */ static frequencies = Object.freeze({
        a: 0.08167,
        b: 0.01492,
        c: 0.02782,
        d: 0.04253,
        e: 0.12702,
        f: 0.02228,
        g: 0.02015,
        h: 0.06094,
        i: 0.06966,
        j: 0.00153,
        k: 0.00772,
        l: 0.04025,
        m: 0.02406,
        n: 0.06749,
        o: 0.07507,
        p: 0.01929,
        q: 0.00095,
        r: 0.05987,
        s: 0.06327,
        t: 0.09056,
        u: 0.02758,
        v: 0.00978,
        w: 0.02360,
        x: 0.00150,
        y: 0.01974,
        z: 0.00074
    });
    static characters = Object.freeze(Object.keys($31f1f142de46960c$export$beccbe55c9efb032.frequencies));
    /**
   * Defines point tiers based on letter frequency percentage.
   * @type {number[]} Frequency tiers.
   */ static pointTiers = [
        0.1,
        0.5,
        1,
        4,
        8
    ].map((n)=>n / 100);
}
const $31f1f142de46960c$export$e893190d69011f56 = Object.fromEntries($31f1f142de46960c$export$beccbe55c9efb032.characters.map((character)=>[
        character,
        new $31f1f142de46960c$export$beccbe55c9efb032(character)
    ]));
const $31f1f142de46960c$export$cf980ec1f8b21744 = Object.values($31f1f142de46960c$export$e893190d69011f56);
const $31f1f142de46960c$var$$letterPoints = document.getElementById('letter-points');
const $31f1f142de46960c$var$letterPointBuckets = {};
$31f1f142de46960c$export$cf980ec1f8b21744.forEach((letter)=>($31f1f142de46960c$var$letterPointBuckets[letter.points] ?? ($31f1f142de46960c$var$letterPointBuckets[letter.points] = [])).push(letter));
for(const points in $31f1f142de46960c$var$letterPointBuckets){
    const $li = document.createElement('li');
    const $points = document.createElement('span');
    $points.classList.add('points');
    $points.textContent = `${points} Point${points > 1 ? 's' : ''}:`;
    const $letters = document.createElement('span');
    $letters.classList.add('letters');
    $letters.textContent = $31f1f142de46960c$var$letterPointBuckets[points].map((letter)=>letter.character).join(', ');
    $li.append($points, $letters);
    $31f1f142de46960c$var$$letterPoints.append($li);
}




class $282e11ce9af396b1$export$1ee6d718c47c2db0 {
    content;
    indexes = [];
    move;
    points;
    constructor(width, cells, move){
        const content = [];
        const pointScoringLetters = [];
        cells.forEach((cell)=>{
            const character = cell.getContent();
            content.push(character);
            const letter = (0, $31f1f142de46960c$export$e893190d69011f56)[character];
            if (!cell.getFlags().has((0, $28857821e2b8567e$export$f6f0c3fe4ec306ea).Flags.Swapped) || move.value.match === (0, $f3a1510773f18396$export$ef2184bd89960b14).Match.Exact) // Points are only scored for letters that are not swapped, unless the word exactly matches a secret word.
            pointScoringLetters.push(letter);
            this.indexes.push(cell.getIndex());
        });
        this.content = content.join('');
        this.move = move;
        const lengthMultiplier = Math.floor(pointScoringLetters.length / $282e11ce9af396b1$export$1ee6d718c47c2db0.widthMultiplier(width));
        this.points = pointScoringLetters.reduce((points, letter)=>points + letter.points, 0) * lengthMultiplier;
    }
    static widthMultiplier(width) {
        return Math.floor(width / 2);
    }
    static minimumLength = 3;
}







class $7dbf3b60a5ee77ad$export$4ee70ab773570fb9 {
    sources = {};
    words = [];
    async load(source) {
        if (this.sources[source.name]) {
            console.debug(`Dictionary '${source.name}' has already been loaded.`);
            return;
        }
        console.debug(`Loading dictionary '${source.name}' from URL: '${source.url}'`);
        try {
            // Always use cached copy if it exists
            const response = await fetch(source.url, {
                cache: 'force-cache'
            });
            const text = await response.text();
            const startIndex = this.words.length;
            this.words = Array.from(new Set(this.words.concat(text.split('\n').filter((word)=>word.length >= (0, $282e11ce9af396b1$export$1ee6d718c47c2db0).minimumLength))));
            const range = new $7dbf3b60a5ee77ad$export$4ee70ab773570fb9.Range(startIndex, this.words.length - 1);
            this.sources[source.name] = source.withRange(range);
            console.debug(`Words loaded. New word count: ${this.words.length}`);
        } catch (e) {
            console.error(`Could not load words for dictionary '${source.name}' from URL '${source.url}'`, e.message);
        }
    }
    /**
   * Gets random words from the words dictionary until the length is met.
   * @param rand A PRNG used to choose indexes from the set of words.
   * @param length The exact total length of the picked words.
   * @param maximumWordLength Optional maximum length for a picked word.
   * @returns {*[]|*} An array of words.
   */ getWords(rand, length, maximumWordLength) {
        let availableWords = Array.from(this.words);
        let count = 0;
        if (maximumWordLength) availableWords = availableWords.filter((word)=>word.length <= maximumWordLength);
        console.debug(`getWords: ${length} characters with maximum word length of ${maximumWordLength}.`);
        const result = [];
        function next() {
            let maximumWordLength = length - count - (0, $282e11ce9af396b1$export$1ee6d718c47c2db0).minimumLength;
            if (maximumWordLength >= (0, $282e11ce9af396b1$export$1ee6d718c47c2db0).minimumLength) availableWords = availableWords.filter((word)=>word.length <= maximumWordLength);
            else {
                maximumWordLength = maximumWordLength + (0, $282e11ce9af396b1$export$1ee6d718c47c2db0).minimumLength;
                availableWords = availableWords.filter((word)=>word.length === maximumWordLength);
            }
            console.debug(`getWords ${result.length}: ` + `count = ${count}/${length}, ` + `maximumWordLength = ${maximumWordLength}, ` + `availableWords = ${availableWords.length}`);
            const nextWordIndex = Math.floor(rand() * availableWords.length);
            const nextWord = availableWords[nextWordIndex];
            availableWords.splice(nextWordIndex, 1);
            console.debug(`getWords picked word '${nextWord}' at index ${nextWordIndex}.`);
            result.push(nextWord);
            count += nextWord.length;
            if (count === length) {
                // Shuffle the results, since the algorithm is biased towards putting the shortest word last.
                (0, $c5a0b96abcd6dbcd$export$448332262467e042)(rand, result);
                console.debug(`getWords result: ${result.join(', ')}`);
                return result;
            }
            return next();
        }
        return next();
    }
    getSource(word) {
        const index = this.words.indexOf(word);
        if (index < 0) return;
        for(const name in this.sources){
            if (this.sources[name]?.range.contains(index)) return name;
        }
    }
    isValid(word) {
        return word.length >= (0, $282e11ce9af396b1$export$1ee6d718c47c2db0).minimumLength && this.words.includes(word);
    }
    unload(name) {
        const source = this.sources[name];
        if (!source) {
            console.warn(`Dictionary '${name}' has not been loaded.`);
            return;
        }
        console.debug(`Unloading dictionary '${source.name}'. Current word count: ${this.words.length}`);
        source.range.extract(this.words);
        delete this.sources[source.name];
        // Update any sources after this one
        for(const name in this.sources){
            const other = this.sources[name];
            if (other.range.startIndex > source.range.startIndex) {
                const range = other.range.offset(-source.range.count);
                console.debug(`Updating range for dictionary '${other.name}' from (${other.range.toString()}) to (${range.toString()}).`);
                this.sources[name] = other.withRange(range);
            }
        }
        console.debug(`Words unloaded. New word count: ${this.words.length}`);
    }
    static Range = class {
        endIndex;
        count;
        startIndex;
        constructor(startIndex, endIndex){
            this.startIndex = startIndex;
            this.endIndex = endIndex;
            this.count = endIndex - startIndex + 1;
        }
        contains(index) {
            return index >= this.startIndex && index <= this.endIndex;
        }
        extract(words) {
            words.splice(this.startIndex, this.count);
        }
        offset(count) {
            return new $7dbf3b60a5ee77ad$export$4ee70ab773570fb9.Range(this.startIndex + count, this.endIndex + count);
        }
        toString() {
            return [
                this.startIndex,
                this.endIndex
            ].join(',');
        }
    };
    static Source = class {
        name;
        range;
        url;
        constructor(name, url, range){
            this.name = name;
            this.url = url;
            this.range = range;
        }
        withRange(range) {
            return new $7dbf3b60a5ee77ad$export$4ee70ab773570fb9.Source(this.name, this.url, range);
        }
    };
    static BaseUrl = 'https://raw.githubusercontent.com/kflorence/word-list/';
    static Names = Object.freeze({
        Default: 'default',
        Profanity: 'profanity'
    });
    static Sources = Object.freeze({
        Default: new $7dbf3b60a5ee77ad$export$4ee70ab773570fb9.Source($7dbf3b60a5ee77ad$export$4ee70ab773570fb9.Names.Default, `${$7dbf3b60a5ee77ad$export$4ee70ab773570fb9.BaseUrl}/d00c2d094a4a4c68da1722eec3e83cd5078af771/words.txt`),
        Profanity: new $7dbf3b60a5ee77ad$export$4ee70ab773570fb9.Source($7dbf3b60a5ee77ad$export$4ee70ab773570fb9.Names.Profanity, `${$7dbf3b60a5ee77ad$export$4ee70ab773570fb9.BaseUrl}/d00c2d094a4a4c68da1722eec3e83cd5078af771/words-profanity.txt`)
    });
    static SourcesByName = Object.freeze(Object.fromEntries(Object.entries($7dbf3b60a5ee77ad$export$4ee70ab773570fb9.Names).map(([key, name])=>[
            name,
            $7dbf3b60a5ee77ad$export$4ee70ab773570fb9.Sources[key]
        ])));
}





class $89326aeeb2232301$export$a0db4e1d2ed78ba0 {
    characters;
    configuration;
    dictionary;
    rand;
    wordBoundaries;
    words;
    #invalidSteps = {};
    #maxTries;
    #path = [];
    #steps;
    #tries = 0;
    #restartThreshold;
    constructor(configuration, dictionary){
        this.rand = (0, $c5a0b96abcd6dbcd$export$ea27ae0a69e9255c)(configuration.hash);
        this.words = dictionary.getWords(this.rand, configuration.size, Math.ceil(configuration.width + configuration.width / 2));
        const words = Array.from(this.words);
        const characters = words.reduce((characters, word)=>characters.concat(word.split('')), []);
        if (configuration.mode === (0, $f3a1510773f18396$export$ef2184bd89960b14).Modes.Challenge) {
            // Randomly reverse up to half of the words
            const reverseCount = (0, $c5a0b96abcd6dbcd$export$f863c42fae7e138a)(this.rand, Math.floor(words.length / 2));
            console.debug(`Reversing ${reverseCount} words.`);
            (0, $c5a0b96abcd6dbcd$export$c8245504e56d23ee)(this.rand, words, reverseCount).forEach((index)=>{
                words[index] = (0, $c5a0b96abcd6dbcd$export$4b9a4be687eeedb5)(words[index]);
            });
        }
        this.characters = characters;
        this.configuration = configuration;
        this.dictionary = dictionary;
        this.wordBoundaries = $89326aeeb2232301$export$a0db4e1d2ed78ba0.getWordBoundaries(this.words);
        this.#steps = new Array(configuration.size);
        this.#restartThreshold = configuration.size * configuration.width;
        this.#maxTries = this.#restartThreshold * configuration.size;
    }
    /**
   * Generate grid state configuration.
   * @returns {Grid.State.Configuration}
   */ generate() {
        while(this.#path.length < this.configuration.size)this.#step();
        const cells = this.#steps.map((step)=>step.state);
        const path = this.#path.map((step)=>step.index);
        const wordIndexes = this.wordBoundaries.map((boundary)=>boundary.map((index)=>path[index]));
        console.debug('Done.', path);
        return new (0, $f3a1510773f18396$export$ef2184bd89960b14).State.Configuration(cells, path, this.words, wordIndexes);
    }
    #getAvailableCellIndexes() {
        // Return an array of all indexes that don't contain a value
        return [
            ...this.#steps
        ].flatMap((v, i)=>v === undefined ? [
                i
            ] : []);
    }
    #getConnectableIndexes(pool) {
        const connectable = [];
        const queue = [];
        const visited = {};
        function dequeue() {
            const index = queue.pop();
            connectable.push(index);
            // Remove this index from the pool
            pool.splice(pool.indexOf(index), 1);
            return index;
        }
        function enqueue(index) {
            visited[index] = true;
            queue.push(index);
        }
        // Start processing from the end
        enqueue(pool[pool.length - 1]);
        while(queue.length > 0){
            const index = dequeue();
            const coordinates = this.configuration.getCoordinates(index);
            const validIndexes = pool.filter((index)=>!visited[index]);
            if (validIndexes.length) // Enqueue all valid neighbors
            this.#getNeighbors(coordinates, validIndexes).forEach((neighbor)=>enqueue(this.configuration.getIndex(neighbor.coordinates)));
        }
        return connectable.sort((a, b)=>a - b);
    }
    #getConnectableGroups(indexes) {
        const groups = [];
        const pool = Array.from(indexes);
        while(pool.length > 0)groups.push(this.#getConnectableIndexes(pool));
        return groups;
    }
    #getNeighbors(coordinates, validIndexes) {
        if (!validIndexes.length) return [];
        return coordinates.getNeighbors().filter((neighbor)=>{
            if (!this.configuration.isValid(neighbor.coordinates)) return false;
            const index = this.configuration.getIndex(neighbor.coordinates);
            if (validIndexes && !validIndexes.includes(index)) return false;
            if (neighbor.isDirectionDiagonal) {
                // console.log('neighbor is directional', neighbor)
                const [source, target] = neighbor.coordinates.getNeighborsCrossing(coordinates).map((neighbor)=>{
                    const index = this.configuration.getIndex(neighbor.coordinates);
                    return this.#steps[index];
                });
                // console.log(source, target, source?.isConnected(target))
                if (source?.isConnected(target)) // Eliminate neighbors that cannot be reached due to crossing paths
                return false;
            }
            return true;
        });
    }
    #step() {
        this.#tries++;
        const steps = this.#path.length;
        const stepsRemaining = this.configuration.size - steps;
        console.debug(`Steps remaining: ${stepsRemaining}. Total tries: ${this.#tries}`);
        if (this.#tries > this.#maxTries) // Shouldn't happen, but break the loop if it gets stuck for some reason.
        throw new Error(`Too many tries: ${this.#tries}. Stopping.`);
        else if (this.#tries % this.#restartThreshold === 0) {
            // Sometimes a random path causes too many choices. To speed things up, restart every X number of tries.
            console.debug('Exhausted tries on current path. Starting over.');
            this.#restart();
        }
        const availableCellIndexes = this.#getAvailableCellIndexes();
        const lastStep = this.#path[steps - 1];
        if (!lastStep) {
            // First step
            const index = (0, $c5a0b96abcd6dbcd$export$f863c42fae7e138a)(this.rand, availableCellIndexes.length - 1);
            this.#addStep(availableCellIndexes[index]);
            return;
        }
        // Filter out any steps we have already determined to be invalid from this point.
        const validStepIndexes = availableCellIndexes.filter((index)=>!this.#invalidSteps[$89326aeeb2232301$var$Step.key(lastStep.key, index)]);
        // The minimum group size after picking the next step
        const minGroupSize = stepsRemaining - 1;
        const validNeighbors = this.#getNeighbors(lastStep.coordinates, validStepIndexes).filter((neighbor)=>{
            const index = this.configuration.getIndex(neighbor.coordinates);
            // Assess groupability of available indexes assuming this neighbor is picked, and so removed from availability.
            const groupableIndexes = availableCellIndexes.filter((available)=>available !== index);
            const groups = this.#getConnectableGroups(groupableIndexes);
            console.debug('Found groups', groups, 'for neighbor', neighbor, 'with available indexes', groupableIndexes);
            if (groups.length > 1) {
                console.debug('Excluding neighbor: multiple groups', neighbor);
                return false;
            } else if (groups.length === 1 && groups[0].length < minGroupSize) {
                // Picking this neighbor would result in a group that is too small for the number of remaining steps.
                console.debug('Excluding neighbor: group is too small', neighbor);
                return false;
            }
            return true;
        });
        if (!validNeighbors.length) {
            console.debug('No valid steps from here. Removing last step and trying again.');
            return this.#removeLastStep();
        }
        // Pick a random neighbor from the list of valid neighbors to step to
        const index = (0, $c5a0b96abcd6dbcd$export$f863c42fae7e138a)(this.rand, validNeighbors.length - 1);
        this.#addStep(this.configuration.getIndex(validNeighbors[index].coordinates), lastStep);
    }
    #addStep(index, lastStep) {
        const coordinates = this.configuration.getCoordinates(index);
        const character = this.characters[this.#path.length];
        const step = new $89326aeeb2232301$var$Step(new (0, $28857821e2b8567e$export$f6f0c3fe4ec306ea).State(index, character), coordinates, lastStep);
        this.#steps[index] = step;
        this.#path.push(step);
        console.debug('Added step:', step);
    }
    #removeLastStep() {
        const step = this.#path.pop();
        const index = step.index;
        delete this.#steps[index];
        // Mark this choice as invalid so we don't try it again
        this.#invalidSteps[step.key] = true;
        console.debug('Removed step:', step);
    }
    #restart() {
        while(this.#path.length > 0)this.#removeLastStep();
        for(const key in this.#invalidSteps)this.#invalidSteps[key] = {};
    }
    static getWordBoundaries(words) {
        return words.reduce((boundaries, word)=>{
            const last = boundaries[boundaries.length - 1];
            const lastIndex = last ? last[last.length - 1] + 1 : 0;
            boundaries.push([
                ...word.split('').map((_, index)=>lastIndex + index)
            ]);
            return boundaries;
        }, []);
    }
}
class $89326aeeb2232301$var$Step {
    coordinates;
    index;
    key;
    parent;
    state;
    constructor(state, coordinates, parent){
        this.coordinates = coordinates;
        this.index = state.index;
        this.key = parent ? $89326aeeb2232301$var$Step.key(parent.key, this.index) : this.index.toString();
        this.parent = parent;
        this.state = state;
    }
    equals(other) {
        return this.index === other?.index;
    }
    isConnected(other) {
        return (this.parent?.equals(other) || other?.parent?.equals(this)) === true;
    }
    static key(...parts) {
        return parts.join('.');
    }
}


const $f3a1510773f18396$var$$grid = document.getElementById('grid');
class $f3a1510773f18396$export$ef2184bd89960b14 {
    #active;
    #cells = [];
    #configuration;
    #dictionary;
    #eventListeners = new (0, $7cd91973a7925acd$export$b20b719ec758a20f)({
        context: this,
        element: $f3a1510773f18396$var$$grid
    });
    #pointerIndex = -1;
    #selection = [];
    #selectionStart;
    #state;
    constructor(dictionary, width, mode){
        this.#configuration = new $f3a1510773f18396$export$ef2184bd89960b14.Configuration($f3a1510773f18396$export$ef2184bd89960b14.getId(), width, mode);
        this.#dictionary = dictionary;
        const sharedSolution = $f3a1510773f18396$export$ef2184bd89960b14.getSolution(this.#configuration.hash);
        // Don't persist changes locally if a solution is provided in the URL
        const persistence = sharedSolution === undefined;
        const initialState = new $f3a1510773f18396$export$ef2184bd89960b14.State(undefined, sharedSolution, new $f3a1510773f18396$export$ef2184bd89960b14.State.User(), $f3a1510773f18396$export$ef2184bd89960b14.State.Version);
        this.#state = new (0, $4c3397e7d04ad378$export$7254cc27399e90bd)(this.#configuration.hash, initialState, {
            persistence: persistence
        });
        const state = this.getState();
        if (state.version < $f3a1510773f18396$export$ef2184bd89960b14.State.Version) {
            console.warn(`Ignoring stale cache with version ${state.version}. Current version: ${$f3a1510773f18396$export$ef2184bd89960b14.State.Version}`);
            this.#state.set(initialState);
        }
        if ((0, $c5a0b96abcd6dbcd$export$da1115b7645c376c).has('reset')) {
            console.debug(`Resetting solution for path '${this.#configuration.id}'.`);
            this.#resetSolution();
            (0, $c5a0b96abcd6dbcd$export$da1115b7645c376c).delete('reset');
            (0, $c5a0b96abcd6dbcd$export$55abd4691b317664).replaceState((0, $c5a0b96abcd6dbcd$export$55abd4691b317664).state, 'reset', (0, $c5a0b96abcd6dbcd$export$128fa18b7194ef));
        }
        document.body.classList.add((0, $c5a0b96abcd6dbcd$export$307b18b61172f7ed)($f3a1510773f18396$export$ef2184bd89960b14.Name, 'mode', this.#configuration.mode));
        $f3a1510773f18396$var$$grid.dataset.width = this.#configuration.width;
        this.#eventListeners.add([
            {
                type: (0, $28857821e2b8567e$export$f6f0c3fe4ec306ea).Events.Select,
                handler: this.#onSelect
            },
            {
                type: 'pointerup',
                element: document,
                handler: this.#onPointerUp
            }
        ]);
    }
    getConfiguration() {
        return this.#configuration;
    }
    getMoves() {
        return this.getState().solution.moves;
    }
    getSelection() {
        const cells = Array.from(this.#selection);
        if (!cells.length) return new $f3a1510773f18396$export$ef2184bd89960b14.Selection(cells);
        let pathIndexes = $f3a1510773f18396$export$ef2184bd89960b14.getIndexes(cells);
        const lastPathCell = this.#getLastPathCell();
        if (lastPathCell) {
            // Make sure the selection can anchor to the existing path.
            const selectionAnchorIndex = this.#getSelectionAnchorIndex(lastPathCell);
            if (selectionAnchorIndex < 0) {
                console.debug('Unable to anchor selection to existing path.');
                pathIndexes.splice(0);
            } else if (selectionAnchorIndex !== 0) {
                console.debug('Anchoring selection at end.');
                // Reverse pathIndexes to ensure they get stored in state in the proper order.
                pathIndexes.reverse();
            } else console.debug('Anchoring selection at beginning.');
        }
        let content = $f3a1510773f18396$export$ef2184bd89960b14.getContent(cells);
        let isValid = false;
        if (pathIndexes.length) {
            isValid = this.#dictionary.isValid(content);
            if (!isValid) {
                // Try the selection in reverse
                const contentReversed = (0, $c5a0b96abcd6dbcd$export$4b9a4be687eeedb5)(content);
                isValid = this.#dictionary.isValid(contentReversed);
                if (isValid) {
                    // The word was spelled backwards
                    cells.reverse();
                    content = contentReversed;
                }
            }
        }
        const state = this.getState();
        const wordIndexes = $f3a1510773f18396$export$ef2184bd89960b14.getIndexes(cells);
        const hiddenWordIndex = state.getHiddenWordIndex();
        const hiddenWordIndexes = state.configuration.wordIndexes[hiddenWordIndex] ?? [];
        const revealedIndexes = wordIndexes.filter((index)=>hiddenWordIndexes.includes(index));
        const hintIndexes = revealedIndexes.filter((index)=>!state.solution.hints.includes(index));
        const isHiddenWord = isValid && (this.#configuration.mode === $f3a1510773f18396$export$ef2184bd89960b14.Modes.Challenge ? state.configuration.words.includes(content) : isValid && state.configuration.words[hiddenWordIndex] === content && (0, $c5a0b96abcd6dbcd$export$22d6d01dd47e89dd)(hiddenWordIndexes, wordIndexes, (0, $c5a0b96abcd6dbcd$export$4f889fe9b45273af)));
        const updateIndexes = lastPathCell ? pathIndexes.concat([
            lastPathCell.getIndex()
        ]) : pathIndexes;
        if (isValid && this.#configuration.mode === $f3a1510773f18396$export$ef2184bd89960b14.Modes.Pathfinder) {
            const allHiddenWordHintIndexesUsed = hiddenWordIndexes.every((index)=>!state.solution.hints.includes(index) || wordIndexes.includes(index));
            const previouslyGuessedWordsByIndex = state.solution.moves.filter((move)=>move.type === $f3a1510773f18396$export$ef2184bd89960b14.Move.Types.Spell && move.value.hiddenWordIndex === hiddenWordIndex).map((move)=>move.value.index);
            const previouslyGuessedWordIndexes = state.solution.words.filter((word, index)=>previouslyGuessedWordsByIndex.includes(index));
            // Reject words where not all previous hint indexes have been used and duplicate guesses (by path index) for the
            // same hidden word.
            isValid = allHiddenWordHintIndexesUsed && !(0, $c5a0b96abcd6dbcd$export$22012a5c726bef55)(previouslyGuessedWordIndexes, wordIndexes);
            if (isValid && isHiddenWord) // Ensure that the path matches the generated path to prevent the user from getting stuck in the case they
            // spell a matching hidden word using the same indexes but in a different order.
            pathIndexes = Array.from(hiddenWordIndexes);
        }
        return new $f3a1510773f18396$export$ef2184bd89960b14.Selection(cells, content, pathIndexes, hintIndexes, updateIndexes, wordIndexes, hiddenWordIndex, hiddenWordIndexes, isHiddenWord, isValid);
    }
    getState() {
        return $f3a1510773f18396$export$ef2184bd89960b14.State.fromObject(this.#state.get());
    }
    getStatistics(state) {
        state ??= this.getState();
        return new $f3a1510773f18396$export$ef2184bd89960b14.Statistics(this.#configuration, state, this.getWords(state), this.#cells);
    }
    getSwaps() {
        const state = this.getState();
        return state.solution.swaps.map((indexes)=>indexes.map((index)=>{
                const cell = this.#cells[index];
                const content = state.configuration.cells[index].content;
                const coordinates = cell.getCoordinates().toString();
                return `${content} (${coordinates})`;
            }));
    }
    getWords(state) {
        state ??= this.getState();
        return state.solution.words.map((word, index)=>{
            const move = state.solution.moves.find((move)=>move.type === $f3a1510773f18396$export$ef2184bd89960b14.Move.Types.Spell && move.value.index === index);
            return new (0, $282e11ce9af396b1$export$1ee6d718c47c2db0)(this.#configuration.width, word.map((index)=>this.#cells[index]), move);
        });
    }
    hasHint(state) {
        return this.#getNextHint(state ?? this.getState()) !== undefined;
    }
    hint() {
        if (this.#configuration.mode === $f3a1510773f18396$export$ef2184bd89960b14.Modes.Challenge) // No hints in challenge mode
        return;
        const state = this.getState();
        const index = this.#getNextHint(state);
        if (index === undefined) return;
        state.solution.hints.push(index);
        state.solution.moves.push(new $f3a1510773f18396$export$ef2184bd89960b14.Move($f3a1510773f18396$export$ef2184bd89960b14.Move.Types.Hint, index));
        this.#setState(state);
        this.#update([
            index
        ]);
    }
    #getNextHint(state) {
        return state.configuration.wordIndexes[state.getHiddenWordIndex()]?.find((index)=>!state.solution.hints.includes(index));
    }
    removeSwap(index) {
        const state = this.getState();
        // Remove the swap
        const swap = state.solution.swaps.splice(index, 1)[0];
        // Update moves
        const moveIndex = state.solution.moves.findIndex((move)=>move.type === $f3a1510773f18396$export$ef2184bd89960b14.Move.Types.Swap && move.value === index);
        state.solution.moves.splice(moveIndex, 1);
        this.#setState(state);
        // If one of the swapped cells was part of a word, remove the word, too.
        const wordIndex = state.solution.words.findIndex((indexes)=>swap.some((index)=>indexes.indexOf(index) >= 0));
        if (wordIndex >= 0) this.removeWord(wordIndex);
        this.#update(swap);
    }
    removeWord(index) {
        const state = this.getState();
        // Remove the word and everything after it
        const firstRemovedWord = state.solution.words.splice(index)[0];
        const earliestPathIndex = state.solution.path.findIndex((index)=>firstRemovedWord.indexOf(index) >= 0);
        // Remove everything after and including the first matched path index.
        const pathIndexes = state.solution.path.splice(earliestPathIndex);
        // Update word validation sources
        state.solution.sources.splice(index);
        // Update moves
        state.solution.moves = state.solution.moves.filter((move)=>{
            // Remove any spell moves including and after the removed word index
            return !(move.type === $f3a1510773f18396$export$ef2184bd89960b14.Move.Types.Spell && move.value.index >= index);
        });
        this.#setState(state);
        const lastPathCellIndex = state.solution.path[state.solution.path.length - 1];
        if (lastPathCellIndex !== undefined) // Also update the last path item so the link can be removed.
        pathIndexes.push(lastPathCellIndex);
        this.#update(pathIndexes);
    }
    reset() {
        this.#resetSolution();
        this.#update($f3a1510773f18396$export$ef2184bd89960b14.getIndexes(this.#cells));
    }
    setup() {
        let configuration = this.#state.get($f3a1510773f18396$export$ef2184bd89960b14.State.Keys.Configuration);
        if (!configuration) {
            // This grid has not been generated yet. Generate it and cache it.
            const generator = new (0, $89326aeeb2232301$export$a0db4e1d2ed78ba0)(this.#configuration, this.#dictionary);
            configuration = generator.generate();
            this.#state.set($f3a1510773f18396$export$ef2184bd89960b14.State.Keys.Configuration, configuration);
        }
        const solution = this.#state.get($f3a1510773f18396$export$ef2184bd89960b14.State.Keys.Solution);
        if (!solution) this.#resetSolution();
        this.#cells = configuration.cells.map((state)=>new (0, $28857821e2b8567e$export$f6f0c3fe4ec306ea)(this.#configuration.getCoordinates(state.index), (0, $28857821e2b8567e$export$f6f0c3fe4ec306ea).State.fromObject(state)));
        this.#update($f3a1510773f18396$export$ef2184bd89960b14.getIndexes(this.#cells));
        $f3a1510773f18396$var$$grid.replaceChildren(...this.#cells.map((cell)=>cell.getElement()));
        $f3a1510773f18396$var$$grid.classList.remove($f3a1510773f18396$export$ef2184bd89960b14.ClassNames.Loading);
    }
    undo() {
        if (this.#selection.length) {
            // If there is an active selection, de-select it.
            this.#deselect(this.#selection.splice(0));
            return;
        }
        const state = this.getState();
        const moves = state.solution.moves.filter((move)=>move.type !== $f3a1510773f18396$export$ef2184bd89960b14.Move.Types.Hint);
        if (moves.length === 0) // If there are no moves, nothing to do.
        return;
        const move = moves[moves.length - 1];
        switch(move.type){
            case $f3a1510773f18396$export$ef2184bd89960b14.Move.Types.Spell:
                this.removeWord(move.value.index);
                break;
            case $f3a1510773f18396$export$ef2184bd89960b14.Move.Types.Swap:
                this.removeSwap(move.value);
                break;
        }
    }
    #activate(cell) {
        this.#deactivate();
        cell.update((state)=>state.copy({
                flags: state.getFlags().add((0, $28857821e2b8567e$export$f6f0c3fe4ec306ea).Flags.Active)
            }));
        this.#active = cell;
    }
    #anchorSelection(lastPathItem) {
        const anchor = this.#selection[this.#getSelectionAnchorIndex(lastPathItem)];
        if (anchor) {
            // Visually anchor the selection to the end of the path.
            const direction = lastPathItem.getDirection(anchor);
            lastPathItem.update((state)=>state.copy({
                    flags: state.getFlags().add((0, $28857821e2b8567e$export$f6f0c3fe4ec306ea).FlagsByName[direction])
                }));
        }
    }
    #deactivate() {
        if (!this.#active) return;
        this.#active.update((state)=>state.copy({
                flags: state.getFlags().remove((0, $28857821e2b8567e$export$f6f0c3fe4ec306ea).Flags.Active)
            }));
        this.#active = undefined;
    }
    #deselect(selection) {
        selection.forEach((cell)=>cell.reset());
        const lastPathCell = this.#getLastPathCell();
        if (lastPathCell) this.#update([
            lastPathCell.getIndex()
        ]);
        this.#dispatch($f3a1510773f18396$export$ef2184bd89960b14.Events.Selection);
    }
    #dispatch(name, detail = null) {
        const event = new CustomEvent(name, {
            detail: detail
        });
        // Ensure event is emitted after any currently processing events have been handled
        setTimeout(()=>document.dispatchEvent(event));
    }
    #getLastPathCell() {
        const state = this.getState();
        const path = state.solution.path;
        return this.#cells[path[path.length - 1]];
    }
    #getSelectionAnchorIndex(lastPathCell) {
        if (this.#selection.length === 0) return;
        lastPathCell ??= this.#getLastPathCell();
        if (!lastPathCell) return;
        // Try to anchor at the head of the selection first.
        const indexes = [
            0
        ];
        const lastIndex = this.#selection.length - 1;
        if (lastIndex !== 0) indexes.push(lastIndex);
        return indexes.find((index)=>{
            const cell = this.#selection[index];
            return !cell.getFlags().has((0, $28857821e2b8567e$export$f6f0c3fe4ec306ea).Flags.Swap) && this.#isValid(lastPathCell, cell);
        }) ?? -1;
    }
    #isCrossing(source, target) {
        // Get the neighbors that if connected would cause the path to cross
        const [first, second] = source.getCoordinates().getNeighborsCrossing(target.getCoordinates()).map((neighbor)=>this.#cells[this.#configuration.getIndex(neighbor.coordinates)]);
        // Check both of them to see if they are connected to the other one in any direction.
        return first?.isConnected(second) || second?.isConnected(first) || false;
    }
    #isValid(source, target) {
        return source?.isNeighbor(target) && !this.#isCrossing(source, target);
    }
    #onPointerUp(event) {
        this.#deactivate();
        if (!this.#selectionStart) {
            // User did not tap on a cell.
            if (!event.target.closest('#grid') && !event.target.closest('#undo')) // User tapped outside the grid area and not on the undo button, de-select everything.
            this.#deselect(this.#selection.splice(0));
            return;
        }
        const length = this.#selection.length;
        const count = length - this.#selectionStart.length;
        if (count > 1) // User selected multiple cells before pointerup was fired. Validate the selection.
        this.#validate();
        else if (length === 2) {
            const last = this.#selection[length - 1];
            if (last.getFlags().has((0, $28857821e2b8567e$export$f6f0c3fe4ec306ea).Flags.Swap)) this.#swap(...this.#selection.splice(0));
        }
        this.#selectionStart = undefined;
    }
    #onSelect(event) {
        if (!this.#selectionStart && event.detail.event.type !== 'pointerdown') {
            console.debug('Ignoring cell events prior to pointerdown.');
            // Mobile sends out a 'pointerenter' event before the first 'pointerdown'.
            // Ignore it, otherwise onSelect will get called multiple times for a single touch.
            return;
        }
        const cell = event.detail.cell;
        this.#activate(cell);
        if (cell.getFlags().has((0, $28857821e2b8567e$export$f6f0c3fe4ec306ea).Flags.Validated)) // These cells cannot be selected
        return;
        // User is doing a multi-select if multiple onSelect events have been fired before pointerup resets selectionStart.
        const isMultiSelect = this.#selectionStart !== undefined;
        if (!isMultiSelect) // Save a reference to the first selection event.
        this.#selectionStart = new $f3a1510773f18396$export$ef2184bd89960b14.SelectionStart(event, this.#selection.length);
        else if (this.#selection.length === 0) {
            console.debug('SelectMultiple: Selection was cleared during multi-select. Wait for pointerup before continuing.');
            return;
        }
        const flags = [];
        const lastCell = this.#selection[this.#selection.length - 1];
        const selectedIndex = this.#selection.findIndex((selected)=>selected.equals(cell));
        if (lastCell?.getFlags().has((0, $28857821e2b8567e$export$f6f0c3fe4ec306ea).Flags.Swap)) this.#onSwap(cell, lastCell, flags, selectedIndex, isMultiSelect);
        else {
            const isNeighbor = cell.isNeighbor(lastCell);
            const isValid = this.#isValid(lastCell, cell);
            if (isMultiSelect) this.#onSelectMultiple(cell, lastCell, flags, selectedIndex, isValid);
            else this.#onSelectSingle(cell, lastCell, flags, selectedIndex, isNeighbor, isValid);
        }
        if (flags.includes((0, $28857821e2b8567e$export$f6f0c3fe4ec306ea).Flags.Path)) flags.push((0, $28857821e2b8567e$export$f6f0c3fe4ec306ea).FlagsByName[cell.getDirection(lastCell)], (0, $28857821e2b8567e$export$f6f0c3fe4ec306ea).Flags.Selected);
        const lastPathCell = this.#getLastPathCell();
        if (lastPathCell) {
            // Update the visual anchor of selection to path.
            this.#update([
                lastPathCell.getIndex()
            ]);
            if (this.#selection.length && !flags.includes((0, $28857821e2b8567e$export$f6f0c3fe4ec306ea).Flags.Swap)) this.#anchorSelection(lastPathCell);
        }
        if (flags.length) {
            cell.update((state)=>state.copy({
                    flags: state.getFlags().add(...flags)
                }));
            this.#dispatch($f3a1510773f18396$export$ef2184bd89960b14.Events.Selection);
        }
    }
    #onSelectMultiple(cell, lastCell, flags, selectedIndex, isValid) {
        if (selectedIndex >= 0) {
            console.debug('SelectMultiple: Re-selecting a previously selected cell. De-select everything after it.');
            this.#deselect(this.#selection.splice(selectedIndex + 1));
        } else if (isValid) {
            console.debug('SelectMultiple: A valid new cell has been selected.');
            this.#selection.push(cell);
            flags.push((0, $28857821e2b8567e$export$f6f0c3fe4ec306ea).Flags.Path);
        } else console.debug('SelectMultiple: Invalid cell selected. Ignoring.');
    }
    #onSelectSingle(cell, lastCell, flags, selectedIndex, isNeighbor, isValid) {
        if (selectedIndex >= 0) {
            // An already selected cell was tapped.
            if (// No swaps outside of challenge mode
            this.#configuration.mode === $f3a1510773f18396$export$ef2184bd89960b14.Modes.Challenge && this.#selection.length === 1 && !cell.getFlags().has((0, $28857821e2b8567e$export$f6f0c3fe4ec306ea).Flags.Swapped)) {
                console.debug('SelectSingle: A non-swapped selected cell has been re-tapped. Mark for swap.');
                flags.push((0, $28857821e2b8567e$export$f6f0c3fe4ec306ea).Flags.Swap);
            } else {
                const lastSelectionIndex = this.#selection.length - 1;
                if (this.#selection.length >= (0, $282e11ce9af396b1$export$1ee6d718c47c2db0).minimumLength && selectedIndex === lastSelectionIndex) {
                    console.debug('SelectSingle: Submitting selection for validation.');
                    this.#validate();
                } else {
                    console.debug('SelectSingle: Re-selecting a previously selected cell. De-select everything after it.');
                    this.#deselect(this.#selection.splice(selectedIndex + 1));
                }
            }
        } else if (!isNeighbor) {
            if (this.#selection.length) {
                console.debug('SelectSingle: A non-neighboring cell has been selected. De-select everything else.');
                this.#deselect(this.#selection.splice(0));
            }
            this.#selection.push(cell);
            flags.push((0, $28857821e2b8567e$export$f6f0c3fe4ec306ea).Flags.Selected);
        } else if (isValid) {
            console.debug('SelectSingle: A valid new cell has been selected.');
            this.#selection.push(cell);
            flags.push((0, $28857821e2b8567e$export$f6f0c3fe4ec306ea).Flags.Path);
        } else console.debug('SelectSingle: Invalid cell selected. Ignoring.');
    }
    #onSwap(cell, lastCell, flags, selectedIndex, isMultiSelect) {
        if (isMultiSelect) {
            console.debug('Swap: Multiple target cells selected. De-selecting everything except source cell.');
            this.#deselect(this.#selection.splice(1));
        } else if (// User tapped a cell marked for swap or already swapped
        cell.getFlags().has((0, $28857821e2b8567e$export$f6f0c3fe4ec306ea).Flags.Swap, (0, $28857821e2b8567e$export$f6f0c3fe4ec306ea).Flags.Swapped) || // User tapped a cell with the same content as the cell marked for swap
        cell.getContent() === lastCell.getContent()) {
            console.debug('Swap: Invalid target cell selected. Cancelling swap.');
            this.#deselect(this.#selection.splice(0));
        } else if (!cell.getFlags().has((0, $28857821e2b8567e$export$f6f0c3fe4ec306ea).Flags.Swapped)) {
            console.debug('Swap: Valid target cell selected. Initiating swap.');
            flags.push((0, $28857821e2b8567e$export$f6f0c3fe4ec306ea).Flags.Swap);
            this.#selection.push(cell);
        }
    }
    #resetSolution() {
        this.#state.update((state)=>{
            const hash = this.#configuration.hash;
            const hints = this.#configuration.mode === $f3a1510773f18396$export$ef2184bd89960b14.Modes.Pathfinder ? [
                state.configuration.path[0]
            ] : [];
            state.solution = $f3a1510773f18396$export$ef2184bd89960b14.State.Solution.fromObject({
                hash: hash,
                hints: hints
            });
        });
    }
    #setState(state) {
        this.#state.set(state);
        if ((0, $c5a0b96abcd6dbcd$export$da1115b7645c376c).has($f3a1510773f18396$export$ef2184bd89960b14.Params.Solution.key)) // Update solution URL parameter if present
        $f3a1510773f18396$export$ef2184bd89960b14.Params.Solution.set(state.solution);
    }
    #swap(source, target) {
        const state = this.getState();
        const swap = [
            source.getIndex(),
            target.getIndex()
        ];
        state.solution.swaps.push(swap);
        // Update moves
        state.solution.moves.push(new $f3a1510773f18396$export$ef2184bd89960b14.Move($f3a1510773f18396$export$ef2184bd89960b14.Move.Types.Swap, state.solution.swaps.length - 1));
        this.#setState(state);
        this.#update(swap);
    }
    /**
   * This method is responsible for updating the state of cells belonging to the given indexes by examining the current
   * state of the grid.
   * @param indexes The indexes of the cells to update.
   */ #update(indexes) {
        const state = this.getState();
        const cells = state.configuration.cells;
        const hints = state.solution.hints;
        const path = state.solution.path;
        const swaps = state.solution.swaps;
        const words = this.#configuration.mode === $f3a1510773f18396$export$ef2184bd89960b14.Modes.Pathfinder ? state.configuration.wordIndexes : state.solution.words;
        const lastPathIndex = path.length - 1;
        indexes.forEach((index)=>{
            const cell = this.#cells[index];
            let content = cells[index].content;
            const flags = new (0, $6b10fa0db6bfe928$export$434ba092ed0eee4e)();
            // Handle cells that have a hint
            const hintIndex = hints.indexOf(index);
            if (hintIndex >= 0) {
                flags.add((0, $28857821e2b8567e$export$f6f0c3fe4ec306ea).Flags.Hint);
                if (hintIndex === 0) flags.add((0, $28857821e2b8567e$export$f6f0c3fe4ec306ea).Flags.First);
            }
            // Handle swapped cells
            const swap = swaps.find((indexes)=>indexes.includes(index));
            if (swap) {
                flags.add((0, $28857821e2b8567e$export$f6f0c3fe4ec306ea).Flags.Swapped);
                const targetIndex = swap.indexOf(index) === 0 ? swap[1] : swap[0];
                content = cells[targetIndex].content;
            }
            // Handle cells that are part of the path
            const pathIndex = path.indexOf(index);
            if (pathIndex >= 0) {
                flags.add((0, $28857821e2b8567e$export$f6f0c3fe4ec306ea).Flags.Path);
                const nextPathIndex = path[pathIndex + 1];
                if (nextPathIndex !== undefined) {
                    // Link current cell to next cell
                    const nextCell = this.#cells[nextPathIndex];
                    flags.add((0, $28857821e2b8567e$export$f6f0c3fe4ec306ea).FlagsByName[cell.getDirection(nextCell)]);
                }
                if (pathIndex === 0) flags.add((0, $28857821e2b8567e$export$f6f0c3fe4ec306ea).Flags.First);
                if (pathIndex === lastPathIndex) {
                    if (lastPathIndex !== this.#pointerIndex && this.#pointerIndex >= 0) // Remove flag from the old last path item
                    this.#cells[this.#pointerIndex].update((state)=>state.copy({
                            flags: state.getFlags().remove((0, $28857821e2b8567e$export$f6f0c3fe4ec306ea).Flags.Last)
                        }));
                    flags.add((0, $28857821e2b8567e$export$f6f0c3fe4ec306ea).Flags.Last);
                }
                // Handle cells that are part of a word
                const word = words.find((indexes)=>indexes.includes(index));
                if (word) {
                    flags.add((0, $28857821e2b8567e$export$f6f0c3fe4ec306ea).Flags.Validated);
                    const lastWordIndex = word.length - 1;
                    // If the starting path index of the word is later in the path than the ending path index of the word, the
                    // word was spelled in reverse
                    const isReversed = path.indexOf(word[0]) > path.indexOf(word[lastWordIndex]);
                    const wordIndexes = isReversed ? Array.from(word).reverse() : word;
                    const wordIndex = wordIndexes.indexOf(index);
                    if ((0, $c5a0b96abcd6dbcd$export$22012a5c726bef55)(state.configuration.wordIndexes, wordIndexes, (0, $c5a0b96abcd6dbcd$export$4f889fe9b45273af))) // The user has spelled a hidden word using the optimal path.
                    flags.add((0, $28857821e2b8567e$export$f6f0c3fe4ec306ea).Flags.Revealed);
                    if (wordIndex === 0) flags.add((0, $28857821e2b8567e$export$f6f0c3fe4ec306ea).Flags.WordStart);
                    else if (wordIndex === lastWordIndex) flags.add((0, $28857821e2b8567e$export$f6f0c3fe4ec306ea).Flags.WordEnd);
                }
            }
            cell.update((state)=>state.copy({
                    content: content,
                    flags: flags
                }));
        });
        this.#pointerIndex = lastPathIndex;
        const statistics = this.getStatistics(state);
        if (statistics.score > state.user.highScore) {
            state.user.highScore = statistics.score;
            this.#setState(state);
        }
        this.#dispatch($f3a1510773f18396$export$ef2184bd89960b14.Events.Update);
    }
    /**
   * Responsible for validating a selection of cells by index to see if the user has spelled a valid word.
   */ #validate() {
        const selection = this.getSelection();
        this.#deselect(this.#selection.splice(0));
        if (!selection.pathIndexes.length || !selection.isValidWord) return;
        const state = this.getState();
        // Add the dictionary used to verify the word
        state.solution.sources.push(this.#dictionary.getSource(selection.content));
        // Add the spelled word to the list of spelled words
        state.solution.words.push(selection.wordIndexes);
        // Update moves
        const index = state.solution.words.length - 1;
        const match = selection.match;
        const hiddenWordIndex = selection.hiddenWordIndex;
        state.solution.moves.push(new $f3a1510773f18396$export$ef2184bd89960b14.Move($f3a1510773f18396$export$ef2184bd89960b14.Move.Types.Spell, {
            index: index,
            match: match,
            hiddenWordIndex: hiddenWordIndex
        }));
        // Update path
        switch(this.#configuration.mode){
            case $f3a1510773f18396$export$ef2184bd89960b14.Modes.Challenge:
                // In challenge mode, all valid words are added to the path.
                state.solution.path.push(...selection.pathIndexes);
                break;
            case $f3a1510773f18396$export$ef2184bd89960b14.Modes.Pathfinder:
                // In pathfinding mode, only hidden words can be added to the path.
                if (selection.isHiddenWord) state.solution.path.push(...selection.pathIndexes);
                else if (selection.hintIndexes.length) // Add hints to any portion of the next hidden word that were revealed by the valid word.
                state.solution.hints.push(...selection.hintIndexes);
                break;
            default:
                throw new Error(`Unsupported mode: ${this.#configuration.mode}.`);
        }
        this.#setState(state);
        this.#update(selection.updateIndexes);
    }
    static getContent(cells) {
        return cells.map((cell)=>cell.getContent()).join('');
    }
    /**
   * Get the indexes of the given cells.
   * @param cells
   * @returns {number[]}
   */ static getIndexes(cells) {
        return cells.map((cell)=>cell.getIndex());
    }
    static getId() {
        const id = $f3a1510773f18396$export$ef2184bd89960b14.Params.Id.get();
        return id === undefined || $f3a1510773f18396$export$ef2184bd89960b14.DateRegex.test(id) && Date.parse(id) > $f3a1510773f18396$export$ef2184bd89960b14.Today ? $f3a1510773f18396$export$ef2184bd89960b14.DefaultId : id;
    }
    static getMode() {
        const mode = $f3a1510773f18396$export$ef2184bd89960b14.Params.Mode.get();
        return Object.values($f3a1510773f18396$export$ef2184bd89960b14.Modes).includes(mode) ? mode : $f3a1510773f18396$export$ef2184bd89960b14.DefaultMode;
    }
    static getSolution(hash) {
        const solution = $f3a1510773f18396$export$ef2184bd89960b14.Params.Solution.get();
        if (solution?.hash === hash) return solution;
    }
    static getWidth() {
        const width = Number($f3a1510773f18396$export$ef2184bd89960b14.Params.Width.get());
        return $f3a1510773f18396$export$ef2184bd89960b14.Widths.includes(width) ? width : $f3a1510773f18396$export$ef2184bd89960b14.DefaultWidth;
    }
    static Name = 'grid';
    static ClassNames = Object.freeze({
        Loading: (0, $c5a0b96abcd6dbcd$export$307b18b61172f7ed)($f3a1510773f18396$export$ef2184bd89960b14.Name, 'loading')
    });
    static DateRegex = /^\d{4}-\d{2}-\d{2}$/;
    static DefaultId = (0, $c5a0b96abcd6dbcd$export$1f72301cb8058614)(new Date());
    static Events = Object.freeze({
        Selection: (0, $c5a0b96abcd6dbcd$export$307b18b61172f7ed)($f3a1510773f18396$export$ef2184bd89960b14.Name, 'selection'),
        Update: (0, $c5a0b96abcd6dbcd$export$307b18b61172f7ed)($f3a1510773f18396$export$ef2184bd89960b14.Name, 'update')
    });
    static Match = Object.freeze({
        Exact: 'exact',
        None: 'none',
        Partial: 'partial'
    });
    static Modes = Object.freeze({
        Challenge: 'challenge',
        Pathfinder: 'pathfinder'
    });
    static Params = Object.freeze({
        Id: (0, $40d8a77a984c51a9$export$94affb487e701bf2).urlParams('id'),
        Mode: (0, $40d8a77a984c51a9$export$94affb487e701bf2).urlParams('mode'),
        Solution: new (0, $40d8a77a984c51a9$export$94affb487e701bf2)('solution', (0, $c5a0b96abcd6dbcd$export$da1115b7645c376c).get.bind((0, $c5a0b96abcd6dbcd$export$da1115b7645c376c)), (key, value)=>{
            (0, $c5a0b96abcd6dbcd$export$da1115b7645c376c).set(key, value);
            (0, $c5a0b96abcd6dbcd$export$55abd4691b317664).pushState({
                [key]: value
            }, '', (0, $c5a0b96abcd6dbcd$export$128fa18b7194ef));
        }, [
            (0, $40d8a77a984c51a9$export$94affb487e701bf2).Encoders.Base64,
            (0, $40d8a77a984c51a9$export$94affb487e701bf2).Encoders.Json
        ]),
        Width: (0, $40d8a77a984c51a9$export$94affb487e701bf2).urlParams('width')
    });
    static Today = Date.parse($f3a1510773f18396$export$ef2184bd89960b14.DefaultId);
    static Widths = Object.freeze([
        5,
        7,
        9
    ]);
    static DefaultMode = $f3a1510773f18396$export$ef2184bd89960b14.Modes.Challenge;
    static DefaultWidth = $f3a1510773f18396$export$ef2184bd89960b14.Widths[0];
    static SelectionStart = class {
        event;
        length;
        constructor(event, length){
            this.event = event;
            this.length = length;
        }
    };
    static Configuration = class {
        hash;
        id;
        maxColumn;
        maxRow;
        mode;
        seed;
        size;
        width;
        constructor(id, width, mode, hash){
            this.id = id ?? $f3a1510773f18396$export$ef2184bd89960b14.getId();
            this.mode = mode ?? $f3a1510773f18396$export$ef2184bd89960b14.getMode();
            this.width = width ?? $f3a1510773f18396$export$ef2184bd89960b14.getWidth();
            this.maxColumn = this.maxRow = this.width - 1;
            this.size = this.width * this.width;
            // Anything that influences the outcome of the grid should be passed in here
            this.seed = [
                this.mode,
                this.width,
                this.id
            ].join(':');
            this.hash = hash ?? (0, $c5a0b96abcd6dbcd$export$f09b504682b60c87)(this.seed);
        }
        getCoordinates(index) {
            return new (0, $274095b041d6d131$export$d6e0f5996cc55599)(this.getRow(index), this.getColumn(index), this.width);
        }
        getColumn(index) {
            return index % this.width;
        }
        getIndex(coordinates) {
            return coordinates.row * this.width + coordinates.column;
        }
        getRow(index) {
            return Math.floor(index / this.width);
        }
        isValid(coordinates) {
            return coordinates.column >= 0 && coordinates.column <= this.maxColumn && coordinates.row >= 0 && coordinates.row <= this.maxRow;
        }
    };
    static Move = class {
        type;
        value;
        constructor(type, value){
            this.type = type;
            this.value = value;
        }
        getSymbol(mode) {
            let symbol;
            switch(this.type){
                case $f3a1510773f18396$export$ef2184bd89960b14.Move.Types.Hint:
                    symbol = $f3a1510773f18396$export$ef2184bd89960b14.Move.Symbols.LightBulb;
                    break;
                case $f3a1510773f18396$export$ef2184bd89960b14.Move.Types.Spell:
                    symbol = $f3a1510773f18396$export$ef2184bd89960b14.Move.Symbols.CircleGreen;
                    if (mode === $f3a1510773f18396$export$ef2184bd89960b14.Modes.Challenge && this.value.match === $f3a1510773f18396$export$ef2184bd89960b14.Match.Exact) symbol = $f3a1510773f18396$export$ef2184bd89960b14.Move.Symbols.CircleYellow;
                    else if (mode === $f3a1510773f18396$export$ef2184bd89960b14.Modes.Pathfinder) {
                        if (this.value.match === $f3a1510773f18396$export$ef2184bd89960b14.Match.Partial) symbol = $f3a1510773f18396$export$ef2184bd89960b14.Move.Symbols.CircleYellow;
                        else if (this.value.match === $f3a1510773f18396$export$ef2184bd89960b14.Match.None) symbol = $f3a1510773f18396$export$ef2184bd89960b14.Move.Symbols.CircleWhite;
                    }
                    break;
                case $f3a1510773f18396$export$ef2184bd89960b14.Move.Types.Swap:
                    symbol = $f3a1510773f18396$export$ef2184bd89960b14.Move.Symbols.CirclePurple;
                    break;
            }
            return symbol;
        }
        static fromObject(obj) {
            return new $f3a1510773f18396$export$ef2184bd89960b14.Move(obj.type, obj.value);
        }
        static Types = Object.freeze({
            Hint: 'hint',
            Spell: 'spell',
            Swap: 'swap'
        });
        static Symbols = Object.freeze({
            CircleGreen: "\uD83D\uDFE2",
            CirclePurple: "\uD83D\uDFE3",
            CircleWhite: "\u26AA",
            CircleYellow: "\uD83D\uDFE1",
            LightBulb: "\uD83D\uDCA1"
        });
    };
    static Selection = class {
        cells;
        content;
        hintIndexes;
        isHiddenWord;
        isValidWord;
        match;
        pathIndexes;
        hiddenWordIndex;
        hiddenWordIndexes;
        updateIndexes;
        wordIndexes;
        constructor(cells, content, pathIndexes, hintIndexes, updateIndexes, wordIndexes, hiddenWordIndex, hiddenWordIndexes, isHiddenWord, isValidWord){
            this.cells = cells;
            this.content = content;
            this.pathIndexes = pathIndexes ?? [];
            this.hintIndexes = hintIndexes ?? [];
            this.updateIndexes = updateIndexes ?? [];
            this.wordIndexes = wordIndexes ?? [];
            this.hiddenWordIndex = hiddenWordIndex ?? -1;
            this.hiddenWordIndexes = hiddenWordIndexes;
            this.isHiddenWord = isHiddenWord ?? false;
            this.isValidWord = isValidWord ?? false;
            this.match = this.isHiddenWord ? $f3a1510773f18396$export$ef2184bd89960b14.Match.Exact : this.hintIndexes.length ? $f3a1510773f18396$export$ef2184bd89960b14.Match.Partial : $f3a1510773f18396$export$ef2184bd89960b14.Match.None;
        }
    };
    static State = class {
        configuration;
        solution;
        user;
        version;
        constructor(configuration, solution, user, version){
            this.configuration = configuration;
            this.solution = solution;
            this.user = user;
            this.version = version ?? 0;
        }
        getRemainingPathIndexes() {
            return this.configuration.path.slice(this.solution.path.length);
        }
        getHiddenWordIndex(cellIndex) {
            // Use the index of the next cell in the configured path by default
            cellIndex ??= this.configuration.path[this.solution.path.length];
            return this.configuration.wordIndexes.findIndex((indexes)=>indexes.includes(cellIndex));
        }
        getSources() {
            return Array.from(new Set([
                (0, $7dbf3b60a5ee77ad$export$4ee70ab773570fb9).Names.Default
            ].concat(this.solution.sources))).sort();
        }
        static fromObject(obj) {
            return new $f3a1510773f18396$export$ef2184bd89960b14.State((0, $c5a0b96abcd6dbcd$export$b1b145d64c7b5823)(obj.configuration, $f3a1510773f18396$export$ef2184bd89960b14.State.Configuration.fromObject), (0, $c5a0b96abcd6dbcd$export$b1b145d64c7b5823)(obj.solution, $f3a1510773f18396$export$ef2184bd89960b14.State.Solution.fromObject), (0, $c5a0b96abcd6dbcd$export$b1b145d64c7b5823)(obj.user, $f3a1510773f18396$export$ef2184bd89960b14.State.User.fromObject), obj.version);
        }
        static Version = 2;
        static Configuration = class {
            cells;
            path;
            wordIndexes;
            words;
            constructor(cells, path, words, wordIndexes){
                this.cells = cells;
                this.path = path;
                this.words = words;
                this.wordIndexes = wordIndexes;
            }
            static fromObject(obj) {
                return new $f3a1510773f18396$export$ef2184bd89960b14.State.Configuration(obj.cells, obj.path, obj.words, obj.wordIndexes);
            }
        };
        static Solution = class {
            hash;
            moves;
            path;
            hints;
            sources;
            swaps;
            words;
            constructor(hash, path, moves, hints, swaps, words, sources){
                this.hash = hash;
                this.hints = hints ?? [];
                this.path = path ?? [];
                this.moves = moves ?? [];
                this.swaps = swaps ?? [];
                this.words = words ?? [];
                this.sources = sources ?? [];
            }
            static fromObject(obj) {
                return new $f3a1510773f18396$export$ef2184bd89960b14.State.Solution(obj.hash, obj.path, (0, $c5a0b96abcd6dbcd$export$b1b145d64c7b5823)(obj.moves, (moves)=>moves.map((obj)=>$f3a1510773f18396$export$ef2184bd89960b14.Move.fromObject(obj))), obj.hints, obj.swaps, obj.words, obj.sources);
            }
        };
        static User = class {
            highScore;
            constructor(highScore){
                this.highScore = highScore ?? 0;
            }
            static fromObject(obj) {
                return new $f3a1510773f18396$export$ef2184bd89960b14.State.User(obj.highScore);
            }
        };
        static Keys = Object.freeze({
            Configuration: 'configuration',
            Solution: 'solution',
            User: 'user'
        });
    };
    static Statistics = class {
        averageWordLength;
        best;
        bestDiff;
        bestPossible;
        hiddenWordCount;
        hiddenWordsGuessed;
        moves;
        progress;
        score;
        swapCount;
        wordCount;
        constructor(configuration, state, words, cells){
            const { size: size } = configuration;
            const { length: length, points: points } = words.reduce((acc, word)=>({
                    length: acc.length + word.content.length,
                    points: acc.points + word.points
                }), {
                length: 0,
                points: 0
            });
            const score = points + (length === size ? size : 0);
            const diff = state.user.highScore - score;
            const hiddenWords = state.configuration.words.map((content, index)=>new (0, $282e11ce9af396b1$export$1ee6d718c47c2db0)(configuration.width, state.configuration.wordIndexes[index].map((index)=>cells[index]), new $f3a1510773f18396$export$ef2184bd89960b14.Move($f3a1510773f18396$export$ef2184bd89960b14.Move.Types.Spell, {
                    match: $f3a1510773f18396$export$ef2184bd89960b14.Match.Exact
                })));
            this.averageWordLength = length === 0 ? 0 : (length / words.length).toPrecision(2);
            this.best = state.user.highScore;
            this.bestDiff = diff === 0 ? '=' : diff < 0 ? diff : `+${diff}`;
            this.bestPossible = hiddenWords.reduce((points, word)=>points + word.points, 0) + size;
            this.hiddenWordCount = state.configuration.words.length;
            this.hiddenWordsGuessed = state.configuration.words.filter((content)=>words.some((word)=>word.content === content)).length;
            this.moves = state.solution.moves;
            this.progress = Math.trunc(state.solution.path.length / size * 100);
            this.score = score;
            this.swapCount = state.solution.swaps.length;
            this.wordCount = words.length;
        }
    };
}
const $f3a1510773f18396$var$$gridSizeMultipliers = document.getElementById('grid-size-multipliers');
$f3a1510773f18396$export$ef2184bd89960b14.Widths.forEach((width)=>{
    const $li = document.createElement('li');
    $li.textContent = `${width}x${width} = ${(0, $282e11ce9af396b1$export$1ee6d718c47c2db0).widthMultiplier(width)}`;
    $f3a1510773f18396$var$$gridSizeMultipliers.append($li);
});



/**!
* tippy.js v6.3.7
* (c) 2017-2021 atomiks
* MIT License
*/ function $421c98f7def03b28$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}


function $29dc7b5485c2b872$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $847fa8a1c8b7e840$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $29dc7b5485c2b872$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $847fa8a1c8b7e840$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $29dc7b5485c2b872$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $847fa8a1c8b7e840$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $29dc7b5485c2b872$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


// and applies them to the HTMLElements such as popper and arrow
function $256e1e3d16d72587$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $847fa8a1c8b7e840$export$1b3bfaa9684536aa)(element) || !(0, $421c98f7def03b28$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $256e1e3d16d72587$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $847fa8a1c8b7e840$export$1b3bfaa9684536aa)(element) || !(0, $421c98f7def03b28$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $256e1e3d16d72587$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $256e1e3d16d72587$var$applyStyles,
    effect: $256e1e3d16d72587$var$effect,
    requires: [
        'computeStyles'
    ]
};


var $6ae7dd51c7efe65d$export$8960430cfd85939f = Math.max;
var $6ae7dd51c7efe65d$export$96ec731ed4dcb222 = Math.min;
var $6ae7dd51c7efe65d$export$2077e0241d6afd3c = Math.round;



function $2ac4725dd0765905$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $878e70939910a97f$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $2ac4725dd0765905$export$2e2bcd8739ae039)());
}


function $a9f9f76b2e31a8ff$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $847fa8a1c8b7e840$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $6ae7dd51c7efe65d$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $6ae7dd51c7efe65d$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $847fa8a1c8b7e840$export$45a5e7f76e0caa8d)(element) ? (0, $29dc7b5485c2b872$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $878e70939910a97f$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $25dec7cde7218cb8$export$2e2bcd8739ae039(node) {
    var win = (0, $29dc7b5485c2b872$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $4ab0cac82e4dd830$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $da14689c085ac96f$export$2e2bcd8739ae039(node) {
    if (node === (0, $29dc7b5485c2b872$export$2e2bcd8739ae039)(node) || !(0, $847fa8a1c8b7e840$export$1b3bfaa9684536aa)(node)) return (0, $25dec7cde7218cb8$export$2e2bcd8739ae039)(node);
    else return (0, $4ab0cac82e4dd830$export$2e2bcd8739ae039)(node);
}






function $eda9fa179efc25ca$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $847fa8a1c8b7e840$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $49a56a59387361d8$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $a9f9f76b2e31a8ff$export$2e2bcd8739ae039)((0, $eda9fa179efc25ca$export$2e2bcd8739ae039)(element)).left + (0, $25dec7cde7218cb8$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $85c9704214414551$export$2e2bcd8739ae039(element) {
    return (0, $29dc7b5485c2b872$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $48a1e36e987e05f9$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $85c9704214414551$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $cb662e22ab9e25a2$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $6ae7dd51c7efe65d$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $6ae7dd51c7efe65d$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $cb662e22ab9e25a2$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $847fa8a1c8b7e840$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $847fa8a1c8b7e840$export$1b3bfaa9684536aa)(offsetParent) && $cb662e22ab9e25a2$var$isElementScaled(offsetParent);
    var documentElement = (0, $eda9fa179efc25ca$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $a9f9f76b2e31a8ff$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $421c98f7def03b28$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $48a1e36e987e05f9$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $da14689c085ac96f$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $847fa8a1c8b7e840$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $a9f9f76b2e31a8ff$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $49a56a59387361d8$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $2b558eacad58df9b$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $a9f9f76b2e31a8ff$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $6514720383b3d443$export$2e2bcd8739ae039(element) {
    if ((0, $421c98f7def03b28$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $847fa8a1c8b7e840$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $eda9fa179efc25ca$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $efd68ede05cda96a$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $421c98f7def03b28$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $847fa8a1c8b7e840$export$1b3bfaa9684536aa)(node) && (0, $48a1e36e987e05f9$export$2e2bcd8739ae039)(node)) return node;
    return $efd68ede05cda96a$export$2e2bcd8739ae039((0, $6514720383b3d443$export$2e2bcd8739ae039)(node));
}





function $6125692aff59407b$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $efd68ede05cda96a$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $29dc7b5485c2b872$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $48a1e36e987e05f9$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($6125692aff59407b$export$2e2bcd8739ae039((0, $6514720383b3d443$export$2e2bcd8739ae039)(target)));
}







function $d84c344210720cda$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $421c98f7def03b28$export$2e2bcd8739ae039)(element)) >= 0;
}




function $eb735df350c664be$var$getTrueOffsetParent(element) {
    if (!(0, $847fa8a1c8b7e840$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $85c9704214414551$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $eb735df350c664be$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $2ac4725dd0765905$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $2ac4725dd0765905$export$2e2bcd8739ae039)());
    if (isIE && (0, $847fa8a1c8b7e840$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $85c9704214414551$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $6514720383b3d443$export$2e2bcd8739ae039)(element);
    if ((0, $847fa8a1c8b7e840$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $847fa8a1c8b7e840$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $421c98f7def03b28$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $85c9704214414551$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $eb735df350c664be$export$2e2bcd8739ae039(element) {
    var window = (0, $29dc7b5485c2b872$export$2e2bcd8739ae039)(element);
    var offsetParent = $eb735df350c664be$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $d84c344210720cda$export$2e2bcd8739ae039)(offsetParent) && (0, $85c9704214414551$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $eb735df350c664be$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $421c98f7def03b28$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $421c98f7def03b28$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $85c9704214414551$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $eb735df350c664be$var$getContainingBlock(element) || window;
}


var $25540fe47559f30f$export$1e95b668f3b82d = 'top';
var $25540fe47559f30f$export$40e543e69a8b3fbb = 'bottom';
var $25540fe47559f30f$export$79ffe56a765070d2 = 'right';
var $25540fe47559f30f$export$eabcd2c8791e7bf4 = 'left';
var $25540fe47559f30f$export$dfb5619354ba860 = 'auto';
var $25540fe47559f30f$export$aec2ce47c367b8c3 = [
    $25540fe47559f30f$export$1e95b668f3b82d,
    $25540fe47559f30f$export$40e543e69a8b3fbb,
    $25540fe47559f30f$export$79ffe56a765070d2,
    $25540fe47559f30f$export$eabcd2c8791e7bf4
];
var $25540fe47559f30f$export$b3571188c770cc5a = 'start';
var $25540fe47559f30f$export$bd5df0f255a350f8 = 'end';
var $25540fe47559f30f$export$390fd549c5303b4d = 'clippingParents';
var $25540fe47559f30f$export$d7b7311ec04a3e8f = 'viewport';
var $25540fe47559f30f$export$ae5ab1c730825774 = 'popper';
var $25540fe47559f30f$export$ca50aac9f3ba507f = 'reference';
var $25540fe47559f30f$export$368f9a87e87fa4e1 = /*#__PURE__*/ $25540fe47559f30f$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $25540fe47559f30f$export$b3571188c770cc5a,
        placement + "-" + $25540fe47559f30f$export$bd5df0f255a350f8
    ]);
}, []);
var $25540fe47559f30f$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($25540fe47559f30f$export$aec2ce47c367b8c3, [
    $25540fe47559f30f$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $25540fe47559f30f$export$b3571188c770cc5a,
        placement + "-" + $25540fe47559f30f$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $25540fe47559f30f$export$421679a7c3d56e = 'beforeRead';
var $25540fe47559f30f$export$aafa59e2e03f2942 = 'read';
var $25540fe47559f30f$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $25540fe47559f30f$export$c65e99957a05207c = 'beforeMain';
var $25540fe47559f30f$export$f22da7240b7add18 = 'main';
var $25540fe47559f30f$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $25540fe47559f30f$export$8d4d2d70e7d46032 = 'beforeWrite';
var $25540fe47559f30f$export$68d8715fc104d294 = 'write';
var $25540fe47559f30f$export$70a6e5159acce2e6 = 'afterWrite';
var $25540fe47559f30f$export$d087d3878fdf71d5 = [
    $25540fe47559f30f$export$421679a7c3d56e,
    $25540fe47559f30f$export$aafa59e2e03f2942,
    $25540fe47559f30f$export$6964f6c886723980,
    $25540fe47559f30f$export$c65e99957a05207c,
    $25540fe47559f30f$export$f22da7240b7add18,
    $25540fe47559f30f$export$bab79516f2d662fe,
    $25540fe47559f30f$export$8d4d2d70e7d46032,
    $25540fe47559f30f$export$68d8715fc104d294,
    $25540fe47559f30f$export$70a6e5159acce2e6
];


function $b8e65c41ade6b2ef$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $b8e65c41ade6b2ef$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $b8e65c41ade6b2ef$var$order(modifiers); // order based on phase
    return (0, $25540fe47559f30f$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $4590d4a6c2c2d1da$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $35df0834ea7de43c$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $259584f8752a4336$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $259584f8752a4336$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $259584f8752a4336$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $259584f8752a4336$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $259584f8752a4336$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $847fa8a1c8b7e840$export$45a5e7f76e0caa8d)(reference) ? (0, $6125692aff59407b$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $6125692aff59407b$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $6125692aff59407b$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $b8e65c41ade6b2ef$export$2e2bcd8739ae039)((0, $35df0834ea7de43c$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$259584f8752a4336$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $cb662e22ab9e25a2$export$2e2bcd8739ae039)(reference, (0, $eb735df350c664be$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $2b558eacad58df9b$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $4590d4a6c2c2d1da$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$259584f8752a4336$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $259584f8752a4336$export$8f7491d57c8f97a9 = /*#__PURE__*/ $259584f8752a4336$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $a6dc03b201d7eb9f$var$passive = {
    passive: true
};
function $a6dc03b201d7eb9f$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $29dc7b5485c2b872$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $a6dc03b201d7eb9f$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $a6dc03b201d7eb9f$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $a6dc03b201d7eb9f$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $a6dc03b201d7eb9f$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $a6dc03b201d7eb9f$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $a6dc03b201d7eb9f$var$effect,
    data: {}
};



function $a104544d0793a745$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}


function $9e7a6108fbefe825$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}


function $739dfb0c2e83b281$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $4fd6fbd2a9686e87$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $a104544d0793a745$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $9e7a6108fbefe825$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $25540fe47559f30f$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $25540fe47559f30f$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $25540fe47559f30f$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $25540fe47559f30f$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $739dfb0c2e83b281$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $25540fe47559f30f$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $25540fe47559f30f$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $ee56ab20e7932e96$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $4fd6fbd2a9686e87$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $ee56ab20e7932e96$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $ee56ab20e7932e96$var$popperOffsets,
    data: {}
};










var $3e03aa9366d7f94a$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $3e03aa9366d7f94a$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $6ae7dd51c7efe65d$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $6ae7dd51c7efe65d$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $3e03aa9366d7f94a$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $25540fe47559f30f$export$eabcd2c8791e7bf4);
    var sideY = (0, $25540fe47559f30f$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $eb735df350c664be$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $29dc7b5485c2b872$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $eda9fa179efc25ca$export$2e2bcd8739ae039)(popper);
            if ((0, $85c9704214414551$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $25540fe47559f30f$export$1e95b668f3b82d) || (placement === (0, $25540fe47559f30f$export$eabcd2c8791e7bf4) || placement === (0, $25540fe47559f30f$export$79ffe56a765070d2)) && variation === (0, $25540fe47559f30f$export$bd5df0f255a350f8)) {
            sideY = (0, $25540fe47559f30f$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $25540fe47559f30f$export$eabcd2c8791e7bf4) || (placement === (0, $25540fe47559f30f$export$1e95b668f3b82d) || placement === (0, $25540fe47559f30f$export$40e543e69a8b3fbb)) && variation === (0, $25540fe47559f30f$export$bd5df0f255a350f8)) {
            sideX = (0, $25540fe47559f30f$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $3e03aa9366d7f94a$var$unsetSides);
    var _ref4 = roundOffsets === true ? $3e03aa9366d7f94a$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $29dc7b5485c2b872$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $3e03aa9366d7f94a$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $a104544d0793a745$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $9e7a6108fbefe825$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $3e03aa9366d7f94a$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $3e03aa9366d7f94a$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $3e03aa9366d7f94a$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $3e03aa9366d7f94a$var$computeStyles,
    data: {}
};





function $a82dbb7d68a695b2$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $a104544d0793a745$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $25540fe47559f30f$export$eabcd2c8791e7bf4),
        (0, $25540fe47559f30f$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $25540fe47559f30f$export$eabcd2c8791e7bf4),
        (0, $25540fe47559f30f$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $a82dbb7d68a695b2$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $25540fe47559f30f$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $a82dbb7d68a695b2$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $a82dbb7d68a695b2$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $a82dbb7d68a695b2$var$offset
};


var $2687cf4c6f58fcb9$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $2687cf4c6f58fcb9$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $2687cf4c6f58fcb9$var$hash[matched];
    });
}



var $6635f5b3ad8da196$var$hash = {
    start: 'end',
    end: 'start'
};
function $6635f5b3ad8da196$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $6635f5b3ad8da196$var$hash[matched];
    });
}







function $462b59b7571433fd$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $29dc7b5485c2b872$export$2e2bcd8739ae039)(element);
    var html = (0, $eda9fa179efc25ca$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $878e70939910a97f$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $49a56a59387361d8$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $66d40ce09282bca5$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $eda9fa179efc25ca$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $25dec7cde7218cb8$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $6ae7dd51c7efe65d$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $6ae7dd51c7efe65d$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $49a56a59387361d8$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $85c9704214414551$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $6ae7dd51c7efe65d$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $5ca4490d10e2dced$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $847fa8a1c8b7e840$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $93633595d99068d6$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $59ad268ac8d9d7c8$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $a9f9f76b2e31a8ff$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $59ad268ac8d9d7c8$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $25540fe47559f30f$export$d7b7311ec04a3e8f) ? (0, $93633595d99068d6$export$2e2bcd8739ae039)((0, $462b59b7571433fd$export$2e2bcd8739ae039)(element, strategy)) : (0, $847fa8a1c8b7e840$export$45a5e7f76e0caa8d)(clippingParent) ? $59ad268ac8d9d7c8$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $93633595d99068d6$export$2e2bcd8739ae039)((0, $66d40ce09282bca5$export$2e2bcd8739ae039)((0, $eda9fa179efc25ca$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $59ad268ac8d9d7c8$var$getClippingParents(element) {
    var clippingParents = (0, $6125692aff59407b$export$2e2bcd8739ae039)((0, $6514720383b3d443$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $85c9704214414551$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $847fa8a1c8b7e840$export$1b3bfaa9684536aa)(element) ? (0, $eb735df350c664be$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $847fa8a1c8b7e840$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $847fa8a1c8b7e840$export$45a5e7f76e0caa8d)(clippingParent) && (0, $5ca4490d10e2dced$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $421c98f7def03b28$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $59ad268ac8d9d7c8$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $59ad268ac8d9d7c8$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $59ad268ac8d9d7c8$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $6ae7dd51c7efe65d$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $6ae7dd51c7efe65d$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $6ae7dd51c7efe65d$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $6ae7dd51c7efe65d$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $59ad268ac8d9d7c8$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $94f4d0ca4e1b72f7$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $7319477ce1353fd5$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $94f4d0ca4e1b72f7$export$2e2bcd8739ae039)(), paddingObject);
}


function $1707372acc01c332$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $33423740a376f8c9$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $25540fe47559f30f$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $25540fe47559f30f$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $25540fe47559f30f$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $7319477ce1353fd5$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $1707372acc01c332$export$2e2bcd8739ae039)(padding, (0, $25540fe47559f30f$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $25540fe47559f30f$export$ae5ab1c730825774) ? (0, $25540fe47559f30f$export$ca50aac9f3ba507f) : (0, $25540fe47559f30f$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $59ad268ac8d9d7c8$export$2e2bcd8739ae039)((0, $847fa8a1c8b7e840$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $eda9fa179efc25ca$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $a9f9f76b2e31a8ff$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $4fd6fbd2a9686e87$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $93633595d99068d6$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $25540fe47559f30f$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $25540fe47559f30f$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $25540fe47559f30f$export$79ffe56a765070d2),
                (0, $25540fe47559f30f$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $25540fe47559f30f$export$1e95b668f3b82d),
                (0, $25540fe47559f30f$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $190ae9b3a9ae7973$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $25540fe47559f30f$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $9e7a6108fbefe825$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $25540fe47559f30f$export$368f9a87e87fa4e1) : (0, $25540fe47559f30f$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $9e7a6108fbefe825$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $25540fe47559f30f$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $33423740a376f8c9$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $a104544d0793a745$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $71f75fa9bdffac77$var$getExpandedFallbackPlacements(placement) {
    if ((0, $a104544d0793a745$export$2e2bcd8739ae039)(placement) === (0, $25540fe47559f30f$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $2687cf4c6f58fcb9$export$2e2bcd8739ae039)(placement);
    return [
        (0, $6635f5b3ad8da196$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $6635f5b3ad8da196$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $71f75fa9bdffac77$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $a104544d0793a745$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $2687cf4c6f58fcb9$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $71f75fa9bdffac77$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $a104544d0793a745$export$2e2bcd8739ae039)(placement) === (0, $25540fe47559f30f$export$dfb5619354ba860) ? (0, $190ae9b3a9ae7973$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $a104544d0793a745$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $9e7a6108fbefe825$export$2e2bcd8739ae039)(placement) === (0, $25540fe47559f30f$export$b3571188c770cc5a);
        var isVertical = [
            (0, $25540fe47559f30f$export$1e95b668f3b82d),
            (0, $25540fe47559f30f$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $33423740a376f8c9$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $25540fe47559f30f$export$79ffe56a765070d2) : (0, $25540fe47559f30f$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $25540fe47559f30f$export$40e543e69a8b3fbb) : (0, $25540fe47559f30f$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $2687cf4c6f58fcb9$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $2687cf4c6f58fcb9$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $71f75fa9bdffac77$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $71f75fa9bdffac77$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};





function $30230d5a6d6777c7$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}



function $21699d27f11b509f$export$f28d906d67a997f3(min, value, max) {
    return (0, $6ae7dd51c7efe65d$export$8960430cfd85939f)(min, (0, $6ae7dd51c7efe65d$export$96ec731ed4dcb222)(value, max));
}
function $21699d27f11b509f$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $21699d27f11b509f$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $7b8c0f77c6b2b318$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $33423740a376f8c9$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $a104544d0793a745$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $9e7a6108fbefe825$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $739dfb0c2e83b281$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $30230d5a6d6777c7$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $25540fe47559f30f$export$1e95b668f3b82d) : (0, $25540fe47559f30f$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $25540fe47559f30f$export$40e543e69a8b3fbb) : (0, $25540fe47559f30f$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $25540fe47559f30f$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $25540fe47559f30f$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $2b558eacad58df9b$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $94f4d0ca4e1b72f7$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $21699d27f11b509f$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $eb735df350c664be$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $21699d27f11b509f$export$f28d906d67a997f3)(tether ? (0, $6ae7dd51c7efe65d$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $6ae7dd51c7efe65d$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $25540fe47559f30f$export$1e95b668f3b82d) : (0, $25540fe47559f30f$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $25540fe47559f30f$export$40e543e69a8b3fbb) : (0, $25540fe47559f30f$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $25540fe47559f30f$export$1e95b668f3b82d),
            (0, $25540fe47559f30f$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $21699d27f11b509f$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $21699d27f11b509f$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $7b8c0f77c6b2b318$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $7b8c0f77c6b2b318$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};











var $6346ab29a87013af$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $7319477ce1353fd5$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $1707372acc01c332$export$2e2bcd8739ae039)(padding, (0, $25540fe47559f30f$export$aec2ce47c367b8c3)));
};
function $6346ab29a87013af$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $a104544d0793a745$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $739dfb0c2e83b281$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $25540fe47559f30f$export$eabcd2c8791e7bf4),
        (0, $25540fe47559f30f$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $6346ab29a87013af$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $2b558eacad58df9b$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $25540fe47559f30f$export$1e95b668f3b82d) : (0, $25540fe47559f30f$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $25540fe47559f30f$export$40e543e69a8b3fbb) : (0, $25540fe47559f30f$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $eb735df350c664be$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $21699d27f11b509f$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $6346ab29a87013af$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $5ca4490d10e2dced$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $6346ab29a87013af$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $6346ab29a87013af$var$arrow,
    effect: $6346ab29a87013af$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};




function $76d01a2789f8a769$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $76d01a2789f8a769$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $25540fe47559f30f$export$1e95b668f3b82d),
        (0, $25540fe47559f30f$export$79ffe56a765070d2),
        (0, $25540fe47559f30f$export$40e543e69a8b3fbb),
        (0, $25540fe47559f30f$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $76d01a2789f8a769$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $33423740a376f8c9$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $33423740a376f8c9$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $76d01a2789f8a769$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $76d01a2789f8a769$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $76d01a2789f8a769$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $76d01a2789f8a769$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $76d01a2789f8a769$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $76d01a2789f8a769$var$hide
};




var $3dd3addecd072f67$export$d34966752335dd47 = [
    (0, $a6dc03b201d7eb9f$export$2e2bcd8739ae039),
    (0, $ee56ab20e7932e96$export$2e2bcd8739ae039),
    (0, $3e03aa9366d7f94a$export$2e2bcd8739ae039),
    (0, $256e1e3d16d72587$export$2e2bcd8739ae039),
    (0, $a82dbb7d68a695b2$export$2e2bcd8739ae039),
    (0, $71f75fa9bdffac77$export$2e2bcd8739ae039),
    (0, $7b8c0f77c6b2b318$export$2e2bcd8739ae039),
    (0, $6346ab29a87013af$export$2e2bcd8739ae039),
    (0, $76d01a2789f8a769$export$2e2bcd8739ae039)
];
var $3dd3addecd072f67$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $259584f8752a4336$export$ed5e13716264f202)({
    defaultModifiers: $3dd3addecd072f67$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


var $122ea7d6880b82fb$export$c96c811c44a42da5 = '<svg width="16" height="6" xmlns="http://www.w3.org/2000/svg"><path d="M0 6s1.796-.013 4.67-3.615C5.851.9 6.93.006 8 0c1.07-.006 2.148.887 3.343 2.385C14.233 6.005 16 6 16 6H0z"></svg>';
var $122ea7d6880b82fb$var$BOX_CLASS = "tippy-box";
var $122ea7d6880b82fb$var$CONTENT_CLASS = "tippy-content";
var $122ea7d6880b82fb$var$BACKDROP_CLASS = "tippy-backdrop";
var $122ea7d6880b82fb$var$ARROW_CLASS = "tippy-arrow";
var $122ea7d6880b82fb$var$SVG_ARROW_CLASS = "tippy-svg-arrow";
var $122ea7d6880b82fb$var$TOUCH_OPTIONS = {
    passive: true,
    capture: true
};
var $122ea7d6880b82fb$var$TIPPY_DEFAULT_APPEND_TO = function TIPPY_DEFAULT_APPEND_TO() {
    return document.body;
};
function $122ea7d6880b82fb$var$hasOwnProperty(obj, key) {
    return ({}).hasOwnProperty.call(obj, key);
}
function $122ea7d6880b82fb$var$getValueAtIndexOrReturn(value, index, defaultValue) {
    if (Array.isArray(value)) {
        var v = value[index];
        return v == null ? Array.isArray(defaultValue) ? defaultValue[index] : defaultValue : v;
    }
    return value;
}
function $122ea7d6880b82fb$var$isType(value, type) {
    var str = ({}).toString.call(value);
    return str.indexOf('[object') === 0 && str.indexOf(type + "]") > -1;
}
function $122ea7d6880b82fb$var$invokeWithArgsOrReturn(value, args) {
    return typeof value === 'function' ? value.apply(void 0, args) : value;
}
function $122ea7d6880b82fb$var$debounce(fn, ms) {
    // Avoid wrapping in `setTimeout` if ms is 0 anyway
    if (ms === 0) return fn;
    var timeout;
    return function(arg) {
        clearTimeout(timeout);
        timeout = setTimeout(function() {
            fn(arg);
        }, ms);
    };
}
function $122ea7d6880b82fb$var$removeProperties(obj, keys) {
    var clone = Object.assign({}, obj);
    keys.forEach(function(key) {
        delete clone[key];
    });
    return clone;
}
function $122ea7d6880b82fb$var$splitBySpaces(value) {
    return value.split(/\s+/).filter(Boolean);
}
function $122ea7d6880b82fb$var$normalizeToArray(value) {
    return [].concat(value);
}
function $122ea7d6880b82fb$var$pushIfUnique(arr, value) {
    if (arr.indexOf(value) === -1) arr.push(value);
}
function $122ea7d6880b82fb$var$unique(arr) {
    return arr.filter(function(item, index) {
        return arr.indexOf(item) === index;
    });
}
function $122ea7d6880b82fb$var$getBasePlacement(placement) {
    return placement.split('-')[0];
}
function $122ea7d6880b82fb$var$arrayFrom(value) {
    return [].slice.call(value);
}
function $122ea7d6880b82fb$var$removeUndefinedProps(obj) {
    return Object.keys(obj).reduce(function(acc, key) {
        if (obj[key] !== undefined) acc[key] = obj[key];
        return acc;
    }, {});
}
function $122ea7d6880b82fb$var$div() {
    return document.createElement('div');
}
function $122ea7d6880b82fb$var$isElement(value) {
    return [
        'Element',
        'Fragment'
    ].some(function(type) {
        return $122ea7d6880b82fb$var$isType(value, type);
    });
}
function $122ea7d6880b82fb$var$isNodeList(value) {
    return $122ea7d6880b82fb$var$isType(value, 'NodeList');
}
function $122ea7d6880b82fb$var$isMouseEvent(value) {
    return $122ea7d6880b82fb$var$isType(value, 'MouseEvent');
}
function $122ea7d6880b82fb$var$isReferenceElement(value) {
    return !!(value && value._tippy && value._tippy.reference === value);
}
function $122ea7d6880b82fb$var$getArrayOfElements(value) {
    if ($122ea7d6880b82fb$var$isElement(value)) return [
        value
    ];
    if ($122ea7d6880b82fb$var$isNodeList(value)) return $122ea7d6880b82fb$var$arrayFrom(value);
    if (Array.isArray(value)) return value;
    return $122ea7d6880b82fb$var$arrayFrom(document.querySelectorAll(value));
}
function $122ea7d6880b82fb$var$setTransitionDuration(els, value) {
    els.forEach(function(el) {
        if (el) el.style.transitionDuration = value + "ms";
    });
}
function $122ea7d6880b82fb$var$setVisibilityState(els, state) {
    els.forEach(function(el) {
        if (el) el.setAttribute('data-state', state);
    });
}
function $122ea7d6880b82fb$var$getOwnerDocument(elementOrElements) {
    var _element$ownerDocumen;
    var _normalizeToArray = $122ea7d6880b82fb$var$normalizeToArray(elementOrElements), element = _normalizeToArray[0]; // Elements created via a <template> have an ownerDocument with no reference to the body
    return element != null && (_element$ownerDocumen = element.ownerDocument) != null && _element$ownerDocumen.body ? element.ownerDocument : document;
}
function $122ea7d6880b82fb$var$isCursorOutsideInteractiveBorder(popperTreeData, event) {
    var clientX = event.clientX, clientY = event.clientY;
    return popperTreeData.every(function(_ref) {
        var popperRect = _ref.popperRect, popperState = _ref.popperState, props = _ref.props;
        var interactiveBorder = props.interactiveBorder;
        var basePlacement = $122ea7d6880b82fb$var$getBasePlacement(popperState.placement);
        var offsetData = popperState.modifiersData.offset;
        if (!offsetData) return true;
        var topDistance = basePlacement === 'bottom' ? offsetData.top.y : 0;
        var bottomDistance = basePlacement === 'top' ? offsetData.bottom.y : 0;
        var leftDistance = basePlacement === 'right' ? offsetData.left.x : 0;
        var rightDistance = basePlacement === 'left' ? offsetData.right.x : 0;
        var exceedsTop = popperRect.top - clientY + topDistance > interactiveBorder;
        var exceedsBottom = clientY - popperRect.bottom - bottomDistance > interactiveBorder;
        var exceedsLeft = popperRect.left - clientX + leftDistance > interactiveBorder;
        var exceedsRight = clientX - popperRect.right - rightDistance > interactiveBorder;
        return exceedsTop || exceedsBottom || exceedsLeft || exceedsRight;
    });
}
function $122ea7d6880b82fb$var$updateTransitionEndListener(box, action, listener) {
    var method = action + "EventListener"; // some browsers apparently support `transition` (unprefixed) but only fire
    // `webkitTransitionEnd`...
    [
        'transitionend',
        'webkitTransitionEnd'
    ].forEach(function(event) {
        box[method](event, listener);
    });
}
/**
 * Compared to xxx.contains, this function works for dom structures with shadow
 * dom
 */ function $122ea7d6880b82fb$var$actualContains(parent, child) {
    var target = child;
    while(target){
        var _target$getRootNode;
        if (parent.contains(target)) return true;
        target = target.getRootNode == null ? void 0 : (_target$getRootNode = target.getRootNode()) == null ? void 0 : _target$getRootNode.host;
    }
    return false;
}
var $122ea7d6880b82fb$var$currentInput = {
    isTouch: false
};
var $122ea7d6880b82fb$var$lastMouseMoveTime = 0;
/**
 * When a `touchstart` event is fired, it's assumed the user is using touch
 * input. We'll bind a `mousemove` event listener to listen for mouse input in
 * the future. This way, the `isTouch` property is fully dynamic and will handle
 * hybrid devices that use a mix of touch + mouse input.
 */ function $122ea7d6880b82fb$var$onDocumentTouchStart() {
    if ($122ea7d6880b82fb$var$currentInput.isTouch) return;
    $122ea7d6880b82fb$var$currentInput.isTouch = true;
    if (window.performance) document.addEventListener('mousemove', $122ea7d6880b82fb$var$onDocumentMouseMove);
}
/**
 * When two `mousemove` event are fired consecutively within 20ms, it's assumed
 * the user is using mouse input again. `mousemove` can fire on touch devices as
 * well, but very rarely that quickly.
 */ function $122ea7d6880b82fb$var$onDocumentMouseMove() {
    var now = performance.now();
    if (now - $122ea7d6880b82fb$var$lastMouseMoveTime < 20) {
        $122ea7d6880b82fb$var$currentInput.isTouch = false;
        document.removeEventListener('mousemove', $122ea7d6880b82fb$var$onDocumentMouseMove);
    }
    $122ea7d6880b82fb$var$lastMouseMoveTime = now;
}
/**
 * When an element is in focus and has a tippy, leaving the tab/window and
 * returning causes it to show again. For mouse users this is unexpected, but
 * for keyboard use it makes sense.
 * TODO: find a better technique to solve this problem
 */ function $122ea7d6880b82fb$var$onWindowBlur() {
    var activeElement = document.activeElement;
    if ($122ea7d6880b82fb$var$isReferenceElement(activeElement)) {
        var instance = activeElement._tippy;
        if (activeElement.blur && !instance.state.isVisible) activeElement.blur();
    }
}
function $122ea7d6880b82fb$var$bindGlobalEventListeners() {
    document.addEventListener('touchstart', $122ea7d6880b82fb$var$onDocumentTouchStart, $122ea7d6880b82fb$var$TOUCH_OPTIONS);
    window.addEventListener('blur', $122ea7d6880b82fb$var$onWindowBlur);
}
var $122ea7d6880b82fb$var$isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
var $122ea7d6880b82fb$var$isIE11 = $122ea7d6880b82fb$var$isBrowser ? !!window.msCrypto : false;
function $122ea7d6880b82fb$var$createMemoryLeakWarning(method) {
    var txt = method === 'destroy' ? 'n already-' : ' ';
    return [
        method + "() was called on a" + txt + "destroyed instance. This is a no-op but",
        'indicates a potential memory leak.'
    ].join(' ');
}
function $122ea7d6880b82fb$var$clean(value) {
    var spacesAndTabs = /[ \t]{2,}/g;
    var lineStartWithSpaces = /^[ \t]*/gm;
    return value.replace(spacesAndTabs, ' ').replace(lineStartWithSpaces, '').trim();
}
function $122ea7d6880b82fb$var$getDevMessage(message) {
    return $122ea7d6880b82fb$var$clean("\n  %ctippy.js\n\n  %c" + $122ea7d6880b82fb$var$clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development-only message. It will be removed in production.\n  ");
}
function $122ea7d6880b82fb$var$getFormattedMessage(message) {
    return [
        $122ea7d6880b82fb$var$getDevMessage(message),
        'color: #00C584; font-size: 1.3em; font-weight: bold;',
        'line-height: 1.5',
        'color: #a6a095;'
    ];
} // Assume warnings and errors never have the same message
var $122ea7d6880b82fb$var$visitedMessages;
function $122ea7d6880b82fb$var$resetVisitedMessages() {
    $122ea7d6880b82fb$var$visitedMessages = new Set();
}
function $122ea7d6880b82fb$var$warnWhen(condition, message) {
    if (condition && !$122ea7d6880b82fb$var$visitedMessages.has(message)) {
        var _console;
        $122ea7d6880b82fb$var$visitedMessages.add(message);
        (_console = console).warn.apply(_console, $122ea7d6880b82fb$var$getFormattedMessage(message));
    }
}
function $122ea7d6880b82fb$var$errorWhen(condition, message) {
    if (condition && !$122ea7d6880b82fb$var$visitedMessages.has(message)) {
        var _console2;
        $122ea7d6880b82fb$var$visitedMessages.add(message);
        (_console2 = console).error.apply(_console2, $122ea7d6880b82fb$var$getFormattedMessage(message));
    }
}
function $122ea7d6880b82fb$var$validateTargets(targets) {
    var didPassFalsyValue = !targets;
    var didPassPlainObject = Object.prototype.toString.call(targets) === '[object Object]' && !targets.addEventListener;
    $122ea7d6880b82fb$var$errorWhen(didPassFalsyValue, [
        'tippy() was passed',
        '`' + String(targets) + '`',
        'as its targets (first) argument. Valid types are: String, Element,',
        'Element[], or NodeList.'
    ].join(' '));
    $122ea7d6880b82fb$var$errorWhen(didPassPlainObject, [
        'tippy() was passed a plain object which is not supported as an argument',
        'for virtual positioning. Use props.getReferenceClientRect instead.'
    ].join(' '));
}
var $122ea7d6880b82fb$var$pluginProps = {
    animateFill: false,
    followCursor: false,
    inlinePositioning: false,
    sticky: false
};
var $122ea7d6880b82fb$var$renderProps = {
    allowHTML: false,
    animation: 'fade',
    arrow: true,
    content: '',
    inertia: false,
    maxWidth: 350,
    role: 'tooltip',
    theme: '',
    zIndex: 9999
};
var $122ea7d6880b82fb$var$defaultProps = Object.assign({
    appendTo: $122ea7d6880b82fb$var$TIPPY_DEFAULT_APPEND_TO,
    aria: {
        content: 'auto',
        expanded: 'auto'
    },
    delay: 0,
    duration: [
        300,
        250
    ],
    getReferenceClientRect: null,
    hideOnClick: true,
    ignoreAttributes: false,
    interactive: false,
    interactiveBorder: 2,
    interactiveDebounce: 0,
    moveTransition: '',
    offset: [
        0,
        10
    ],
    onAfterUpdate: function onAfterUpdate() {},
    onBeforeUpdate: function onBeforeUpdate() {},
    onCreate: function onCreate() {},
    onDestroy: function onDestroy() {},
    onHidden: function onHidden() {},
    onHide: function onHide() {},
    onMount: function onMount() {},
    onShow: function onShow() {},
    onShown: function onShown() {},
    onTrigger: function onTrigger() {},
    onUntrigger: function onUntrigger() {},
    onClickOutside: function onClickOutside() {},
    placement: 'top',
    plugins: [],
    popperOptions: {},
    render: null,
    showOnCreate: false,
    touch: true,
    trigger: 'mouseenter focus',
    triggerTarget: null
}, $122ea7d6880b82fb$var$pluginProps, $122ea7d6880b82fb$var$renderProps);
var $122ea7d6880b82fb$var$defaultKeys = Object.keys($122ea7d6880b82fb$var$defaultProps);
var $122ea7d6880b82fb$var$setDefaultProps = function setDefaultProps(partialProps) {
    var keys = Object.keys(partialProps);
    keys.forEach(function(key) {
        $122ea7d6880b82fb$var$defaultProps[key] = partialProps[key];
    });
};
function $122ea7d6880b82fb$var$getExtendedPassedProps(passedProps) {
    var plugins = passedProps.plugins || [];
    var pluginProps = plugins.reduce(function(acc, plugin) {
        var name = plugin.name, defaultValue = plugin.defaultValue;
        if (name) {
            var _name;
            acc[name] = passedProps[name] !== undefined ? passedProps[name] : (_name = $122ea7d6880b82fb$var$defaultProps[name]) != null ? _name : defaultValue;
        }
        return acc;
    }, {});
    return Object.assign({}, passedProps, pluginProps);
}
function $122ea7d6880b82fb$var$getDataAttributeProps(reference, plugins) {
    var propKeys = plugins ? Object.keys($122ea7d6880b82fb$var$getExtendedPassedProps(Object.assign({}, $122ea7d6880b82fb$var$defaultProps, {
        plugins: plugins
    }))) : $122ea7d6880b82fb$var$defaultKeys;
    var props = propKeys.reduce(function(acc, key) {
        var valueAsString = (reference.getAttribute("data-tippy-" + key) || '').trim();
        if (!valueAsString) return acc;
        if (key === 'content') acc[key] = valueAsString;
        else try {
            acc[key] = JSON.parse(valueAsString);
        } catch (e) {
            acc[key] = valueAsString;
        }
        return acc;
    }, {});
    return props;
}
function $122ea7d6880b82fb$var$evaluateProps(reference, props) {
    var out = Object.assign({}, props, {
        content: $122ea7d6880b82fb$var$invokeWithArgsOrReturn(props.content, [
            reference
        ])
    }, props.ignoreAttributes ? {} : $122ea7d6880b82fb$var$getDataAttributeProps(reference, props.plugins));
    out.aria = Object.assign({}, $122ea7d6880b82fb$var$defaultProps.aria, out.aria);
    out.aria = {
        expanded: out.aria.expanded === 'auto' ? props.interactive : out.aria.expanded,
        content: out.aria.content === 'auto' ? props.interactive ? null : 'describedby' : out.aria.content
    };
    return out;
}
function $122ea7d6880b82fb$var$validateProps(partialProps, plugins) {
    if (partialProps === void 0) partialProps = {};
    if (plugins === void 0) plugins = [];
    var keys = Object.keys(partialProps);
    keys.forEach(function(prop) {
        var nonPluginProps = $122ea7d6880b82fb$var$removeProperties($122ea7d6880b82fb$var$defaultProps, Object.keys($122ea7d6880b82fb$var$pluginProps));
        var didPassUnknownProp = !$122ea7d6880b82fb$var$hasOwnProperty(nonPluginProps, prop); // Check if the prop exists in `plugins`
        if (didPassUnknownProp) didPassUnknownProp = plugins.filter(function(plugin) {
            return plugin.name === prop;
        }).length === 0;
        $122ea7d6880b82fb$var$warnWhen(didPassUnknownProp, [
            "`" + prop + "`",
            "is not a valid prop. You may have spelled it incorrectly, or if it's",
            'a plugin, forgot to pass it in an array as props.plugins.',
            '\n\n',
            'All props: https://atomiks.github.io/tippyjs/v6/all-props/\n',
            'Plugins: https://atomiks.github.io/tippyjs/v6/plugins/'
        ].join(' '));
    });
}
var $122ea7d6880b82fb$var$innerHTML = function innerHTML() {
    return 'innerHTML';
};
function $122ea7d6880b82fb$var$dangerouslySetInnerHTML(element, html) {
    element[$122ea7d6880b82fb$var$innerHTML()] = html;
}
function $122ea7d6880b82fb$var$createArrowElement(value) {
    var arrow = $122ea7d6880b82fb$var$div();
    if (value === true) arrow.className = $122ea7d6880b82fb$var$ARROW_CLASS;
    else {
        arrow.className = $122ea7d6880b82fb$var$SVG_ARROW_CLASS;
        if ($122ea7d6880b82fb$var$isElement(value)) arrow.appendChild(value);
        else $122ea7d6880b82fb$var$dangerouslySetInnerHTML(arrow, value);
    }
    return arrow;
}
function $122ea7d6880b82fb$var$setContent(content, props) {
    if ($122ea7d6880b82fb$var$isElement(props.content)) {
        $122ea7d6880b82fb$var$dangerouslySetInnerHTML(content, '');
        content.appendChild(props.content);
    } else if (typeof props.content !== 'function') {
        if (props.allowHTML) $122ea7d6880b82fb$var$dangerouslySetInnerHTML(content, props.content);
        else content.textContent = props.content;
    }
}
function $122ea7d6880b82fb$var$getChildren(popper) {
    var box = popper.firstElementChild;
    var boxChildren = $122ea7d6880b82fb$var$arrayFrom(box.children);
    return {
        box: box,
        content: boxChildren.find(function(node) {
            return node.classList.contains($122ea7d6880b82fb$var$CONTENT_CLASS);
        }),
        arrow: boxChildren.find(function(node) {
            return node.classList.contains($122ea7d6880b82fb$var$ARROW_CLASS) || node.classList.contains($122ea7d6880b82fb$var$SVG_ARROW_CLASS);
        }),
        backdrop: boxChildren.find(function(node) {
            return node.classList.contains($122ea7d6880b82fb$var$BACKDROP_CLASS);
        })
    };
}
function $122ea7d6880b82fb$var$render(instance) {
    var popper = $122ea7d6880b82fb$var$div();
    var box = $122ea7d6880b82fb$var$div();
    box.className = $122ea7d6880b82fb$var$BOX_CLASS;
    box.setAttribute('data-state', 'hidden');
    box.setAttribute('tabindex', '-1');
    var content = $122ea7d6880b82fb$var$div();
    content.className = $122ea7d6880b82fb$var$CONTENT_CLASS;
    content.setAttribute('data-state', 'hidden');
    $122ea7d6880b82fb$var$setContent(content, instance.props);
    popper.appendChild(box);
    box.appendChild(content);
    onUpdate(instance.props, instance.props);
    function onUpdate(prevProps, nextProps) {
        var _getChildren = $122ea7d6880b82fb$var$getChildren(popper), box = _getChildren.box, content = _getChildren.content, arrow = _getChildren.arrow;
        if (nextProps.theme) box.setAttribute('data-theme', nextProps.theme);
        else box.removeAttribute('data-theme');
        if (typeof nextProps.animation === 'string') box.setAttribute('data-animation', nextProps.animation);
        else box.removeAttribute('data-animation');
        if (nextProps.inertia) box.setAttribute('data-inertia', '');
        else box.removeAttribute('data-inertia');
        box.style.maxWidth = typeof nextProps.maxWidth === 'number' ? nextProps.maxWidth + "px" : nextProps.maxWidth;
        if (nextProps.role) box.setAttribute('role', nextProps.role);
        else box.removeAttribute('role');
        if (prevProps.content !== nextProps.content || prevProps.allowHTML !== nextProps.allowHTML) $122ea7d6880b82fb$var$setContent(content, instance.props);
        if (nextProps.arrow) {
            if (!arrow) box.appendChild($122ea7d6880b82fb$var$createArrowElement(nextProps.arrow));
            else if (prevProps.arrow !== nextProps.arrow) {
                box.removeChild(arrow);
                box.appendChild($122ea7d6880b82fb$var$createArrowElement(nextProps.arrow));
            }
        } else if (arrow) box.removeChild(arrow);
    }
    return {
        popper: popper,
        onUpdate: onUpdate
    };
} // Runtime check to identify if the render function is the default one; this
// way we can apply default CSS transitions logic and it can be tree-shaken away
$122ea7d6880b82fb$var$render.$$tippy = true;
var $122ea7d6880b82fb$var$idCounter = 1;
var $122ea7d6880b82fb$var$mouseMoveListeners = []; // Used by `hideAll()`
var $122ea7d6880b82fb$var$mountedInstances = [];
function $122ea7d6880b82fb$var$createTippy(reference, passedProps) {
    var props = $122ea7d6880b82fb$var$evaluateProps(reference, Object.assign({}, $122ea7d6880b82fb$var$defaultProps, $122ea7d6880b82fb$var$getExtendedPassedProps($122ea7d6880b82fb$var$removeUndefinedProps(passedProps)))); // ===========================================================================
    // 🔒 Private members
    // ===========================================================================
    var showTimeout;
    var hideTimeout;
    var scheduleHideAnimationFrame;
    var isVisibleFromClick = false;
    var didHideDueToDocumentMouseDown = false;
    var didTouchMove = false;
    var ignoreOnFirstUpdate = false;
    var lastTriggerEvent;
    var currentTransitionEndListener;
    var onFirstUpdate;
    var listeners = [];
    var debouncedOnMouseMove = $122ea7d6880b82fb$var$debounce(onMouseMove, props.interactiveDebounce);
    var currentTarget; // ===========================================================================
    // 🔑 Public members
    // ===========================================================================
    var id = $122ea7d6880b82fb$var$idCounter++;
    var popperInstance = null;
    var plugins = $122ea7d6880b82fb$var$unique(props.plugins);
    var state = {
        // Is the instance currently enabled?
        isEnabled: true,
        // Is the tippy currently showing and not transitioning out?
        isVisible: false,
        // Has the instance been destroyed?
        isDestroyed: false,
        // Is the tippy currently mounted to the DOM?
        isMounted: false,
        // Has the tippy finished transitioning in?
        isShown: false
    };
    var instance = {
        // properties
        id: id,
        reference: reference,
        popper: $122ea7d6880b82fb$var$div(),
        popperInstance: popperInstance,
        props: props,
        state: state,
        plugins: plugins,
        // methods
        clearDelayTimeouts: clearDelayTimeouts,
        setProps: setProps,
        setContent: setContent,
        show: show,
        hide: hide,
        hideWithInteractivity: hideWithInteractivity,
        enable: enable,
        disable: disable,
        unmount: unmount,
        destroy: destroy
    }; // TODO: Investigate why this early return causes a TDZ error in the tests —
    // it doesn't seem to happen in the browser
    /* istanbul ignore if */ if (!props.render) return instance;
     // ===========================================================================
    // Initial mutations
    // ===========================================================================
    var _props$render = props.render(instance), popper = _props$render.popper, onUpdate = _props$render.onUpdate;
    popper.setAttribute('data-tippy-root', '');
    popper.id = "tippy-" + instance.id;
    instance.popper = popper;
    reference._tippy = instance;
    popper._tippy = instance;
    var pluginsHooks = plugins.map(function(plugin) {
        return plugin.fn(instance);
    });
    var hasAriaExpanded = reference.hasAttribute('aria-expanded');
    addListeners();
    handleAriaExpandedAttribute();
    handleStyles();
    invokeHook('onCreate', [
        instance
    ]);
    if (props.showOnCreate) scheduleShow();
     // Prevent a tippy with a delay from hiding if the cursor left then returned
    // before it started hiding
    popper.addEventListener('mouseenter', function() {
        if (instance.props.interactive && instance.state.isVisible) instance.clearDelayTimeouts();
    });
    popper.addEventListener('mouseleave', function() {
        if (instance.props.interactive && instance.props.trigger.indexOf('mouseenter') >= 0) getDocument().addEventListener('mousemove', debouncedOnMouseMove);
    });
    return instance; // ===========================================================================
    // 🔒 Private methods
    // ===========================================================================
    function getNormalizedTouchSettings() {
        var touch = instance.props.touch;
        return Array.isArray(touch) ? touch : [
            touch,
            0
        ];
    }
    function getIsCustomTouchBehavior() {
        return getNormalizedTouchSettings()[0] === 'hold';
    }
    function getIsDefaultRenderFn() {
        var _instance$props$rende;
        // @ts-ignore
        return !!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy);
    }
    function getCurrentTarget() {
        return currentTarget || reference;
    }
    function getDocument() {
        var parent = getCurrentTarget().parentNode;
        return parent ? $122ea7d6880b82fb$var$getOwnerDocument(parent) : document;
    }
    function getDefaultTemplateChildren() {
        return $122ea7d6880b82fb$var$getChildren(popper);
    }
    function getDelay(isShow) {
        // For touch or keyboard input, force `0` delay for UX reasons
        // Also if the instance is mounted but not visible (transitioning out),
        // ignore delay
        if (instance.state.isMounted && !instance.state.isVisible || $122ea7d6880b82fb$var$currentInput.isTouch || lastTriggerEvent && lastTriggerEvent.type === 'focus') return 0;
        return $122ea7d6880b82fb$var$getValueAtIndexOrReturn(instance.props.delay, isShow ? 0 : 1, $122ea7d6880b82fb$var$defaultProps.delay);
    }
    function handleStyles(fromHide) {
        if (fromHide === void 0) fromHide = false;
        popper.style.pointerEvents = instance.props.interactive && !fromHide ? '' : 'none';
        popper.style.zIndex = "" + instance.props.zIndex;
    }
    function invokeHook(hook, args, shouldInvokePropsHook) {
        if (shouldInvokePropsHook === void 0) shouldInvokePropsHook = true;
        pluginsHooks.forEach(function(pluginHooks) {
            if (pluginHooks[hook]) pluginHooks[hook].apply(pluginHooks, args);
        });
        if (shouldInvokePropsHook) {
            var _instance$props;
            (_instance$props = instance.props)[hook].apply(_instance$props, args);
        }
    }
    function handleAriaContentAttribute() {
        var aria = instance.props.aria;
        if (!aria.content) return;
        var attr = "aria-" + aria.content;
        var id = popper.id;
        var nodes = $122ea7d6880b82fb$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            var currentValue = node.getAttribute(attr);
            if (instance.state.isVisible) node.setAttribute(attr, currentValue ? currentValue + " " + id : id);
            else {
                var nextValue = currentValue && currentValue.replace(id, '').trim();
                if (nextValue) node.setAttribute(attr, nextValue);
                else node.removeAttribute(attr);
            }
        });
    }
    function handleAriaExpandedAttribute() {
        if (hasAriaExpanded || !instance.props.aria.expanded) return;
        var nodes = $122ea7d6880b82fb$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            if (instance.props.interactive) node.setAttribute('aria-expanded', instance.state.isVisible && node === getCurrentTarget() ? 'true' : 'false');
            else node.removeAttribute('aria-expanded');
        });
    }
    function cleanupInteractiveMouseListeners() {
        getDocument().removeEventListener('mousemove', debouncedOnMouseMove);
        $122ea7d6880b82fb$var$mouseMoveListeners = $122ea7d6880b82fb$var$mouseMoveListeners.filter(function(listener) {
            return listener !== debouncedOnMouseMove;
        });
    }
    function onDocumentPress(event) {
        // Moved finger to scroll instead of an intentional tap outside
        if ($122ea7d6880b82fb$var$currentInput.isTouch) {
            if (didTouchMove || event.type === 'mousedown') return;
        }
        var actualTarget = event.composedPath && event.composedPath()[0] || event.target; // Clicked on interactive popper
        if (instance.props.interactive && $122ea7d6880b82fb$var$actualContains(popper, actualTarget)) return;
         // Clicked on the event listeners target
        if ($122ea7d6880b82fb$var$normalizeToArray(instance.props.triggerTarget || reference).some(function(el) {
            return $122ea7d6880b82fb$var$actualContains(el, actualTarget);
        })) {
            if ($122ea7d6880b82fb$var$currentInput.isTouch) return;
            if (instance.state.isVisible && instance.props.trigger.indexOf('click') >= 0) return;
        } else invokeHook('onClickOutside', [
            instance,
            event
        ]);
        if (instance.props.hideOnClick === true) {
            instance.clearDelayTimeouts();
            instance.hide(); // `mousedown` event is fired right before `focus` if pressing the
            // currentTarget. This lets a tippy with `focus` trigger know that it
            // should not show
            didHideDueToDocumentMouseDown = true;
            setTimeout(function() {
                didHideDueToDocumentMouseDown = false;
            }); // The listener gets added in `scheduleShow()`, but this may be hiding it
            // before it shows, and hide()'s early bail-out behavior can prevent it
            // from being cleaned up
            if (!instance.state.isMounted) removeDocumentPress();
        }
    }
    function onTouchMove() {
        didTouchMove = true;
    }
    function onTouchStart() {
        didTouchMove = false;
    }
    function addDocumentPress() {
        var doc = getDocument();
        doc.addEventListener('mousedown', onDocumentPress, true);
        doc.addEventListener('touchend', onDocumentPress, $122ea7d6880b82fb$var$TOUCH_OPTIONS);
        doc.addEventListener('touchstart', onTouchStart, $122ea7d6880b82fb$var$TOUCH_OPTIONS);
        doc.addEventListener('touchmove', onTouchMove, $122ea7d6880b82fb$var$TOUCH_OPTIONS);
    }
    function removeDocumentPress() {
        var doc = getDocument();
        doc.removeEventListener('mousedown', onDocumentPress, true);
        doc.removeEventListener('touchend', onDocumentPress, $122ea7d6880b82fb$var$TOUCH_OPTIONS);
        doc.removeEventListener('touchstart', onTouchStart, $122ea7d6880b82fb$var$TOUCH_OPTIONS);
        doc.removeEventListener('touchmove', onTouchMove, $122ea7d6880b82fb$var$TOUCH_OPTIONS);
    }
    function onTransitionedOut(duration, callback) {
        onTransitionEnd(duration, function() {
            if (!instance.state.isVisible && popper.parentNode && popper.parentNode.contains(popper)) callback();
        });
    }
    function onTransitionedIn(duration, callback) {
        onTransitionEnd(duration, callback);
    }
    function onTransitionEnd(duration, callback) {
        var box = getDefaultTemplateChildren().box;
        function listener(event) {
            if (event.target === box) {
                $122ea7d6880b82fb$var$updateTransitionEndListener(box, 'remove', listener);
                callback();
            }
        } // Make callback synchronous if duration is 0
        // `transitionend` won't fire otherwise
        if (duration === 0) return callback();
        $122ea7d6880b82fb$var$updateTransitionEndListener(box, 'remove', currentTransitionEndListener);
        $122ea7d6880b82fb$var$updateTransitionEndListener(box, 'add', listener);
        currentTransitionEndListener = listener;
    }
    function on(eventType, handler, options) {
        if (options === void 0) options = false;
        var nodes = $122ea7d6880b82fb$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            node.addEventListener(eventType, handler, options);
            listeners.push({
                node: node,
                eventType: eventType,
                handler: handler,
                options: options
            });
        });
    }
    function addListeners() {
        if (getIsCustomTouchBehavior()) {
            on('touchstart', onTrigger, {
                passive: true
            });
            on('touchend', onMouseLeave, {
                passive: true
            });
        }
        $122ea7d6880b82fb$var$splitBySpaces(instance.props.trigger).forEach(function(eventType) {
            if (eventType === 'manual') return;
            on(eventType, onTrigger);
            switch(eventType){
                case 'mouseenter':
                    on('mouseleave', onMouseLeave);
                    break;
                case 'focus':
                    on($122ea7d6880b82fb$var$isIE11 ? 'focusout' : 'blur', onBlurOrFocusOut);
                    break;
                case 'focusin':
                    on('focusout', onBlurOrFocusOut);
                    break;
            }
        });
    }
    function removeListeners() {
        listeners.forEach(function(_ref) {
            var node = _ref.node, eventType = _ref.eventType, handler = _ref.handler, options = _ref.options;
            node.removeEventListener(eventType, handler, options);
        });
        listeners = [];
    }
    function onTrigger(event) {
        var _lastTriggerEvent;
        var shouldScheduleClickHide = false;
        if (!instance.state.isEnabled || isEventListenerStopped(event) || didHideDueToDocumentMouseDown) return;
        var wasFocused = ((_lastTriggerEvent = lastTriggerEvent) == null ? void 0 : _lastTriggerEvent.type) === 'focus';
        lastTriggerEvent = event;
        currentTarget = event.currentTarget;
        handleAriaExpandedAttribute();
        if (!instance.state.isVisible && $122ea7d6880b82fb$var$isMouseEvent(event)) // If scrolling, `mouseenter` events can be fired if the cursor lands
        // over a new target, but `mousemove` events don't get fired. This
        // causes interactive tooltips to get stuck open until the cursor is
        // moved
        $122ea7d6880b82fb$var$mouseMoveListeners.forEach(function(listener) {
            return listener(event);
        });
         // Toggle show/hide when clicking click-triggered tooltips
        if (event.type === 'click' && (instance.props.trigger.indexOf('mouseenter') < 0 || isVisibleFromClick) && instance.props.hideOnClick !== false && instance.state.isVisible) shouldScheduleClickHide = true;
        else scheduleShow(event);
        if (event.type === 'click') isVisibleFromClick = !shouldScheduleClickHide;
        if (shouldScheduleClickHide && !wasFocused) scheduleHide(event);
    }
    function onMouseMove(event) {
        var target = event.target;
        var isCursorOverReferenceOrPopper = getCurrentTarget().contains(target) || popper.contains(target);
        if (event.type === 'mousemove' && isCursorOverReferenceOrPopper) return;
        var popperTreeData = getNestedPopperTree().concat(popper).map(function(popper) {
            var _instance$popperInsta;
            var instance = popper._tippy;
            var state = (_instance$popperInsta = instance.popperInstance) == null ? void 0 : _instance$popperInsta.state;
            if (state) return {
                popperRect: popper.getBoundingClientRect(),
                popperState: state,
                props: props
            };
            return null;
        }).filter(Boolean);
        if ($122ea7d6880b82fb$var$isCursorOutsideInteractiveBorder(popperTreeData, event)) {
            cleanupInteractiveMouseListeners();
            scheduleHide(event);
        }
    }
    function onMouseLeave(event) {
        var shouldBail = isEventListenerStopped(event) || instance.props.trigger.indexOf('click') >= 0 && isVisibleFromClick;
        if (shouldBail) return;
        if (instance.props.interactive) {
            instance.hideWithInteractivity(event);
            return;
        }
        scheduleHide(event);
    }
    function onBlurOrFocusOut(event) {
        if (instance.props.trigger.indexOf('focusin') < 0 && event.target !== getCurrentTarget()) return;
         // If focus was moved to within the popper
        if (instance.props.interactive && event.relatedTarget && popper.contains(event.relatedTarget)) return;
        scheduleHide(event);
    }
    function isEventListenerStopped(event) {
        return $122ea7d6880b82fb$var$currentInput.isTouch ? getIsCustomTouchBehavior() !== event.type.indexOf('touch') >= 0 : false;
    }
    function createPopperInstance() {
        destroyPopperInstance();
        var _instance$props2 = instance.props, popperOptions = _instance$props2.popperOptions, placement = _instance$props2.placement, offset = _instance$props2.offset, getReferenceClientRect = _instance$props2.getReferenceClientRect, moveTransition = _instance$props2.moveTransition;
        var arrow = getIsDefaultRenderFn() ? $122ea7d6880b82fb$var$getChildren(popper).arrow : null;
        var computedReference = getReferenceClientRect ? {
            getBoundingClientRect: getReferenceClientRect,
            contextElement: getReferenceClientRect.contextElement || getCurrentTarget()
        } : reference;
        var tippyModifier = {
            name: '$$tippy',
            enabled: true,
            phase: 'beforeWrite',
            requires: [
                'computeStyles'
            ],
            fn: function fn(_ref2) {
                var state = _ref2.state;
                if (getIsDefaultRenderFn()) {
                    var _getDefaultTemplateCh = getDefaultTemplateChildren(), box = _getDefaultTemplateCh.box;
                    [
                        'placement',
                        'reference-hidden',
                        'escaped'
                    ].forEach(function(attr) {
                        if (attr === 'placement') box.setAttribute('data-placement', state.placement);
                        else if (state.attributes.popper["data-popper-" + attr]) box.setAttribute("data-" + attr, '');
                        else box.removeAttribute("data-" + attr);
                    });
                    state.attributes.popper = {};
                }
            }
        };
        var modifiers = [
            {
                name: 'offset',
                options: {
                    offset: offset
                }
            },
            {
                name: 'preventOverflow',
                options: {
                    padding: {
                        top: 2,
                        bottom: 2,
                        left: 5,
                        right: 5
                    }
                }
            },
            {
                name: 'flip',
                options: {
                    padding: 5
                }
            },
            {
                name: 'computeStyles',
                options: {
                    adaptive: !moveTransition
                }
            },
            tippyModifier
        ];
        if (getIsDefaultRenderFn() && arrow) modifiers.push({
            name: 'arrow',
            options: {
                element: arrow,
                padding: 3
            }
        });
        modifiers.push.apply(modifiers, (popperOptions == null ? void 0 : popperOptions.modifiers) || []);
        instance.popperInstance = (0, $3dd3addecd072f67$export$8f7491d57c8f97a9)(computedReference, popper, Object.assign({}, popperOptions, {
            placement: placement,
            onFirstUpdate: onFirstUpdate,
            modifiers: modifiers
        }));
    }
    function destroyPopperInstance() {
        if (instance.popperInstance) {
            instance.popperInstance.destroy();
            instance.popperInstance = null;
        }
    }
    function mount() {
        var appendTo = instance.props.appendTo;
        var parentNode; // By default, we'll append the popper to the triggerTargets's parentNode so
        // it's directly after the reference element so the elements inside the
        // tippy can be tabbed to
        // If there are clipping issues, the user can specify a different appendTo
        // and ensure focus management is handled correctly manually
        var node = getCurrentTarget();
        if (instance.props.interactive && appendTo === $122ea7d6880b82fb$var$TIPPY_DEFAULT_APPEND_TO || appendTo === 'parent') parentNode = node.parentNode;
        else parentNode = $122ea7d6880b82fb$var$invokeWithArgsOrReturn(appendTo, [
            node
        ]);
         // The popper element needs to exist on the DOM before its position can be
        // updated as Popper needs to read its dimensions
        if (!parentNode.contains(popper)) parentNode.appendChild(popper);
        instance.state.isMounted = true;
        createPopperInstance();
    }
    function getNestedPopperTree() {
        return $122ea7d6880b82fb$var$arrayFrom(popper.querySelectorAll('[data-tippy-root]'));
    }
    function scheduleShow(event) {
        instance.clearDelayTimeouts();
        if (event) invokeHook('onTrigger', [
            instance,
            event
        ]);
        addDocumentPress();
        var delay = getDelay(true);
        var _getNormalizedTouchSe = getNormalizedTouchSettings(), touchValue = _getNormalizedTouchSe[0], touchDelay = _getNormalizedTouchSe[1];
        if ($122ea7d6880b82fb$var$currentInput.isTouch && touchValue === 'hold' && touchDelay) delay = touchDelay;
        if (delay) showTimeout = setTimeout(function() {
            instance.show();
        }, delay);
        else instance.show();
    }
    function scheduleHide(event) {
        instance.clearDelayTimeouts();
        invokeHook('onUntrigger', [
            instance,
            event
        ]);
        if (!instance.state.isVisible) {
            removeDocumentPress();
            return;
        } // For interactive tippies, scheduleHide is added to a document.body handler
        // from onMouseLeave so must intercept scheduled hides from mousemove/leave
        // events when trigger contains mouseenter and click, and the tip is
        // currently shown as a result of a click.
        if (instance.props.trigger.indexOf('mouseenter') >= 0 && instance.props.trigger.indexOf('click') >= 0 && [
            'mouseleave',
            'mousemove'
        ].indexOf(event.type) >= 0 && isVisibleFromClick) return;
        var delay = getDelay(false);
        if (delay) hideTimeout = setTimeout(function() {
            if (instance.state.isVisible) instance.hide();
        }, delay);
        else // Fixes a `transitionend` problem when it fires 1 frame too
        // late sometimes, we don't want hide() to be called.
        scheduleHideAnimationFrame = requestAnimationFrame(function() {
            instance.hide();
        });
    } // ===========================================================================
    // 🔑 Public methods
    // ===========================================================================
    function enable() {
        instance.state.isEnabled = true;
    }
    function disable() {
        // Disabling the instance should also hide it
        // https://github.com/atomiks/tippy.js-react/issues/106
        instance.hide();
        instance.state.isEnabled = false;
    }
    function clearDelayTimeouts() {
        clearTimeout(showTimeout);
        clearTimeout(hideTimeout);
        cancelAnimationFrame(scheduleHideAnimationFrame);
    }
    function setProps(partialProps) {
        if (instance.state.isDestroyed) return;
        invokeHook('onBeforeUpdate', [
            instance,
            partialProps
        ]);
        removeListeners();
        var prevProps = instance.props;
        var nextProps = $122ea7d6880b82fb$var$evaluateProps(reference, Object.assign({}, prevProps, $122ea7d6880b82fb$var$removeUndefinedProps(partialProps), {
            ignoreAttributes: true
        }));
        instance.props = nextProps;
        addListeners();
        if (prevProps.interactiveDebounce !== nextProps.interactiveDebounce) {
            cleanupInteractiveMouseListeners();
            debouncedOnMouseMove = $122ea7d6880b82fb$var$debounce(onMouseMove, nextProps.interactiveDebounce);
        } // Ensure stale aria-expanded attributes are removed
        if (prevProps.triggerTarget && !nextProps.triggerTarget) $122ea7d6880b82fb$var$normalizeToArray(prevProps.triggerTarget).forEach(function(node) {
            node.removeAttribute('aria-expanded');
        });
        else if (nextProps.triggerTarget) reference.removeAttribute('aria-expanded');
        handleAriaExpandedAttribute();
        handleStyles();
        if (onUpdate) onUpdate(prevProps, nextProps);
        if (instance.popperInstance) {
            createPopperInstance(); // Fixes an issue with nested tippies if they are all getting re-rendered,
            // and the nested ones get re-rendered first.
            // https://github.com/atomiks/tippyjs-react/issues/177
            // TODO: find a cleaner / more efficient solution(!)
            getNestedPopperTree().forEach(function(nestedPopper) {
                // React (and other UI libs likely) requires a rAF wrapper as it flushes
                // its work in one
                requestAnimationFrame(nestedPopper._tippy.popperInstance.forceUpdate);
            });
        }
        invokeHook('onAfterUpdate', [
            instance,
            partialProps
        ]);
    }
    function setContent(content) {
        instance.setProps({
            content: content
        });
    }
    function show() {
        var isAlreadyVisible = instance.state.isVisible;
        var isDestroyed = instance.state.isDestroyed;
        var isDisabled = !instance.state.isEnabled;
        var isTouchAndTouchDisabled = $122ea7d6880b82fb$var$currentInput.isTouch && !instance.props.touch;
        var duration = $122ea7d6880b82fb$var$getValueAtIndexOrReturn(instance.props.duration, 0, $122ea7d6880b82fb$var$defaultProps.duration);
        if (isAlreadyVisible || isDestroyed || isDisabled || isTouchAndTouchDisabled) return;
         // Normalize `disabled` behavior across browsers.
        // Firefox allows events on disabled elements, but Chrome doesn't.
        // Using a wrapper element (i.e. <span>) is recommended.
        if (getCurrentTarget().hasAttribute('disabled')) return;
        invokeHook('onShow', [
            instance
        ], false);
        if (instance.props.onShow(instance) === false) return;
        instance.state.isVisible = true;
        if (getIsDefaultRenderFn()) popper.style.visibility = 'visible';
        handleStyles();
        addDocumentPress();
        if (!instance.state.isMounted) popper.style.transition = 'none';
         // If flipping to the opposite side after hiding at least once, the
        // animation will use the wrong placement without resetting the duration
        if (getIsDefaultRenderFn()) {
            var _getDefaultTemplateCh2 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh2.box, content = _getDefaultTemplateCh2.content;
            $122ea7d6880b82fb$var$setTransitionDuration([
                box,
                content
            ], 0);
        }
        onFirstUpdate = function onFirstUpdate() {
            var _instance$popperInsta2;
            if (!instance.state.isVisible || ignoreOnFirstUpdate) return;
            ignoreOnFirstUpdate = true; // reflow
            popper.offsetHeight;
            popper.style.transition = instance.props.moveTransition;
            if (getIsDefaultRenderFn() && instance.props.animation) {
                var _getDefaultTemplateCh3 = getDefaultTemplateChildren(), _box = _getDefaultTemplateCh3.box, _content = _getDefaultTemplateCh3.content;
                $122ea7d6880b82fb$var$setTransitionDuration([
                    _box,
                    _content
                ], duration);
                $122ea7d6880b82fb$var$setVisibilityState([
                    _box,
                    _content
                ], 'visible');
            }
            handleAriaContentAttribute();
            handleAriaExpandedAttribute();
            $122ea7d6880b82fb$var$pushIfUnique($122ea7d6880b82fb$var$mountedInstances, instance); // certain modifiers (e.g. `maxSize`) require a second update after the
            // popper has been positioned for the first time
            (_instance$popperInsta2 = instance.popperInstance) == null || _instance$popperInsta2.forceUpdate();
            invokeHook('onMount', [
                instance
            ]);
            if (instance.props.animation && getIsDefaultRenderFn()) onTransitionedIn(duration, function() {
                instance.state.isShown = true;
                invokeHook('onShown', [
                    instance
                ]);
            });
        };
        mount();
    }
    function hide() {
        var isAlreadyHidden = !instance.state.isVisible;
        var isDestroyed = instance.state.isDestroyed;
        var isDisabled = !instance.state.isEnabled;
        var duration = $122ea7d6880b82fb$var$getValueAtIndexOrReturn(instance.props.duration, 1, $122ea7d6880b82fb$var$defaultProps.duration);
        if (isAlreadyHidden || isDestroyed || isDisabled) return;
        invokeHook('onHide', [
            instance
        ], false);
        if (instance.props.onHide(instance) === false) return;
        instance.state.isVisible = false;
        instance.state.isShown = false;
        ignoreOnFirstUpdate = false;
        isVisibleFromClick = false;
        if (getIsDefaultRenderFn()) popper.style.visibility = 'hidden';
        cleanupInteractiveMouseListeners();
        removeDocumentPress();
        handleStyles(true);
        if (getIsDefaultRenderFn()) {
            var _getDefaultTemplateCh4 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh4.box, content = _getDefaultTemplateCh4.content;
            if (instance.props.animation) {
                $122ea7d6880b82fb$var$setTransitionDuration([
                    box,
                    content
                ], duration);
                $122ea7d6880b82fb$var$setVisibilityState([
                    box,
                    content
                ], 'hidden');
            }
        }
        handleAriaContentAttribute();
        handleAriaExpandedAttribute();
        if (instance.props.animation) {
            if (getIsDefaultRenderFn()) onTransitionedOut(duration, instance.unmount);
        } else instance.unmount();
    }
    function hideWithInteractivity(event) {
        getDocument().addEventListener('mousemove', debouncedOnMouseMove);
        $122ea7d6880b82fb$var$pushIfUnique($122ea7d6880b82fb$var$mouseMoveListeners, debouncedOnMouseMove);
        debouncedOnMouseMove(event);
    }
    function unmount() {
        if (instance.state.isVisible) instance.hide();
        if (!instance.state.isMounted) return;
        destroyPopperInstance(); // If a popper is not interactive, it will be appended outside the popper
        // tree by default. This seems mainly for interactive tippies, but we should
        // find a workaround if possible
        getNestedPopperTree().forEach(function(nestedPopper) {
            nestedPopper._tippy.unmount();
        });
        if (popper.parentNode) popper.parentNode.removeChild(popper);
        $122ea7d6880b82fb$var$mountedInstances = $122ea7d6880b82fb$var$mountedInstances.filter(function(i) {
            return i !== instance;
        });
        instance.state.isMounted = false;
        invokeHook('onHidden', [
            instance
        ]);
    }
    function destroy() {
        if (instance.state.isDestroyed) return;
        instance.clearDelayTimeouts();
        instance.unmount();
        removeListeners();
        delete reference._tippy;
        instance.state.isDestroyed = true;
        invokeHook('onDestroy', [
            instance
        ]);
    }
}
function $122ea7d6880b82fb$var$tippy(targets, optionalProps) {
    if (optionalProps === void 0) optionalProps = {};
    var plugins = $122ea7d6880b82fb$var$defaultProps.plugins.concat(optionalProps.plugins || []);
    $122ea7d6880b82fb$var$bindGlobalEventListeners();
    var passedProps = Object.assign({}, optionalProps, {
        plugins: plugins
    });
    var elements = $122ea7d6880b82fb$var$getArrayOfElements(targets);
    var isSingleContentElement, isMoreThanOneReferenceElement;
    var instances = elements.reduce(function(acc, reference) {
        var instance = reference && $122ea7d6880b82fb$var$createTippy(reference, passedProps);
        if (instance) acc.push(instance);
        return acc;
    }, []);
    return $122ea7d6880b82fb$var$isElement(targets) ? instances[0] : instances;
}
$122ea7d6880b82fb$var$tippy.defaultProps = $122ea7d6880b82fb$var$defaultProps;
$122ea7d6880b82fb$var$tippy.setDefaultProps = $122ea7d6880b82fb$var$setDefaultProps;
$122ea7d6880b82fb$var$tippy.currentInput = $122ea7d6880b82fb$var$currentInput;
var $122ea7d6880b82fb$export$a9608aab345f7e75 = function hideAll(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, excludedReferenceOrInstance = _ref.exclude, duration = _ref.duration;
    $122ea7d6880b82fb$var$mountedInstances.forEach(function(instance) {
        var isExcluded = false;
        if (excludedReferenceOrInstance) isExcluded = $122ea7d6880b82fb$var$isReferenceElement(excludedReferenceOrInstance) ? instance.reference === excludedReferenceOrInstance : instance.popper === excludedReferenceOrInstance.popper;
        if (!isExcluded) {
            var originalDuration = instance.props.duration;
            instance.setProps({
                duration: duration
            });
            instance.hide();
            if (!instance.state.isDestroyed) instance.setProps({
                duration: originalDuration
            });
        }
    });
};
// every time the popper is destroyed (i.e. a new target), removing the styles
// and causing transitions to break for singletons when the console is open, but
// most notably for non-transform styles being used, `gpuAcceleration: false`.
var $122ea7d6880b82fb$var$applyStylesModifier = Object.assign({}, (0, $256e1e3d16d72587$export$2e2bcd8739ae039), {
    effect: function effect(_ref) {
        var state = _ref.state;
        var initialStyles = {
            popper: {
                position: state.options.strategy,
                left: '0',
                top: '0',
                margin: '0'
            },
            arrow: {
                position: 'absolute'
            },
            reference: {}
        };
        Object.assign(state.elements.popper.style, initialStyles.popper);
        state.styles = initialStyles;
        if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
         // intentionally return no cleanup function
    // return () => { ... }
    }
});
var $122ea7d6880b82fb$export$374c483667c1ea9b = function createSingleton(tippyInstances, optionalProps) {
    var _optionalProps$popper;
    if (optionalProps === void 0) optionalProps = {};
    var individualInstances = tippyInstances;
    var references = [];
    var triggerTargets = [];
    var currentTarget;
    var overrides = optionalProps.overrides;
    var interceptSetPropsCleanups = [];
    var shownOnCreate = false;
    function setTriggerTargets() {
        triggerTargets = individualInstances.map(function(instance) {
            return $122ea7d6880b82fb$var$normalizeToArray(instance.props.triggerTarget || instance.reference);
        }).reduce(function(acc, item) {
            return acc.concat(item);
        }, []);
    }
    function setReferences() {
        references = individualInstances.map(function(instance) {
            return instance.reference;
        });
    }
    function enableInstances(isEnabled) {
        individualInstances.forEach(function(instance) {
            if (isEnabled) instance.enable();
            else instance.disable();
        });
    }
    function interceptSetProps(singleton) {
        return individualInstances.map(function(instance) {
            var originalSetProps = instance.setProps;
            instance.setProps = function(props) {
                originalSetProps(props);
                if (instance.reference === currentTarget) singleton.setProps(props);
            };
            return function() {
                instance.setProps = originalSetProps;
            };
        });
    } // have to pass singleton, as it maybe undefined on first call
    function prepareInstance(singleton, target) {
        var index = triggerTargets.indexOf(target); // bail-out
        if (target === currentTarget) return;
        currentTarget = target;
        var overrideProps = (overrides || []).concat('content').reduce(function(acc, prop) {
            acc[prop] = individualInstances[index].props[prop];
            return acc;
        }, {});
        singleton.setProps(Object.assign({}, overrideProps, {
            getReferenceClientRect: typeof overrideProps.getReferenceClientRect === 'function' ? overrideProps.getReferenceClientRect : function() {
                var _references$index;
                return (_references$index = references[index]) == null ? void 0 : _references$index.getBoundingClientRect();
            }
        }));
    }
    enableInstances(false);
    setReferences();
    setTriggerTargets();
    var plugin = {
        fn: function fn() {
            return {
                onDestroy: function onDestroy() {
                    enableInstances(true);
                },
                onHidden: function onHidden() {
                    currentTarget = null;
                },
                onClickOutside: function onClickOutside(instance) {
                    if (instance.props.showOnCreate && !shownOnCreate) {
                        shownOnCreate = true;
                        currentTarget = null;
                    }
                },
                onShow: function onShow(instance) {
                    if (instance.props.showOnCreate && !shownOnCreate) {
                        shownOnCreate = true;
                        prepareInstance(instance, references[0]);
                    }
                },
                onTrigger: function onTrigger(instance, event) {
                    prepareInstance(instance, event.currentTarget);
                }
            };
        }
    };
    var singleton = $122ea7d6880b82fb$var$tippy($122ea7d6880b82fb$var$div(), Object.assign({}, $122ea7d6880b82fb$var$removeProperties(optionalProps, [
        'overrides'
    ]), {
        plugins: [
            plugin
        ].concat(optionalProps.plugins || []),
        triggerTarget: triggerTargets,
        popperOptions: Object.assign({}, optionalProps.popperOptions, {
            modifiers: [].concat(((_optionalProps$popper = optionalProps.popperOptions) == null ? void 0 : _optionalProps$popper.modifiers) || [], [
                $122ea7d6880b82fb$var$applyStylesModifier
            ])
        })
    }));
    var originalShow = singleton.show;
    singleton.show = function(target) {
        originalShow(); // first time, showOnCreate or programmatic call with no params
        // default to showing first instance
        if (!currentTarget && target == null) return prepareInstance(singleton, references[0]);
         // triggered from event (do nothing as prepareInstance already called by onTrigger)
        // programmatic call with no params when already visible (do nothing again)
        if (currentTarget && target == null) return;
         // target is index of instance
        if (typeof target === 'number') return references[target] && prepareInstance(singleton, references[target]);
         // target is a child tippy instance
        if (individualInstances.indexOf(target) >= 0) {
            var ref = target.reference;
            return prepareInstance(singleton, ref);
        } // target is a ReferenceElement
        if (references.indexOf(target) >= 0) return prepareInstance(singleton, target);
    };
    singleton.showNext = function() {
        var first = references[0];
        if (!currentTarget) return singleton.show(0);
        var index = references.indexOf(currentTarget);
        singleton.show(references[index + 1] || first);
    };
    singleton.showPrevious = function() {
        var last = references[references.length - 1];
        if (!currentTarget) return singleton.show(last);
        var index = references.indexOf(currentTarget);
        var target = references[index - 1] || last;
        singleton.show(target);
    };
    var originalSetProps = singleton.setProps;
    singleton.setProps = function(props) {
        overrides = props.overrides || overrides;
        originalSetProps(props);
    };
    singleton.setInstances = function(nextInstances) {
        enableInstances(true);
        interceptSetPropsCleanups.forEach(function(fn) {
            return fn();
        });
        individualInstances = nextInstances;
        enableInstances(false);
        setReferences();
        setTriggerTargets();
        interceptSetPropsCleanups = interceptSetProps(singleton);
        singleton.setProps({
            triggerTarget: triggerTargets
        });
    };
    interceptSetPropsCleanups = interceptSetProps(singleton);
    return singleton;
};
var $122ea7d6880b82fb$var$BUBBLING_EVENTS_MAP = {
    mouseover: 'mouseenter',
    focusin: 'focus',
    click: 'click'
};
/**
 * Creates a delegate instance that controls the creation of tippy instances
 * for child elements (`target` CSS selector).
 */ function $122ea7d6880b82fb$export$10b1921597150314(targets, props) {
    var listeners = [];
    var childTippyInstances = [];
    var disabled = false;
    var target = props.target;
    var nativeProps = $122ea7d6880b82fb$var$removeProperties(props, [
        'target'
    ]);
    var parentProps = Object.assign({}, nativeProps, {
        trigger: 'manual',
        touch: false
    });
    var childProps = Object.assign({
        touch: $122ea7d6880b82fb$var$defaultProps.touch
    }, nativeProps, {
        showOnCreate: true
    });
    var returnValue = $122ea7d6880b82fb$var$tippy(targets, parentProps);
    var normalizedReturnValue = $122ea7d6880b82fb$var$normalizeToArray(returnValue);
    function onTrigger(event) {
        if (!event.target || disabled) return;
        var targetNode = event.target.closest(target);
        if (!targetNode) return;
         // Get relevant trigger with fallbacks:
        // 1. Check `data-tippy-trigger` attribute on target node
        // 2. Fallback to `trigger` passed to `delegate()`
        // 3. Fallback to `defaultProps.trigger`
        var trigger = targetNode.getAttribute('data-tippy-trigger') || props.trigger || $122ea7d6880b82fb$var$defaultProps.trigger; // @ts-ignore
        if (targetNode._tippy) return;
        if (event.type === 'touchstart' && typeof childProps.touch === 'boolean') return;
        if (event.type !== 'touchstart' && trigger.indexOf($122ea7d6880b82fb$var$BUBBLING_EVENTS_MAP[event.type]) < 0) return;
        var instance = $122ea7d6880b82fb$var$tippy(targetNode, childProps);
        if (instance) childTippyInstances = childTippyInstances.concat(instance);
    }
    function on(node, eventType, handler, options) {
        if (options === void 0) options = false;
        node.addEventListener(eventType, handler, options);
        listeners.push({
            node: node,
            eventType: eventType,
            handler: handler,
            options: options
        });
    }
    function addEventListeners(instance) {
        var reference = instance.reference;
        on(reference, 'touchstart', onTrigger, $122ea7d6880b82fb$var$TOUCH_OPTIONS);
        on(reference, 'mouseover', onTrigger);
        on(reference, 'focusin', onTrigger);
        on(reference, 'click', onTrigger);
    }
    function removeEventListeners() {
        listeners.forEach(function(_ref) {
            var node = _ref.node, eventType = _ref.eventType, handler = _ref.handler, options = _ref.options;
            node.removeEventListener(eventType, handler, options);
        });
        listeners = [];
    }
    function applyMutations(instance) {
        var originalDestroy = instance.destroy;
        var originalEnable = instance.enable;
        var originalDisable = instance.disable;
        instance.destroy = function(shouldDestroyChildInstances) {
            if (shouldDestroyChildInstances === void 0) shouldDestroyChildInstances = true;
            if (shouldDestroyChildInstances) childTippyInstances.forEach(function(instance) {
                instance.destroy();
            });
            childTippyInstances = [];
            removeEventListeners();
            originalDestroy();
        };
        instance.enable = function() {
            originalEnable();
            childTippyInstances.forEach(function(instance) {
                return instance.enable();
            });
            disabled = false;
        };
        instance.disable = function() {
            originalDisable();
            childTippyInstances.forEach(function(instance) {
                return instance.disable();
            });
            disabled = true;
        };
        addEventListeners(instance);
    }
    normalizedReturnValue.forEach(applyMutations);
    return returnValue;
}
var $122ea7d6880b82fb$export$dd8ded329c01db79 = {
    name: 'animateFill',
    defaultValue: false,
    fn: function fn(instance) {
        var _instance$props$rende;
        // @ts-ignore
        if (!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy)) return {};
        var _getChildren = $122ea7d6880b82fb$var$getChildren(instance.popper), box = _getChildren.box, content = _getChildren.content;
        var backdrop = instance.props.animateFill ? $122ea7d6880b82fb$var$createBackdropElement() : null;
        return {
            onCreate: function onCreate() {
                if (backdrop) {
                    box.insertBefore(backdrop, box.firstElementChild);
                    box.setAttribute('data-animatefill', '');
                    box.style.overflow = 'hidden';
                    instance.setProps({
                        arrow: false,
                        animation: 'shift-away'
                    });
                }
            },
            onMount: function onMount() {
                if (backdrop) {
                    var transitionDuration = box.style.transitionDuration;
                    var duration = Number(transitionDuration.replace('ms', '')); // The content should fade in after the backdrop has mostly filled the
                    // tooltip element. `clip-path` is the other alternative but is not
                    // well-supported and is buggy on some devices.
                    content.style.transitionDelay = Math.round(duration / 10) + "ms";
                    backdrop.style.transitionDuration = transitionDuration;
                    $122ea7d6880b82fb$var$setVisibilityState([
                        backdrop
                    ], 'visible');
                }
            },
            onShow: function onShow() {
                if (backdrop) backdrop.style.transitionDuration = '0ms';
            },
            onHide: function onHide() {
                if (backdrop) $122ea7d6880b82fb$var$setVisibilityState([
                    backdrop
                ], 'hidden');
            }
        };
    }
};
function $122ea7d6880b82fb$var$createBackdropElement() {
    var backdrop = $122ea7d6880b82fb$var$div();
    backdrop.className = $122ea7d6880b82fb$var$BACKDROP_CLASS;
    $122ea7d6880b82fb$var$setVisibilityState([
        backdrop
    ], 'hidden');
    return backdrop;
}
var $122ea7d6880b82fb$var$mouseCoords = {
    clientX: 0,
    clientY: 0
};
var $122ea7d6880b82fb$var$activeInstances = [];
function $122ea7d6880b82fb$var$storeMouseCoords(_ref) {
    var clientX = _ref.clientX, clientY = _ref.clientY;
    $122ea7d6880b82fb$var$mouseCoords = {
        clientX: clientX,
        clientY: clientY
    };
}
function $122ea7d6880b82fb$var$addMouseCoordsListener(doc) {
    doc.addEventListener('mousemove', $122ea7d6880b82fb$var$storeMouseCoords);
}
function $122ea7d6880b82fb$var$removeMouseCoordsListener(doc) {
    doc.removeEventListener('mousemove', $122ea7d6880b82fb$var$storeMouseCoords);
}
var $122ea7d6880b82fb$export$ac81526b64504ab6 = {
    name: 'followCursor',
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference;
        var doc = $122ea7d6880b82fb$var$getOwnerDocument(instance.props.triggerTarget || reference);
        var isInternalUpdate = false;
        var wasFocusEvent = false;
        var isUnmounted = true;
        var prevProps = instance.props;
        function getIsInitialBehavior() {
            return instance.props.followCursor === 'initial' && instance.state.isVisible;
        }
        function addListener() {
            doc.addEventListener('mousemove', onMouseMove);
        }
        function removeListener() {
            doc.removeEventListener('mousemove', onMouseMove);
        }
        function unsetGetReferenceClientRect() {
            isInternalUpdate = true;
            instance.setProps({
                getReferenceClientRect: null
            });
            isInternalUpdate = false;
        }
        function onMouseMove(event) {
            // If the instance is interactive, avoid updating the position unless it's
            // over the reference element
            var isCursorOverReference = event.target ? reference.contains(event.target) : true;
            var followCursor = instance.props.followCursor;
            var clientX = event.clientX, clientY = event.clientY;
            var rect = reference.getBoundingClientRect();
            var relativeX = clientX - rect.left;
            var relativeY = clientY - rect.top;
            if (isCursorOverReference || !instance.props.interactive) instance.setProps({
                // @ts-ignore - unneeded DOMRect properties
                getReferenceClientRect: function getReferenceClientRect() {
                    var rect = reference.getBoundingClientRect();
                    var x = clientX;
                    var y = clientY;
                    if (followCursor === 'initial') {
                        x = rect.left + relativeX;
                        y = rect.top + relativeY;
                    }
                    var top = followCursor === 'horizontal' ? rect.top : y;
                    var right = followCursor === 'vertical' ? rect.right : x;
                    var bottom = followCursor === 'horizontal' ? rect.bottom : y;
                    var left = followCursor === 'vertical' ? rect.left : x;
                    return {
                        width: right - left,
                        height: bottom - top,
                        top: top,
                        right: right,
                        bottom: bottom,
                        left: left
                    };
                }
            });
        }
        function create() {
            if (instance.props.followCursor) {
                $122ea7d6880b82fb$var$activeInstances.push({
                    instance: instance,
                    doc: doc
                });
                $122ea7d6880b82fb$var$addMouseCoordsListener(doc);
            }
        }
        function destroy() {
            $122ea7d6880b82fb$var$activeInstances = $122ea7d6880b82fb$var$activeInstances.filter(function(data) {
                return data.instance !== instance;
            });
            if ($122ea7d6880b82fb$var$activeInstances.filter(function(data) {
                return data.doc === doc;
            }).length === 0) $122ea7d6880b82fb$var$removeMouseCoordsListener(doc);
        }
        return {
            onCreate: create,
            onDestroy: destroy,
            onBeforeUpdate: function onBeforeUpdate() {
                prevProps = instance.props;
            },
            onAfterUpdate: function onAfterUpdate(_, _ref2) {
                var followCursor = _ref2.followCursor;
                if (isInternalUpdate) return;
                if (followCursor !== undefined && prevProps.followCursor !== followCursor) {
                    destroy();
                    if (followCursor) {
                        create();
                        if (instance.state.isMounted && !wasFocusEvent && !getIsInitialBehavior()) addListener();
                    } else {
                        removeListener();
                        unsetGetReferenceClientRect();
                    }
                }
            },
            onMount: function onMount() {
                if (instance.props.followCursor && !wasFocusEvent) {
                    if (isUnmounted) {
                        onMouseMove($122ea7d6880b82fb$var$mouseCoords);
                        isUnmounted = false;
                    }
                    if (!getIsInitialBehavior()) addListener();
                }
            },
            onTrigger: function onTrigger(_, event) {
                if ($122ea7d6880b82fb$var$isMouseEvent(event)) $122ea7d6880b82fb$var$mouseCoords = {
                    clientX: event.clientX,
                    clientY: event.clientY
                };
                wasFocusEvent = event.type === 'focus';
            },
            onHidden: function onHidden() {
                if (instance.props.followCursor) {
                    unsetGetReferenceClientRect();
                    removeListener();
                    isUnmounted = true;
                }
            }
        };
    }
};
function $122ea7d6880b82fb$var$getProps(props, modifier) {
    var _props$popperOptions;
    return {
        popperOptions: Object.assign({}, props.popperOptions, {
            modifiers: [].concat((((_props$popperOptions = props.popperOptions) == null ? void 0 : _props$popperOptions.modifiers) || []).filter(function(_ref) {
                var name = _ref.name;
                return name !== modifier.name;
            }), [
                modifier
            ])
        })
    };
}
var $122ea7d6880b82fb$export$e2b668424a9c728 = {
    name: 'inlinePositioning',
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference;
        function isEnabled() {
            return !!instance.props.inlinePositioning;
        }
        var placement;
        var cursorRectIndex = -1;
        var isInternalUpdate = false;
        var triedPlacements = [];
        var modifier = {
            name: 'tippyInlinePositioning',
            enabled: true,
            phase: 'afterWrite',
            fn: function fn(_ref2) {
                var state = _ref2.state;
                if (isEnabled()) {
                    if (triedPlacements.indexOf(state.placement) !== -1) triedPlacements = [];
                    if (placement !== state.placement && triedPlacements.indexOf(state.placement) === -1) {
                        triedPlacements.push(state.placement);
                        instance.setProps({
                            // @ts-ignore - unneeded DOMRect properties
                            getReferenceClientRect: function getReferenceClientRect() {
                                return _getReferenceClientRect(state.placement);
                            }
                        });
                    }
                    placement = state.placement;
                }
            }
        };
        function _getReferenceClientRect(placement) {
            return $122ea7d6880b82fb$var$getInlineBoundingClientRect($122ea7d6880b82fb$var$getBasePlacement(placement), reference.getBoundingClientRect(), $122ea7d6880b82fb$var$arrayFrom(reference.getClientRects()), cursorRectIndex);
        }
        function setInternalProps(partialProps) {
            isInternalUpdate = true;
            instance.setProps(partialProps);
            isInternalUpdate = false;
        }
        function addModifier() {
            if (!isInternalUpdate) setInternalProps($122ea7d6880b82fb$var$getProps(instance.props, modifier));
        }
        return {
            onCreate: addModifier,
            onAfterUpdate: addModifier,
            onTrigger: function onTrigger(_, event) {
                if ($122ea7d6880b82fb$var$isMouseEvent(event)) {
                    var rects = $122ea7d6880b82fb$var$arrayFrom(instance.reference.getClientRects());
                    var cursorRect = rects.find(function(rect) {
                        return rect.left - 2 <= event.clientX && rect.right + 2 >= event.clientX && rect.top - 2 <= event.clientY && rect.bottom + 2 >= event.clientY;
                    });
                    var index = rects.indexOf(cursorRect);
                    cursorRectIndex = index > -1 ? index : cursorRectIndex;
                }
            },
            onHidden: function onHidden() {
                cursorRectIndex = -1;
            }
        };
    }
};
function $122ea7d6880b82fb$var$getInlineBoundingClientRect(currentBasePlacement, boundingRect, clientRects, cursorRectIndex) {
    // Not an inline element, or placement is not yet known
    if (clientRects.length < 2 || currentBasePlacement === null) return boundingRect;
     // There are two rects and they are disjoined
    if (clientRects.length === 2 && cursorRectIndex >= 0 && clientRects[0].left > clientRects[1].right) return clientRects[cursorRectIndex] || boundingRect;
    switch(currentBasePlacement){
        case 'top':
        case 'bottom':
            var firstRect = clientRects[0];
            var lastRect = clientRects[clientRects.length - 1];
            var isTop = currentBasePlacement === 'top';
            var top = firstRect.top;
            var bottom = lastRect.bottom;
            var left = isTop ? firstRect.left : lastRect.left;
            var right = isTop ? firstRect.right : lastRect.right;
            var width = right - left;
            var height = bottom - top;
            return {
                top: top,
                bottom: bottom,
                left: left,
                right: right,
                width: width,
                height: height
            };
        case 'left':
        case 'right':
            var minLeft = Math.min.apply(Math, clientRects.map(function(rects) {
                return rects.left;
            }));
            var maxRight = Math.max.apply(Math, clientRects.map(function(rects) {
                return rects.right;
            }));
            var measureRects = clientRects.filter(function(rect) {
                return currentBasePlacement === 'left' ? rect.left === minLeft : rect.right === maxRight;
            });
            var _top = measureRects[0].top;
            var _bottom = measureRects[measureRects.length - 1].bottom;
            var _left = minLeft;
            var _right = maxRight;
            var _width = _right - _left;
            var _height = _bottom - _top;
            return {
                top: _top,
                bottom: _bottom,
                left: _left,
                right: _right,
                width: _width,
                height: _height
            };
        default:
            return boundingRect;
    }
}
var $122ea7d6880b82fb$export$4bd4b47501432316 = {
    name: 'sticky',
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference, popper = instance.popper;
        function getReference() {
            return instance.popperInstance ? instance.popperInstance.state.elements.reference : reference;
        }
        function shouldCheck(value) {
            return instance.props.sticky === true || instance.props.sticky === value;
        }
        var prevRefRect = null;
        var prevPopRect = null;
        function updatePosition() {
            var currentRefRect = shouldCheck('reference') ? getReference().getBoundingClientRect() : null;
            var currentPopRect = shouldCheck('popper') ? popper.getBoundingClientRect() : null;
            if (currentRefRect && $122ea7d6880b82fb$var$areRectsDifferent(prevRefRect, currentRefRect) || currentPopRect && $122ea7d6880b82fb$var$areRectsDifferent(prevPopRect, currentPopRect)) {
                if (instance.popperInstance) instance.popperInstance.update();
            }
            prevRefRect = currentRefRect;
            prevPopRect = currentPopRect;
            if (instance.state.isMounted) requestAnimationFrame(updatePosition);
        }
        return {
            onMount: function onMount() {
                if (instance.props.sticky) updatePosition();
            }
        };
    }
};
function $122ea7d6880b82fb$var$areRectsDifferent(rectA, rectB) {
    if (rectA && rectB) return rectA.top !== rectB.top || rectA.right !== rectB.right || rectA.bottom !== rectB.bottom || rectA.left !== rectB.left;
    return true;
}
$122ea7d6880b82fb$var$tippy.setDefaultProps({
    render: $122ea7d6880b82fb$var$render
});
var $122ea7d6880b82fb$export$2e2bcd8739ae039 = $122ea7d6880b82fb$var$tippy;









const $b1559aec03c93e07$var$$expand = document.getElementById('expand');
const $b1559aec03c93e07$var$$footer = document.getElementById('footer');
const $b1559aec03c93e07$var$$hiddenWords = document.getElementById('hidden-words');
const $b1559aec03c93e07$var$$hiddenWordsList = document.getElementById('hidden-words-list');
const $b1559aec03c93e07$var$$hint = document.getElementById('hint');
const $b1559aec03c93e07$var$$includeProfanity = document.getElementById('include-profanity');
const $b1559aec03c93e07$var$$includeSolution = document.getElementById('include-solution');
const $b1559aec03c93e07$var$$mode = document.getElementById('mode');
const $b1559aec03c93e07$var$$new = document.getElementById('new');
const $b1559aec03c93e07$var$$path = document.getElementById('path');
const $b1559aec03c93e07$var$$reset = document.getElementById('reset');
const $b1559aec03c93e07$var$$selection = document.getElementById('selection');
const $b1559aec03c93e07$var$$share = document.getElementById('share');
const $b1559aec03c93e07$var$$statistics = document.querySelector('#statistics > ul');
const $b1559aec03c93e07$var$$status = document.getElementById('status');
const $b1559aec03c93e07$var$$swaps = document.querySelector('#swaps > ul');
const $b1559aec03c93e07$var$$undo = document.getElementById('undo');
const $b1559aec03c93e07$var$$width = document.getElementById('width');
const $b1559aec03c93e07$var$$words = document.querySelector('#words > ul');
const $b1559aec03c93e07$var$confirm = window.confirm;
const $b1559aec03c93e07$var$crypto = window.crypto;
const $b1559aec03c93e07$var$tippy = (0, $122ea7d6880b82fb$export$2e2bcd8739ae039)($b1559aec03c93e07$var$$share, {
    content: 'Copied!',
    theme: 'custom',
    trigger: 'manual'
});
class $b1559aec03c93e07$export$985739bfa5723e08 {
    #configuration;
    #dictionary;
    #eventListeners = new (0, $7cd91973a7925acd$export$b20b719ec758a20f)({
        context: this
    });
    #grid;
    #state;
    constructor(){
        const overrides = [
            $b1559aec03c93e07$export$985739bfa5723e08.Params.DrawerExpanded
        ];
        const initialState = $b1559aec03c93e07$export$985739bfa5723e08.State.fromObject({
            version: $b1559aec03c93e07$export$985739bfa5723e08.State.Version
        });
        this.#state = new (0, $4c3397e7d04ad378$export$7254cc27399e90bd)($b1559aec03c93e07$export$985739bfa5723e08.CacheKey, initialState, {
            overrides: overrides
        });
        const state = this.#getState();
        if (state.version < $b1559aec03c93e07$export$985739bfa5723e08.State.Version) {
            console.warn(`Ignoring stale cache with version ${state.version}. Current version: ${$b1559aec03c93e07$export$985739bfa5723e08.State.Version}`);
            this.#state.set(initialState);
        }
        this.#dictionary = new (0, $7dbf3b60a5ee77ad$export$4ee70ab773570fb9)();
        const mode = this.#getMode();
        const width = this.#getWidth();
        this.#grid = new (0, $f3a1510773f18396$export$ef2184bd89960b14)(this.#dictionary, width, mode);
        this.#configuration = this.#grid.getConfiguration();
        const params = new URLSearchParams((0, $c5a0b96abcd6dbcd$export$128fa18b7194ef).search);
        params.set((0, $f3a1510773f18396$export$ef2184bd89960b14).Params.Id.key, $b1559aec03c93e07$var$crypto.randomUUID().split('-')[0]);
        $b1559aec03c93e07$var$$new.href = `?${params.toString()}`;
        params.set((0, $f3a1510773f18396$export$ef2184bd89960b14).Params.Id.key, this.#configuration.id);
        $b1559aec03c93e07$var$$path.href = `?${params.toString()}`;
        $b1559aec03c93e07$var$$path.textContent = this.#configuration.id;
        this.#eventListeners.add([
            {
                type: 'change',
                element: $b1559aec03c93e07$var$$includeProfanity,
                handler: this.#onIncludeProfanityChange
            },
            {
                type: 'change',
                element: $b1559aec03c93e07$var$$includeSolution,
                handler: this.#onIncludeSolutionChange
            },
            {
                type: 'change',
                element: $b1559aec03c93e07$var$$mode,
                handler: this.#onModeChange
            },
            {
                type: 'change',
                element: $b1559aec03c93e07$var$$width,
                handler: this.#onWidthChange
            },
            {
                type: 'click',
                element: $b1559aec03c93e07$var$$expand,
                handler: this.#onExpand
            },
            {
                type: 'click',
                element: $b1559aec03c93e07$var$$hint,
                handler: this.#onHint
            },
            {
                type: 'click',
                element: $b1559aec03c93e07$var$$reset,
                handler: this.reset
            },
            {
                type: 'click',
                element: $b1559aec03c93e07$var$$share,
                handler: this.share
            },
            {
                type: 'click',
                element: $b1559aec03c93e07$var$$swaps,
                handler: this.#deleteSwap
            },
            {
                type: 'click',
                element: $b1559aec03c93e07$var$$undo,
                handler: this.#onUndo
            },
            {
                type: 'click',
                element: $b1559aec03c93e07$var$$words,
                handler: this.#deleteWord
            },
            {
                type: (0, $f3a1510773f18396$export$ef2184bd89960b14).Events.Selection,
                handler: this.#updateSelection
            },
            {
                type: (0, $f3a1510773f18396$export$ef2184bd89960b14).Events.Update,
                handler: this.#onGridUpdate
            }
        ]);
        this.#updateDrawer();
        this.#updateModeSelector();
        this.#updateWidthSelector();
    }
    reset() {
        // Resolving in promise to prevent the Chrome 'Violation' warning in console
        return Promise.resolve().then(()=>{
            if (!$b1559aec03c93e07$var$confirm('Are you sure you want to reset the grid?')) return;
            this.#grid.reset();
            this.update();
        });
    }
    async setup() {
        // Load the base dictionary, and generate the grid from that
        await this.#dictionary.load((0, $7dbf3b60a5ee77ad$export$4ee70ab773570fb9).Sources.Default);
        this.#grid.setup();
        this.update();
        this.#updateHiddenWords();
        const state = this.#getState();
        // Note that additional dictionary sources are not used to generate the grid. They are only used for validation.
        const additionalSources = Array.from(new Set(this.#grid.getState().getSources().filter((source)=>source !== (0, $7dbf3b60a5ee77ad$export$4ee70ab773570fb9).Names.Default).concat(state.additionalSources)));
        for await (const source of additionalSources)await this.#dictionary.load((0, $7dbf3b60a5ee77ad$export$4ee70ab773570fb9).SourcesByName[source]);
    }
    async share() {
        const { id: id, mode: mode, width: width } = this.#configuration;
        const size = `${width}x${width}`;
        const gameState = this.#getState();
        const gridState = this.#grid.getState();
        const statistics = this.#grid.getStatistics(gridState);
        const content = [
            `Path#${id} | ${size}` + (mode === (0, $f3a1510773f18396$export$ef2184bd89960b14).Modes.Challenge ? ` | ${statistics.score}/${statistics.bestPossible}` : '')
        ];
        let moves = '';
        const lastMovesIndex = statistics.moves.length - 1;
        statistics.moves.forEach((move, index)=>{
            moves += move.getSymbol(mode);
            if (index !== lastMovesIndex && (index + 1) % width === 0) moves += '\n';
        });
        if (moves) content.push(moves);
        const sources = gridState.getSources();
        if (sources.length > 1) content.push(`Dictionary: ${sources.join(' + ')}`);
        content.push(gameState.shareUrl.get(gridState, this.#configuration));
        console.debug(content);
        await (0, $c5a0b96abcd6dbcd$export$e84ab21a5791681d)(content.join('\n'));
        $b1559aec03c93e07$var$tippy.show();
        setTimeout(()=>$b1559aec03c93e07$var$tippy.hide(), 1000);
    }
    update() {
        this.#updateHint();
        this.#updateStatus();
        this.#updateSwaps();
        this.#updateUndo();
        this.#updateWords();
    }
    #deleteSwap(event) {
        if (event.target.classList.contains($b1559aec03c93e07$export$985739bfa5723e08.ClassNames.Delete)) {
            this.#grid.removeSwap(event.target.dataset.index);
            this.update();
        }
    }
    #deleteWord(event) {
        if (event.target.classList.contains($b1559aec03c93e07$export$985739bfa5723e08.ClassNames.Delete)) {
            this.#grid.removeWord(event.target.dataset.index);
            this.update();
        }
    }
    #getMode() {
        return (0, $f3a1510773f18396$export$ef2184bd89960b14).Params.Mode.get() ?? (0, $f3a1510773f18396$export$ef2184bd89960b14).DefaultMode;
    }
    #getState() {
        return $b1559aec03c93e07$export$985739bfa5723e08.State.fromObject(this.#state.get());
    }
    #getWidth() {
        return (0, $c5a0b96abcd6dbcd$export$b1b145d64c7b5823)((0, $f3a1510773f18396$export$ef2184bd89960b14).Params.Width.get(), Number) ?? (0, $f3a1510773f18396$export$ef2184bd89960b14).DefaultWidth;
    }
    #onExpand() {
        this.#state.set($b1559aec03c93e07$export$985739bfa5723e08.Params.DrawerExpanded.key, !this.#state.get($b1559aec03c93e07$export$985739bfa5723e08.Params.DrawerExpanded.key));
        this.#updateDrawer();
    }
    #onGridUpdate() {
        this.update();
    }
    #onHint() {
        this.#grid.hint();
        this.#updateHint();
    }
    async #onIncludeProfanityChange(event) {
        const state = this.#getState();
        if (event.target.checked) {
            state.additionalSources = Array.from(new Set(state.additionalSources.concat([
                (0, $7dbf3b60a5ee77ad$export$4ee70ab773570fb9).Names.Profanity
            ])));
            await this.#dictionary.load((0, $7dbf3b60a5ee77ad$export$4ee70ab773570fb9).Sources.Profanity);
        } else {
            const index = state.additionalSources.findIndex((source)=>source === (0, $7dbf3b60a5ee77ad$export$4ee70ab773570fb9).Names.Profanity);
            state.additionalSources.splice(index, 1);
            this.#dictionary.unload((0, $7dbf3b60a5ee77ad$export$4ee70ab773570fb9).Names.Profanity);
        }
        this.#state.set(state);
    }
    #onIncludeSolutionChange(event) {
        const state = this.#getState();
        state.shareUrl = state.shareUrl.copy({
            solution: event.target.checked
        });
        this.#state.set(state);
    }
    #onUndo() {
        if (!$b1559aec03c93e07$var$$undo.classList.contains($b1559aec03c93e07$export$985739bfa5723e08.ClassNames.Disabled)) this.#grid.undo();
    }
    #onModeChange(event) {
        (0, $f3a1510773f18396$export$ef2184bd89960b14).Params.Mode.set(event.target.value);
        (0, $c5a0b96abcd6dbcd$export$32da5b5043dcd88c)();
    }
    #onWidthChange(event) {
        (0, $f3a1510773f18396$export$ef2184bd89960b14).Params.Width.set(event.target.value);
        (0, $c5a0b96abcd6dbcd$export$32da5b5043dcd88c)();
    }
    #updateDrawer() {
        const state = this.#getState();
        $b1559aec03c93e07$var$$footer.classList.toggle($b1559aec03c93e07$export$985739bfa5723e08.ClassNames.Expanded, state.drawerExpanded);
        $b1559aec03c93e07$var$$expand.textContent = state.drawerExpanded ? 'expand_less' : 'expand_more';
        $b1559aec03c93e07$var$$includeProfanity.checked = state.additionalSources.includes((0, $7dbf3b60a5ee77ad$export$4ee70ab773570fb9).Names.Profanity);
        $b1559aec03c93e07$var$$includeSolution.checked = state.shareUrl.solution;
    }
    #updateHiddenWords() {
        const isToday = this.#configuration.id === (0, $f3a1510773f18396$export$ef2184bd89960b14).DefaultId;
        if (isToday) {
            // For the current day, just display a link to the previous day's words
            const date = new Date();
            date.setDate(date.getDate() - 1);
            const previousId = (0, $c5a0b96abcd6dbcd$export$1f72301cb8058614)(date);
            const a = document.createElement('a');
            const params = new URLSearchParams((0, $c5a0b96abcd6dbcd$export$128fa18b7194ef).search);
            params.set((0, $f3a1510773f18396$export$ef2184bd89960b14).Params.Id.key, previousId);
            a.href = `?${params.toString()}#hidden-words`;
            a.target = '_blank';
            a.textContent = "Yesterday's Hidden Words";
            $b1559aec03c93e07$var$$hiddenWords.replaceChildren(a);
        } else {
            if ((0, $c5a0b96abcd6dbcd$export$128fa18b7194ef).hash.includes('hidden-words')) $b1559aec03c93e07$var$$hiddenWords.querySelector('details').setAttribute('open', '');
            const state = this.#grid.getState();
            state.configuration.words.forEach((word)=>{
                const li = document.createElement('li');
                const a = document.createElement('a');
                a.href = $b1559aec03c93e07$export$985739bfa5723e08.getWordUrl(word);
                a.target = '_blank';
                a.textContent = word.toString();
                a.title = 'See definition';
                li.append(a);
                $b1559aec03c93e07$var$$hiddenWordsList.append(li);
            });
        }
    }
    #updateHint() {
        $b1559aec03c93e07$var$$hint.classList.toggle($b1559aec03c93e07$export$985739bfa5723e08.ClassNames.Disabled, !this.#grid.hasHint());
    }
    #updateSelection() {
        this.#updateUndo();
        const selection = this.#grid.getSelection();
        $b1559aec03c93e07$var$$selection.replaceChildren();
        $b1559aec03c93e07$var$$selection.classList.remove($b1559aec03c93e07$export$985739bfa5723e08.ClassNames.WordValid);
        // Ignore cells marked for swap
        if (!selection.cells.filter((cell)=>!cell.getFlags().has((0, $28857821e2b8567e$export$f6f0c3fe4ec306ea).Flags.Swap)).length) // Nothing to do
        return;
        const $content = document.createElement('span');
        $content.textContent = selection.content;
        $content.classList.toggle($b1559aec03c93e07$export$985739bfa5723e08.ClassNames.WordValid, selection.isValidWord);
        const children = [
            $content
        ];
        if (selection.isValidWord) {
            const $info = document.createElement('span');
            $info.classList.add($b1559aec03c93e07$export$985739bfa5723e08.ClassNames.WordInfo);
            if (this.#configuration.mode === (0, $f3a1510773f18396$export$ef2184bd89960b14).Modes.Pathfinder) $info.textContent = (0, $c5a0b96abcd6dbcd$export$d4634d8e0b46181a)(selection.hiddenWordIndexes.length - selection.content.length);
            else {
                const configuration = this.#grid.getConfiguration();
                const move = new (0, $f3a1510773f18396$export$ef2184bd89960b14).Move((0, $f3a1510773f18396$export$ef2184bd89960b14).Move.Types.Spell, {
                    match: selection.match
                });
                const word = new (0, $282e11ce9af396b1$export$1ee6d718c47c2db0)(configuration.width, selection.cells, move);
                $info.textContent = word.points;
            }
            children.push($info);
        }
        $b1559aec03c93e07$var$$selection.replaceChildren(...children);
    }
    #updateStatus() {
        const statistics = this.#grid.getStatistics();
        const hiddenWords = `${statistics.hiddenWordsGuessed}/${statistics.hiddenWordCount}`;
        if (this.#configuration.mode === (0, $f3a1510773f18396$export$ef2184bd89960b14).Modes.Challenge) {
            $b1559aec03c93e07$var$$status.textContent = statistics.score;
            $b1559aec03c93e07$var$$statistics.replaceChildren(...[
                {
                    name: 'Progress',
                    value: `${statistics.progress}%`
                },
                {
                    name: 'Average Word Length',
                    value: statistics.averageWordLength
                },
                {
                    name: 'Hidden Words Found',
                    value: hiddenWords
                },
                {
                    name: 'Your Best Score',
                    value: `${statistics.best} (${statistics.bestDiff})`
                },
                {
                    name: 'Best Possible Score',
                    value: statistics.bestPossible
                }
            ].map((item)=>{
                const $content = document.createElement('span');
                $content.textContent = item.name;
                const $value = document.createElement('span');
                $value.textContent = item.value;
                return $b1559aec03c93e07$export$985739bfa5723e08.getListItem($content, $value);
            }));
        } else $b1559aec03c93e07$var$$status.textContent = hiddenWords;
    }
    #updateSwaps() {
        const swaps = this.#grid.getSwaps();
        // noinspection JSCheckFunctionSignatures
        $b1559aec03c93e07$var$$swaps.replaceChildren(...swaps.map((swap, index)=>{
            const $swap = document.createElement('span');
            $swap.classList.add($b1559aec03c93e07$export$985739bfa5723e08.ClassNames.Swap);
            $swap.textContent = `${swap.map((letter)=>letter.toUpperCase()).join(" \u2192 ")}`;
            return $b1559aec03c93e07$export$985739bfa5723e08.getListItem($swap, $b1559aec03c93e07$export$985739bfa5723e08.getDeleteElement(index));
        }));
    }
    #updateUndo() {
        const moves = this.#grid.getMoves().filter((move)=>move.type !== (0, $f3a1510773f18396$export$ef2184bd89960b14).Move.Types.Hint);
        const selection = this.#grid.getSelection();
        const disabled = moves.length === 0 && selection.length === 0;
        $b1559aec03c93e07$var$$undo.classList.toggle($b1559aec03c93e07$export$985739bfa5723e08.ClassNames.Disabled, disabled);
    }
    #updateModeSelector() {
        const mode = this.#getMode();
        $b1559aec03c93e07$var$$mode.replaceChildren(...Object.entries((0, $f3a1510773f18396$export$ef2184bd89960b14).Modes).map(([key, value])=>{
            const $option = document.createElement('option');
            $option.textContent = key;
            $option.value = value;
            if (value === mode) $option.selected = true;
            return $option;
        }));
    }
    #updateWidthSelector() {
        const width = this.#getWidth();
        $b1559aec03c93e07$var$$width.replaceChildren(...(0, $f3a1510773f18396$export$ef2184bd89960b14).Widths.map((value)=>{
            const $option = document.createElement('option');
            $option.textContent = `${value}x${value}`;
            $option.value = value.toString();
            if (value === width) $option.selected = true;
            return $option;
        }));
    }
    #updateWords() {
        const state = this.#grid.getState();
        const words = this.#grid.getWords(state).reverse();
        const length = words.length;
        const isPathfinderMode = this.#configuration.mode === (0, $f3a1510773f18396$export$ef2184bd89960b14).Modes.Pathfinder;
        $b1559aec03c93e07$var$$words.replaceChildren(...words.map((word, index)=>{
            const data = word.move.value;
            const $index = document.createElement('span');
            $index.textContent = `${length - index}.`;
            const $word = document.createElement('a');
            $word.classList.add($b1559aec03c93e07$export$985739bfa5723e08.ClassNames.Word, (0, $c5a0b96abcd6dbcd$export$307b18b61172f7ed)($b1559aec03c93e07$export$985739bfa5723e08.ClassNames.Word, 'match', data.match));
            $word.href = $b1559aec03c93e07$export$985739bfa5723e08.getWordUrl(word.content);
            $word.target = '_blank';
            $word.textContent = word.content;
            $word.title = 'See definition';
            const $info = document.createElement('span');
            $info.classList.add($b1559aec03c93e07$export$985739bfa5723e08.ClassNames.WordInfo);
            $info.textContent = isPathfinderMode ? (0, $c5a0b96abcd6dbcd$export$d4634d8e0b46181a)(state.configuration.words[data.hiddenWordIndex].length - word.content.length) : word.points;
            const $delete = isPathfinderMode ? undefined : $b1559aec03c93e07$export$985739bfa5723e08.getDeleteElement(index);
            return $b1559aec03c93e07$export$985739bfa5723e08.getListItem([
                $index,
                $word,
                $info
            ], $delete);
        }));
    }
    static getDeleteElement(index) {
        const $delete = document.createElement('span');
        $delete.classList.add($b1559aec03c93e07$export$985739bfa5723e08.ClassNames.Delete, $b1559aec03c93e07$export$985739bfa5723e08.ClassNames.Icon);
        $delete.dataset.index = index.toString();
        $delete.textContent = 'delete';
        $delete.title = 'Delete';
        return $delete;
    }
    static getListItem($left, $right) {
        const $li = document.createElement('li');
        const $container = document.createElement('div');
        $container.classList.add($b1559aec03c93e07$export$985739bfa5723e08.ClassNames.Container);
        $li.append($container);
        const $containerLeft = document.createElement('div');
        $containerLeft.classList.add($b1559aec03c93e07$export$985739bfa5723e08.ClassNames.FlexLeft);
        $containerLeft.append(...Array.isArray($left) ? $left : [
            $left
        ]);
        $container.append($containerLeft);
        if ($right !== undefined) {
            const $containerRight = document.createElement('div');
            $containerRight.classList.add($b1559aec03c93e07$export$985739bfa5723e08.ClassNames.FlexRight);
            $containerRight.append(...Array.isArray($right) ? $right : [
                $right
            ]);
            $container.append($containerRight);
        }
        return $li;
    }
    static getWordUrl(word) {
        return 'https://en.wiktionary.org/wiki/' + encodeURIComponent(word);
    }
    static CacheKey = 'game';
    static ClassNames = Object.freeze({
        Container: 'container',
        Delete: 'delete',
        Disabled: 'disabled',
        Expanded: 'expanded',
        FlexLeft: 'flex-left',
        FlexRight: 'flex-right',
        Icon: 'material-symbols-outlined',
        Share: 'share',
        Swap: 'swap',
        Word: 'word',
        WordInfo: 'word-info',
        WordValid: 'word-valid'
    });
    static Params = Object.freeze({
        DrawerExpanded: (0, $40d8a77a984c51a9$export$94affb487e701bf2).urlParams('drawerExpanded')
    });
    static State = class {
        additionalSources;
        drawerExpanded;
        shareUrl;
        version;
        constructor(drawerExpanded, shareUrl, additionalSources, version){
            this.drawerExpanded = drawerExpanded ?? false;
            this.shareUrl = shareUrl ?? new $b1559aec03c93e07$export$985739bfa5723e08.State.ShareUrl();
            this.additionalSources = additionalSources ?? [];
            this.version = version ?? 0;
        }
        static fromObject(obj) {
            return new $b1559aec03c93e07$export$985739bfa5723e08.State(obj.drawerExpanded, (0, $c5a0b96abcd6dbcd$export$b1b145d64c7b5823)(obj.shareUrl, $b1559aec03c93e07$export$985739bfa5723e08.State.ShareUrl.fromObject), obj.additionalSources, obj.version);
        }
        static ShareUrl = class {
            solution;
            constructor(solution){
                this.solution = solution ?? false;
            }
            copy(settings) {
                return new $b1559aec03c93e07$export$985739bfa5723e08.State.ShareUrl(settings.solution ?? this.solution);
            }
            get(state, configuration) {
                const url = (0, $c5a0b96abcd6dbcd$export$f654b28f82155665)();
                url.searchParams.set((0, $f3a1510773f18396$export$ef2184bd89960b14).Params.Id.key, configuration.id);
                url.searchParams.set((0, $f3a1510773f18396$export$ef2184bd89960b14).Params.Mode.key, configuration.mode);
                url.searchParams.set((0, $f3a1510773f18396$export$ef2184bd89960b14).Params.Width.key, configuration.width);
                if (this.solution) url.searchParams.set((0, $f3a1510773f18396$export$ef2184bd89960b14).Params.Solution.key, (0, $f3a1510773f18396$export$ef2184bd89960b14).Params.Solution.encode(state.solution));
                return url.toString();
            }
            static fromObject(obj) {
                return new $b1559aec03c93e07$export$985739bfa5723e08.State.ShareUrl(obj.solution);
            }
        };
        static Version = 1;
    };
}
if ((0, $c5a0b96abcd6dbcd$export$da1115b7645c376c).has((0, $f3a1510773f18396$export$ef2184bd89960b14).Params.Solution.key)) document.body.classList.add($b1559aec03c93e07$export$985739bfa5723e08.ClassNames.Share);


const $dd8a317325e1653d$var$$info = document.getElementById('info');
const $dd8a317325e1653d$var$$infoDialog = document.getElementById('info-dialog');
$dd8a317325e1653d$var$$info.addEventListener('click', ()=>{
    if (!$dd8a317325e1653d$var$$infoDialog.open) $dd8a317325e1653d$var$$infoDialog.showModal();
});
$dd8a317325e1653d$var$$infoDialog.addEventListener('click', (event)=>{
    if (event.target === $dd8a317325e1653d$var$$infoDialog) $dd8a317325e1653d$var$$infoDialog.close();
});


const $256b8f6946a9a926$var$id = 'G-44BJC1S0CM';
const $256b8f6946a9a926$var$script = document.createElement('script');
$256b8f6946a9a926$var$script.setAttribute('src', `https://www.googletagmanager.com/gtag/js?id=${$256b8f6946a9a926$var$id}`);
document.head.append($256b8f6946a9a926$var$script);
const $256b8f6946a9a926$var$dataLayer = window.dataLayer = window.dataLayer || [];
function $256b8f6946a9a926$var$gtag() {
    $256b8f6946a9a926$var$dataLayer.push(arguments);
}
$256b8f6946a9a926$var$gtag('js', new Date());
$256b8f6946a9a926$var$gtag('config', $256b8f6946a9a926$var$id);


const $b7ac0cf7b7632c81$var$game = new (0, $b1559aec03c93e07$export$985739bfa5723e08)();
$b7ac0cf7b7632c81$var$game.setup();
window.addEventListener('popstate', ()=>{
    // Handle user navigating through history
    window.location.reload();
});
window.debug = (0, $77e640c1aaab669f$export$1c9f709888824e05);
window.game = $b7ac0cf7b7632c81$var$game;


//# sourceMappingURL=paths.6ff1a41f.js.map
